import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { FaTimes, FaCheck, FaLock, FaPlus, FaTrash, FaChevronDown, FaChevronUp, FaHistory, FaUnlock, FaDollarSign, FaEye, FaClipboardCheck, FaStar, FaFileUpload, FaDrawPolygon, FaFileSignature, FaEdit, FaChartLine, FaDownload, FaFolder, FaFileAlt, FaBell, FaInfoCircle, FaSearch, FaUser, FaComment, FaComments, FaCog, FaFilePdf, FaUsers, FaUserShield, FaCalendarAlt, FaClock, FaCalendarTimes, FaSync, FaExternalLinkAlt, FaPaperPlane, FaReceipt } from "react-icons/fa";
import axios from 'axios';
import SignatureBoxEditor from '../../components/SignatureBoxEditor';
import DocumentsManager from "./DocumentsManager";


const ClientMenuModal = ({
  showMenu, setShowMenu, users = [], onlineUserIds = [], selectedMenuUser, setSelectedMenuUser, selectedStep, setSelectedStep,
  handleFormAssignment, handleMemberFormAssignment, handleStepSubmit, handleMemberStepSubmit,
  isStepSubmitted, isMemberStepSubmitted, canSubmitStep, canSubmitMemberStep,
  toggleServiceLock, toggleLoading, handleMemberNameUpdate, addMember, removeMember,
  handleUSAFormationStepSubmit, isUSAFormationStepSubmitted, canSubmitUSAFormationStep,
  handleCompanyFormAssignment, handleTaxDateUpdate, handleMemberTaxDateUpdate,
  handleAnnualReportServiceUpdate, handleRemoveAnnualReportService,
  handleSalesTaxServiceUpdate, handleRemoveSalesTaxService, handleSalesTaxStepStatusChange,
  handleBookkeepingServiceUpdate, handleRemoveBookkeepingService,
  handleRegisteredAgentDueDateUpdate,
  handleRegisteredAgentPaymentStatusUpdate,
  handleAnnualReportStepStatusChange,
  handleReopenAnnualReportChecklist,
  handleRegisteredAgentDocumentUpload, handleRegisteredAgentDocumentDelete,
  handleMoveToHistory, handleUnlockTaxFiling, handleUnlockAnnualReport, handleAnnualReportPaymentStatusUpdate, handleUpdateTaxFilingUnlockPrice,
  handleUpdateTaxSummaryTable, handleOpenStep1Checklist,
  handleOpenStep3CustomTable, handleViewStep3Submission, getStep3Status, userSteps, refreshUserSteps,
  handleHistoryTaxDateUpdate,
  onQuickPayment, onChatClick, onExportData, onAnnualReportClick,
  activeTab, setActiveTab, chatUser, setChatUser,
  initialMemberIndex,
  onToggleVerify,
  onUserUpdated
}) => {
  const navigate = useNavigate();
  const [switcherSearch, setSwitcherSearch] = useState("");
  const [taxFilingSubTab, setTaxFilingSubTab] = useState("primary-member");
  const [memberToDeleteModal, setMemberToDeleteModal] = useState(null);
  const [isDeletingMember, setIsDeletingMember] = useState(false);
  const [clearDatesModal, setClearDatesModal] = useState(null);
  const [isClearingDates, setIsClearingDates] = useState(false);

  const [isEditingProfile, setIsEditingProfile] = useState(false);
  const [profileEditData, setProfileEditData] = useState({
    name: "",
    email: "",
    organization: "",
    address: "",
    dateOfBirth: ""
  });
  const [isSavingProfile, setIsSavingProfile] = useState(false);
  const [showProfilePicLightbox, setShowProfilePicLightbox] = useState(false);

  useEffect(() => {
    if (selectedMenuUser) {
      setProfileEditData({
        name: selectedMenuUser.name || "",
        email: selectedMenuUser.email || "",
        organization: selectedMenuUser.organization || "",
        address: selectedMenuUser.address || "",
        dateOfBirth: selectedMenuUser.dateOfBirth ? new Date(selectedMenuUser.dateOfBirth).toISOString().split("T")[0] : ""
      });
      setIsEditingProfile(false);
    }
  }, [selectedMenuUser]);

  const handleSaveProfile = async () => {
    if (!profileEditData.name.trim()) {
      alert("Name is required");
      return;
    }
    if (!profileEditData.email.trim()) {
      alert("Email is required");
      return;
    }
    setIsSavingProfile(true);
    try {
      const token = localStorage.getItem("adminToken");
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/users/${selectedMenuUser._id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(profileEditData)
      });
      if (!response.ok) {
        let errMessage = "Failed to update profile";
        try {
          const errData = await response.json();
          if (errData.message) errMessage = errData.message;
        } catch (e) {}
        throw new Error(errMessage);
      }
      const data = await response.json();
      setSelectedMenuUser(data.user);
      if (onUserUpdated) {
        onUserUpdated(data.user);
      }
      setIsEditingProfile(false);
      alert("Profile updated successfully!");
    } catch (error) {
      console.error("Error updating profile:", error);
      alert(error.message);
    } finally {
      setIsSavingProfile(false);
    }
  };

  const formLabelClass = "block text-[10px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1.5";
  const formSelectClass = "w-full px-3 py-2.5 text-sm bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white shadow-sm focus:ring-2 focus:ring-primary-500/25 focus:border-primary-500 outline-none transition-all cursor-pointer";
  const formCardClass = "p-4 bg-white dark:bg-dark-800/60 rounded-xl border border-gray-200 dark:border-dark-600 shadow-sm";

  const handlePrimaryFormAssign = () => {
    const formNumber = selectedMenuUser?.assignedForm || "1040";
    if (!window.confirm(`Assign form ${formNumber} to this primary member?\n\nClick OK to confirm or Cancel to go back.`)) return;
    handleFormAssignment(selectedMenuUser._id, formNumber);
  };

  const handleMemberFormAssignConfirm = () => {
    const formNumber = selectedMenuUser.members[activeMemberIndex]?.assignedForm || "1040";
    const memberName = selectedMenuUser.members[activeMemberIndex]?.name || `Member ${activeMemberIndex + 1}`;
    if (!window.confirm(`Assign form ${formNumber} to ${memberName}?\n\nClick OK to confirm or Cancel to go back.`)) return;
    handleMemberFormAssignment(selectedMenuUser._id, activeMemberIndex, formNumber);
  };

  const handleClientSwitch = (user) => {
    setSelectedMenuUser(user);
    setTaxFilingSubTab("primary-member");
    if (chatUser) {
      setChatUser(user);
    }
  };

  const handleMemberSwitch = (user, memberIndex) => {
    setSelectedMenuUser(user);
    setActiveMemberIndex(memberIndex);
    setTaxFilingSubTab("member");
    if (chatUser) {
      setChatUser(user);
    }
  };

  const [sidebarWidth, setSidebarWidth] = useState(1100);
  const [isResizing, setIsResizing] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isResizing) return;
      const newWidth = window.innerWidth - e.clientX;
      if (newWidth > 600 && newWidth < window.innerWidth * 0.95) {
        setSidebarWidth(newWidth);
      }
    };

    const handleMouseUp = () => {
      setIsResizing(false);
      document.body.style.cursor = 'default';
      document.body.style.userSelect = 'auto';
    };

    if (isResizing) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizing]);

  const [newMemberName, setNewMemberName] = useState("");
  const [activeMemberAccordion, setActiveMemberAccordion] = useState(null);
  const [activeMemberIndex, setActiveMemberIndex] = useState(0);

  useEffect(() => {
    if (showMenu) {
      if (initialMemberIndex !== undefined && initialMemberIndex !== null && initialMemberIndex >= 0) {
        setActiveMemberIndex(initialMemberIndex);
        setTaxFilingSubTab("member");
      } else if (initialMemberIndex === -1) {
        setTaxFilingSubTab("primary-member");
      }
    }
  }, [showMenu, initialMemberIndex]);
  const [primaryTaxYearEndDate, setPrimaryTaxYearEndDate] = useState("");
  const [primaryDueDate, setPrimaryDueDate] = useState("");
  const [memberTaxYearEndDates, setMemberTaxYearEndDates] = useState({});
  const [memberDueDates, setMemberDueDates] = useState({});

  // Annual Report Service states
  const [annualReportState, setAnnualReportState] = useState("");
  const [annualReportEntityType, setAnnualReportEntityType] = useState("");
  const [annualReportRegistrationDate, setAnnualReportRegistrationDate] = useState("");
  const [annualReportYearsToAdd, setAnnualReportYearsToAdd] = useState("");
  const [showEntityTypeSelect, setShowEntityTypeSelect] = useState(false);
  const [isSavingAnnualReportDueDate, setIsSavingAnnualReportDueDate] = useState(false);

  // Sales Tax Service states
  const [salesTaxState, setSalesTaxState] = useState("");
  const [salesTaxEntityType, setSalesTaxEntityType] = useState("");
  const [salesTaxRegistrationDate, setSalesTaxRegistrationDate] = useState("");
  const [salesTaxFrequency, setSalesTaxFrequency] = useState("Quarterly");
  const [salesTaxPeriod, setSalesTaxPeriod] = useState("");
  const [salesTaxFilingYear, setSalesTaxFilingYear] = useState("");
  const [salesTaxCustomDueDate, setSalesTaxCustomDueDate] = useState("");
  const [isSavingSalesTaxDueDate, setIsSavingSalesTaxDueDate] = useState(false);

  // Registered Agent Service states (supports up to 2 states/due dates)
  const ANNUAL_REPORT_STATES = ['Delaware', 'Wyoming', 'New Jersey', 'Florida', 'Pennsylvania', 'Washington'];
  const [registeredAgentState1, setRegisteredAgentState1] = useState("");
  const [registeredAgentDueDate1, setRegisteredAgentDueDate1] = useState("");
  const [registeredAgentState2, setRegisteredAgentState2] = useState("");
  const [registeredAgentDueDate2, setRegisteredAgentDueDate2] = useState("");
  const [registeredAgentUploading, setRegisteredAgentUploading] = useState(false);
  const [manualReminderLoading, setManualReminderLoading] = useState(false);
  const [manualReminderLoading1, setManualReminderLoading1] = useState(false);
  const [manualReminderLoading2, setManualReminderLoading2] = useState(false);
  const [manualBookkeepingReminderLoading, setManualBookkeepingReminderLoading] = useState(false);
  const [manualSalesTaxReminderLoading, setManualSalesTaxReminderLoading] = useState(false);
  const [toggleReminderLoading, setToggleReminderLoading] = useState(false);
  const [raPaymentHistory, setRaPaymentHistory] = useState([]);

  useEffect(() => {
    if (selectedMenuUser) {
      setRegisteredAgentState1(selectedMenuUser?.registeredAgentService?.state || "");
      setRegisteredAgentDueDate1(formatDateForInput(selectedMenuUser?.registeredAgentService?.dueDate));
      setRegisteredAgentState2(selectedMenuUser?.registeredAgentService?.state2 || "");
      setRegisteredAgentDueDate2(formatDateForInput(selectedMenuUser?.registeredAgentService?.dueDate2));

      if (selectedMenuUser._id) {
        const fetchRaPayments = async () => {
          try {
            const token = localStorage.getItem("adminToken");
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/payment/user-payments/${selectedMenuUser._id}`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            if (res.ok) {
              const data = await res.json();
              setRaPaymentHistory((data || []).filter(p => p.service === 'Registered Agent'));
            }
          } catch (e) {
            console.error("Error fetching Registered Agent payment history:", e);
          }
        };
        fetchRaPayments();
      }
    }
  }, [selectedMenuUser]);

  // Bookkeeping Service states
  const [bookkeepingFrequency, setBookkeepingFrequency] = useState("");
  const [bookkeepingStartDate, setBookkeepingStartDate] = useState("");
  const bookkeepingDatePickerRef = useRef(null);
  const [isSavingBookkeepingDueDate, setIsSavingBookkeepingDueDate] = useState(false);
  const [updatingBookkeepingStep, setUpdatingBookkeepingStep] = useState({});
  const [updatingTaxFilingStep, setUpdatingTaxFilingStep] = useState({});
  const [updatingUSAFormationStep, setUpdatingUSAFormationStep] = useState({});
  const [showBookkeepingQueriesModal, setShowBookkeepingQueriesModal] = useState(false);
  const [bookkeepingQueries, setBookkeepingQueries] = useState([]);
  const [savingBookkeepingQueries, setSavingBookkeepingQueries] = useState(false);
  const [bookkeepingCollaborators, setBookkeepingCollaborators] = useState([]);
  const [emailSchedule, setEmailSchedule] = useState({
    scheduleType: 'immediate',
    scheduledDate: '',
    scheduledTime: '09:00',
    dayOfWeek: 'Monday'
  });
  const [showScheduleModal, setShowScheduleModal] = useState(false);


  // Bookkeeping Step 3 states
  const [step3Files, setStep3Files] = useState([]);
  const handleRemoveFile = (index) => {
    setStep3Files(prev => prev.filter((_, i) => i !== index));
  };
  const [step3Question, setStep3Question] = useState("");
  const [step3Questions, setStep3Questions] = useState([
    { questionText: "Do you approve of these draft financial statements to proceed to filing?", options: [] }
  ]);
  const [newOptionTexts, setNewOptionTexts] = useState({});
  const [step3Uploading, setStep3Uploading] = useState(false);
  const [showStep3Modal, setShowStep3Modal] = useState(false);
  const [editStep3HistoryIndex, setEditStep3HistoryIndex] = useState(null);

  const handleAddQuestion = () => {
    setStep3Questions([
      ...step3Questions,
      { questionText: "", options: [] }
    ]);
  };

  const handleRemoveQuestion = (index) => {
    if (step3Questions.length === 1) {
      alert("At least one question is required.");
      return;
    }
    setStep3Questions(step3Questions.filter((_, idx) => idx !== index));
  };

  const handleQuestionTextChange = (index, value) => {
    const updated = [...step3Questions];
    updated[index].questionText = value;
    setStep3Questions(updated);
  };

  const handleAddOption = (qIndex) => {
    const optText = (newOptionTexts[qIndex] || "").trim();
    if (!optText) return;
    const updated = [...step3Questions];
    if (updated[qIndex].options.includes(optText)) {
      alert("This option already exists.");
      return;
    }
    updated[qIndex].options.push(optText);
    setStep3Questions(updated);
    setNewOptionTexts({ ...newOptionTexts, [qIndex]: "" });
  };

  const handleRemoveOption = (qIndex, optIndex) => {
    const updated = [...step3Questions];
    updated[qIndex].options = updated[qIndex].options.filter((_, idx) => idx !== optIndex);
    setStep3Questions(updated);
  };

  // Helper functions for Date input format conversion (MM/DD/YYYY <-> YYYY-MM-DD)
  const convertToISODate = (dateStr) => {
    if (!dateStr) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
    const parts = dateStr.split("/");
    if (parts.length === 3) {
      const [m, d, y] = parts;
      if (m && d && y && y.length === 4) {
        return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
      }
    }
    return "";
  };

  const convertToUSDate = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    if (parts.length === 3) {
      const [y, m, d] = parts;
      if (y && m && d && y.length === 4) {
        return `${m}/${d}/${y}`;
      }
    }
    return dateStr;
  };

  const handleAddQueryRow = () => {
    const nextSrNo = bookkeepingQueries.length + 1;
    const todayFormatted = new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    setBookkeepingQueries([
      ...bookkeepingQueries,
      { srNo: nextSrNo.toString(), date: todayFormatted, accountName: "", description: "", amount: "", bookscomplyComment: "", clientComment: "", assignedEmail: selectedMenuUser?.email || "" }
    ]);
  };

  const handleRemoveQueryRow = (index) => {
    const updated = bookkeepingQueries.filter((_, idx) => idx !== index).map((q, idx) => ({
      ...q,
      srNo: (idx + 1).toString()
    }));
    setBookkeepingQueries(updated);
  };

  const handleQueryCellChange = (index, field, value) => {
    const updated = [...bookkeepingQueries];
    updated[index][field] = value;
    setBookkeepingQueries(updated);
  };

  const handleSaveBookkeepingQueries = async (status = null) => {
    setSavingBookkeepingQueries(status || 'draft');
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL || (typeof API_BASE !== 'undefined' ? API_BASE : '')}/api/bookkeeping/${selectedMenuUser._id}/queries`,
        { queries: bookkeepingQueries, status, emailSchedule },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      if (response.data?.user) {
        setSelectedMenuUser(response.data.user);
      }
      
      alert(
        status === 'client-pending' 
          ? (emailSchedule.scheduleType === 'immediate'
              ? "Queries submitted to client successfully! Email sent."
              : `Queries submitted to client! Email scheduled (${emailSchedule.scheduleType}).`)
          : status === 'completed'
            ? "Step 2 submitted and completed successfully!"
            : "Queries draft saved successfully!"
      );
      setShowBookkeepingQueriesModal(false);
    } catch (error) {
      console.error("Error saving bookkeeping queries:", error);
      alert(error.response?.data?.message || "Failed to save queries.");
    } finally {
      setSavingBookkeepingQueries(false);
    }
  };

  const handleDeleteDraftHistory = async (originalIdx) => {
    if (!window.confirm("Are you sure you want to delete this draft history entry?")) return;
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL || (typeof API_BASE !== 'undefined' ? API_BASE : '')}/api/bookkeeping/${selectedMenuUser._id}/step3/history/${originalIdx}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data?.user) {
        setSelectedMenuUser(response.data.user);
      }
      alert("Draft history deleted successfully!");
    } catch (error) {
      console.error("Error deleting draft history:", error);
      alert(error.response?.data?.message || "Failed to delete history.");
    }
  };

  const handleEditDraftHistory = (originalIdx) => {
    const historyEntry = selectedMenuUser.bookkeepingStep3History[originalIdx];
    if (!historyEntry) return;
    
    setStep3Questions(historyEntry.questions && historyEntry.questions.length > 0 ? historyEntry.questions : [{ questionText: historyEntry.question || "", options: [] }]);
    setEditStep3HistoryIndex(originalIdx);
    
    // Scroll to top or show modal depending on layout
    const step3Form = document.getElementById("publish-new-revision-form");
    if (step3Form) step3Form.scrollIntoView({ behavior: 'smooth' });
  };

  const handleUpdateBookkeepingStepStatus = async (stepNumber, status) => {
    setUpdatingBookkeepingStep(prev => ({ ...prev, [stepNumber]: true }));
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL || (typeof API_BASE !== 'undefined' ? API_BASE : '')}/api/bookkeeping/${selectedMenuUser._id}/step`, 
        { stepNumber, status },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Update selectedMenuUser state locally
      if (response.data?.user) {
        setSelectedMenuUser(response.data.user);
      } else {
        const updatedSteps = [...(selectedMenuUser.bookkeepingSteps || [])];
        const stepIdx = updatedSteps.findIndex(s => s.step === stepNumber);
        if (stepIdx !== -1) {
          updatedSteps[stepIdx].status = status;
        } else {
          updatedSteps.push({ step: stepNumber, status });
        }
        setSelectedMenuUser({ ...selectedMenuUser, bookkeepingSteps: updatedSteps });
      }
      
      alert(`Step ${stepNumber} status updated to ${status} successfully!`);
    } catch (error) {
      console.error("Error updating bookkeeping step status:", error);
      alert(error.response?.data?.message || "Failed to update bookkeeping step status.");
    } finally {
      setUpdatingBookkeepingStep(prev => ({ ...prev, [stepNumber]: false }));
    }
  };

  const DEFAULT_TAX_FILING_STEPS = [
    { step: 1, title: 'Initial Information Required', status: 'in-progress' },
    { step: 2, title: 'Tax Return Preparation', status: 'pending' },
    { step: 3, title: 'Draft Tax Return', status: 'pending' },
    { step: 4, title: 'Tax Filing', status: 'pending' },
  ];

  const getTaxFilingStepsList = (memberIndex = -1) => {
    const raw = memberIndex >= 0
      ? userSteps[selectedMenuUser?._id]?.memberSteps?.[memberIndex]
      : userSteps[selectedMenuUser?._id]?.steps;
    if (!raw?.length) return DEFAULT_TAX_FILING_STEPS;
    return DEFAULT_TAX_FILING_STEPS.map((ds) => {
      const existing = raw.find((s) => s.step === ds.step);
      return existing ? { ...ds, ...existing, title: existing.title || ds.title } : ds;
    });
  };

  const formatTaxFilingStatusLabel = (status) => {
    if (status === 'in-progress') return 'IN PROGRESS';
    if (status === 'client-pending') return 'CLIENT PENDING';
    if (status === 'submitted') return 'COMPLETED';
    return 'PENDING';
  };

  const DEFAULT_USA_FORMATION_STEPS = [
    { step: 1, title: 'Company formation checklist', status: 'in-progress' },
    { step: 2, title: 'Post Formation documents', status: 'pending' },
    { step: 3, title: 'Tax ID (EIN)', status: 'pending' },
  ];

  const getUSAFormationStepsList = () => {
    const raw = selectedMenuUser?.companySteps;
    if (!raw?.length) return DEFAULT_USA_FORMATION_STEPS;
    const plainSteps = raw.map((step) => (
      typeof step.toObject === 'function' ? step.toObject() : step
    ));
    return DEFAULT_USA_FORMATION_STEPS.map((ds) => {
      const existing = plainSteps.find((s) => s.step === ds.step);
      return existing
        ? { ...ds, ...existing, title: existing.title || ds.title, status: existing.status || ds.status }
        : ds;
    });
  };

  const formatUSAFormationStatusLabel = (status) => {
    if (status === 'in-progress') return 'IN PROGRESS';
    if (status === 'submitted') return 'COMPLETED';
    return 'PENDING';
  };

  const handleUpdateUSAFormationStepStatus = async (stepNumber, status) => {
    setUpdatingUSAFormationStep((prev) => ({ ...prev, [stepNumber]: true }));
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/usa-company-formation/admin/update-step-status`,
        {
          userId: selectedMenuUser._id,
          stepNumber,
          status,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data?.user) {
        setSelectedMenuUser(response.data.user);
      }
    } catch (error) {
      console.error('Error updating USA formation step status:', error);
      alert(error.response?.data?.message || 'Failed to update USA formation step status.');
    } finally {
      setUpdatingUSAFormationStep((prev) => ({ ...prev, [stepNumber]: false }));
    }
  };

  const handleUpdateTaxFilingStepStatus = async (stepNumber, status, memberIndex = -1) => {
    const key = `${memberIndex}-${stepNumber}`;
    setUpdatingTaxFilingStep((prev) => ({ ...prev, [key]: true }));
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/update-tax-filing-step-status`,
        {
          userId: selectedMenuUser._id,
          stepNumber,
          status,
          ...(memberIndex >= 0 ? { memberIndex } : {}),
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data?.user) {
        setSelectedMenuUser(response.data.user);
      }
      if (refreshUserSteps) {
        await refreshUserSteps(selectedMenuUser._id);
      }
    } catch (error) {
      console.error('Error updating tax filing step status:', error);
      alert(error.response?.data?.message || 'Failed to update tax filing step status.');
    } finally {
      setUpdatingTaxFilingStep((prev) => ({ ...prev, [key]: false }));
    }
  };

  const renderTaxFilingStepsStatus = (memberIndex = -1) => {
    const stepsList = getTaxFilingStepsList(memberIndex);
    const hasForm = memberIndex >= 0
      ? selectedMenuUser?.members?.[memberIndex]?.assignedForm
      : selectedMenuUser?.assignedForm;

    return (
      <div className="pt-6 border-t border-gray-100 dark:border-dark-700">
        <h5 className="font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
          <FaChartLine className="text-primary-500" /> Tax Filing Steps Status
          {memberIndex >= 0 && (
            <span className="text-xs font-normal text-gray-500">
              — {selectedMenuUser?.members?.[memberIndex]?.name || `Member ${memberIndex + 1}`}
            </span>
          )}
        </h5>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {stepsList.map((step) => {
            const updateKey = `${memberIndex}-${step.step}`;
            const isUpdating = updatingTaxFilingStep[updateKey];
            const step3Status = getStep3Status?.(selectedMenuUser._id, memberIndex);

            return (
              <div
                key={step.step}
                className={`p-4 rounded-xl border-2 transition-all ${
                  step.status === 'submitted'
                    ? 'bg-blue-50/50 dark:bg-blue-900/10 border-blue-200 dark:border-blue-800'
                    : step.status === 'in-progress'
                    ? 'bg-amber-50/50 dark:bg-amber-900/10 border-amber-200 dark:border-amber-800'
                    : step.status === 'client-pending'
                    ? 'bg-purple-50/50 dark:bg-purple-900/10 border-purple-200 dark:border-purple-800'
                    : 'bg-gray-50/50 dark:bg-dark-900/50 border-gray-200 dark:border-dark-700'
                }`}
              >
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[10px] font-bold text-gray-400 uppercase">Step {step.step}</span>
                  <span className={`px-2 py-0.5 text-[9px] font-black rounded-full uppercase tracking-wider ${
                    step.status === 'submitted'
                      ? 'bg-blue-500 text-white'
                      : step.status === 'in-progress'
                      ? 'bg-amber-500 text-white'
                      : step.status === 'client-pending'
                      ? 'bg-purple-500 text-white'
                      : 'bg-gray-500 text-white'
                  }`}>
                    {formatTaxFilingStatusLabel(step.status)}
                  </span>
                </div>

                <h6 className="font-bold text-gray-900 dark:text-white text-xs mb-1.5">{step.title}</h6>

                <div className="relative mt-3">
                  <label className="block text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase mb-1">
                    Update Status
                  </label>
                  <div className="relative">
                    <select
                      value={step.status || 'pending'}
                      onChange={(e) => handleUpdateTaxFilingStepStatus(step.step, e.target.value, memberIndex)}
                      disabled={isUpdating}
                      className="w-full pl-3 pr-8 py-2 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-xs font-semibold text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 outline-none transition-all appearance-none cursor-pointer"
                    >
                      <option value="pending">Pending</option>
                      <option value="in-progress">In Progress</option>
                      {step.step >= 3 && (
                        <option value="client-pending">Client Action Pending</option>
                      )}
                      <option value="submitted">Submitted / Completed</option>
                    </select>
                    <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
                      {isUpdating ? (
                        <div className="w-3.5 h-3.5 border-2 border-primary-600 border-t-transparent rounded-full animate-spin" />
                      ) : (
                        <FaChevronDown className="w-2.5 h-2.5" />
                      )}
                    </div>
                  </div>
                </div>

                {step.step === 1 && hasForm && (
                  <button
                    type="button"
                    onClick={() => handleOpenStep1Checklist && handleOpenStep1Checklist(selectedMenuUser, memberIndex)}
                    className="w-full mt-3 py-1.5 bg-indigo-600 hover:bg-indigo-700 text-white text-[10px] font-bold rounded-lg transition-all flex items-center justify-center gap-1.5"
                  >
                    <FaEye className="w-3 h-3" /> Preview / Edit Step 1 Checklist
                  </button>
                )}

                {step.step === 1 && step.status === 'submitted' && (
                  <button
                    type="button"
                    onClick={() => handleUpdateTaxFilingStepStatus(1, 'in-progress', memberIndex)}
                    disabled={isUpdating}
                    className="w-full mt-2 py-1.5 bg-amber-100 hover:bg-amber-200 text-amber-700 text-[10px] font-bold rounded-lg transition-all flex items-center justify-center gap-1.5"
                  >
                    <FaUnlock className="w-3 h-3" /> Re-open Step 1
                  </button>
                )}

                {step.step === 3 && hasForm && getStep3Status && (
                  <div className="mt-3 space-y-2 pt-3 border-t border-gray-200/50 dark:border-dark-700/50">
                    {step3Status === 'in-progress' && (
                      <button
                        type="button"
                        onClick={() => handleOpenStep3CustomTable && handleOpenStep3CustomTable(selectedMenuUser, memberIndex)}
                        className="w-full py-2 bg-orange-600 hover:bg-orange-700 text-white text-[10px] font-bold rounded-lg transition-all"
                      >
                        Create Custom Table & Submit to Client
                      </button>
                    )}
                    {step3Status === 'client-pending' && (
                      <>
                        <button
                          type="button"
                          onClick={() => handleOpenStep3CustomTable && handleOpenStep3CustomTable(selectedMenuUser, memberIndex, { isEdit: true })}
                          className="w-full py-2 bg-primary-600 hover:bg-primary-700 text-white text-[10px] font-bold rounded-lg transition-all"
                        >
                          Edit Table
                        </button>
                        <button
                          type="button"
                          onClick={() => handleViewStep3Submission && handleViewStep3Submission(selectedMenuUser, memberIndex)}
                          className="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white text-[10px] font-bold rounded-lg transition-all"
                        >
                          View Submission
                        </button>
                      </>
                    )}
                    {step3Status === 'submitted' && (
                      <button
                        type="button"
                        onClick={() => handleViewStep3Submission && handleViewStep3Submission(selectedMenuUser, memberIndex)}
                        className="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white text-[10px] font-bold rounded-lg transition-all"
                      >
                        View Submission
                      </button>
                    )}
                    {(step.status === 'submitted' || step.status === 'client-pending') && (
                      <button
                        type="button"
                        onClick={() => {
                          if (window.confirm('Reopen Step 3? This resets Step 4 to pending and allows a new draft cycle.')) {
                            handleUpdateTaxFilingStepStatus(3, 'in-progress', memberIndex);
                          }
                        }}
                        disabled={isUpdating}
                        className="w-full py-2 bg-amber-50 hover:bg-amber-100 dark:bg-amber-950/20 text-amber-700 dark:text-amber-400 text-[10px] font-bold rounded-lg transition-all flex items-center justify-center gap-1.5 border border-amber-200 dark:border-amber-900/30"
                      >
                        <FaUnlock className="w-3 h-3" /> Reopen Step 3
                      </button>
                    )}
                  </div>
                )}

                {step.step === 4 && step.status === 'client-pending' && (
                  <p className="mt-3 text-[10px] text-purple-600 dark:text-purple-400 italic">
                    Waiting for client signature on uploaded document.
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const handleUploadStep3Documents = async () => {
    if ((!step3Files || step3Files.length === 0) && editStep3HistoryIndex === null) {
      alert("Please select at least one document to upload.");
      return;
    }
    const hasEmptyText = step3Questions.some(q => !q.questionText.trim());
    if (hasEmptyText) {
      alert("Please provide text for all questions.");
      return;
    }
    setStep3Uploading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const formData = new FormData();
      for (let i = 0; i < step3Files.length; i++) {
        formData.append('files', step3Files[i]);
      }
      formData.append('question', step3Questions[0]?.questionText || "");
      formData.append('questions', JSON.stringify(step3Questions));
      if (editStep3HistoryIndex !== null) {
        formData.append('editIndex', editStep3HistoryIndex);
      }

      const res = await axios.post(
        `${API_BASE}/api/bookkeeping/${selectedMenuUser._id}/step3/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      if (res.data?.user) {
        setSelectedMenuUser(res.data.user);
      }
      alert(`Draft financial document(s) and questions ${editStep3HistoryIndex !== null ? 'updated' : 'published'} successfully!`);
      setStep3Files([]);
      setEditStep3HistoryIndex(null);
      setStep3Question("");
      setStep3Questions([
        { questionText: "Do you approve of these draft financial statements to proceed to filing?", options: [] }
      ]);
      setNewOptionTexts({});
      
      // Reset file input elements
      const fileInput = document.getElementById("step3-file-input");
      if (fileInput) fileInput.value = "";
      const modalFileInput = document.getElementById("step3-modal-file-input");
      if (modalFileInput) modalFileInput.value = "";
    } catch (err) {
      console.error("Error uploading step 3 draft:", err);
      alert(err.response?.data?.message || "Failed to upload draft documents.");
    } finally {
      setStep3Uploading(false);
    }
  };

  const handleSendManualReminder = async (userId, slot = 1) => {
    const slotLabel = slot === 2 ? "Service 2" : "Service 1";
    if (!window.confirm(`Send a registered agent renewal reminder email for ${slotLabel} to this client now?`)) return;
    if (slot === 2) setManualReminderLoading2(true);
    else setManualReminderLoading1(true);
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(`${API_BASE}/api/auth/send-immediate-registered-agent-reminder`, 
        { userId, slot },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(response.data.message || "Reminder email sent successfully!");
    } catch (error) {
      console.error("Error sending manual reminder:", error);
      alert(error.response?.data?.message || "Failed to send reminder email.");
    } finally {
      if (slot === 2) setManualReminderLoading2(false);
      else setManualReminderLoading1(false);
    }
  };

  const handleSendTaxReminder = async (userId, memberIndex = null) => {
    if (!window.confirm("Send a tax filing reminder email to this client now?")) return;
    setManualReminderLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(`${API_BASE}/api/auth/send-immediate-tax-reminder`, 
        { userId, memberIndex },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(response.data.message || "Reminder email sent successfully!");
    } catch (error) {
      console.error("Error sending manual tax reminder:", error);
      alert(error.response?.data?.message || "Failed to send reminder email.");
    } finally {
      setManualReminderLoading(false);
    }
  };

  const handleSendAnnualReportReminder = async (userId) => {
    if (!window.confirm("Send an annual report reminder email to this client now?")) return;
    setManualReminderLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(`${API_BASE}/api/auth/send-immediate-annual-report-reminder`, 
        { userId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(response.data.message || "Reminder email sent successfully!");
    } catch (error) {
      console.error("Error sending manual annual report reminder:", error);
      alert(error.response?.data?.message || "Failed to send reminder email.");
    } finally {
      setManualReminderLoading(false);
    }
  };

  const handleSendBookkeepingReminder = async (userId) => {
    if (!window.confirm("Send a bookkeeping document upload reminder email to this client now?")) return;
    setManualBookkeepingReminderLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(`${API_BASE}/api/auth/send-immediate-bookkeeping-reminder`, 
        { userId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(response.data.message || "Bookkeeping reminder email sent successfully!");
      if (response.data.bookkeepingService && selectedMenuUser?._id === userId) {
        setSelectedMenuUser({
          ...selectedMenuUser,
          bookkeepingService: response.data.bookkeepingService
        });
      }
    } catch (error) {
      console.error("Error sending manual bookkeeping reminder:", error);
      alert(error.response?.data?.message || "Failed to send reminder email.");
    } finally {
      setManualBookkeepingReminderLoading(false);
    }
  };

  const handleSendSalesTaxReminder = async (userId) => {
    if (!window.confirm("Send a sales tax document upload reminder email to this client now?")) return;
    setManualSalesTaxReminderLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(`${API_BASE}/api/auth/send-immediate-sales-tax-reminder`, 
        { userId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(response.data.message || "Sales Tax reminder email sent successfully!");
      if (response.data.salesTaxService && selectedMenuUser?._id === userId) {
        setSelectedMenuUser({
          ...selectedMenuUser,
          salesTaxService: response.data.salesTaxService
        });
      }
    } catch (error) {
      console.error("Error sending manual sales tax reminder:", error);
      alert(error.response?.data?.message || "Failed to send reminder email.");
    } finally {
      setManualSalesTaxReminderLoading(false);
    }
  };

  const handleToggleBookkeepingReminders = async (userId) => {
    setToggleReminderLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(`${API_BASE}/api/bookkeeping/service/${userId}/toggle-reminders`, 
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(response.data.message || "Daily reminders status updated!");
      if (response.data.bookkeepingService && selectedMenuUser?._id === userId) {
        setSelectedMenuUser({
          ...selectedMenuUser,
          bookkeepingService: response.data.bookkeepingService
        });
      }
    } catch (error) {
      alert(error.response?.data?.message || "Failed to toggle daily reminders.");
    } finally {
      setToggleReminderLoading(false);
    }
  };

  const handleToggleSalesTaxReminders = async (userId) => {
    setToggleReminderLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(`${API_BASE}/api/sales-tax/service/${userId}/toggle-reminders`, 
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(response.data.message || "Sales Tax daily reminders status updated!");
      if (response.data.salesTaxService && selectedMenuUser?._id === userId) {
        setSelectedMenuUser(prev => ({
          ...prev,
          salesTaxService: response.data.salesTaxService
        }));
        if (onUserUpdated) onUserUpdated();
      }
    } catch (error) {
      alert(error.response?.data?.message || "Failed to toggle daily reminders.");
    } finally {
      setToggleReminderLoading(false);
    }
  };

  const renderReminderTracking = (oneMonthSent, fifteenDaySent) => {
    return (
      <div className="flex gap-4 mt-2 pt-2 border-t border-gray-100 dark:border-dark-700/50">
        <div className="flex items-center gap-1.5">
          <div className={`w-1.5 h-1.5 rounded-full ${oneMonthSent ? 'bg-green-500 shadow-[0_0_8px_var(--green-500)]' : 'bg-gray-300 dark:bg-dark-600'}`} />
          <span className={`text-[9px] font-bold uppercase tracking-wider ${oneMonthSent ? 'text-green-600 dark:text-green-400' : 'text-gray-400'}`}>1-Month</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className={`w-1.5 h-1.5 rounded-full ${fifteenDaySent ? 'bg-green-500 shadow-[0_0_8px_var(--green-500)]' : 'bg-gray-300 dark:bg-dark-600'}`} />
          <span className={`text-[9px] font-bold uppercase tracking-wider ${fifteenDaySent ? 'text-green-600 dark:text-green-400' : 'text-gray-400'}`}>15-Day</span>
        </div>
      </div>
    );
  };

  // Move to History states
  const [newCycleTaxYearEndDate, setNewCycleTaxYearEndDate] = useState("");
  const [newCycleDueDate, setNewCycleDueDate] = useState("");
  const [showMoveToHistoryConfirm, setShowMoveToHistoryConfirm] = useState(false);
  const [moveToHistoryMemberIndex, setMoveToHistoryMemberIndex] = useState(null);

  // Tax Filing unlock price (USD) - per user
  const [taxUnlockPriceUsd, setTaxUnlockPriceUsd] = useState("150");
  const [isSavingTaxUnlockPrice, setIsSavingTaxUnlockPrice] = useState(false);

  // History editing states
  const [editingHistory, setEditingHistory] = useState(null); // { type, index, historyIndex }
  const [historyEditTaxYearEnd, setHistoryEditTaxYearEnd] = useState("");
  const [historyEditDueDate, setHistoryEditDueDate] = useState("");

  // Step 4 Document Signing states
  const [step4DocUploading, setStep4DocUploading] = useState(false);
  const [step4EditorOpen, setStep4EditorOpen] = useState(false);
  const [step4EditorDocUrl, setStep4EditorDocUrl] = useState('');
  const [step4EditorBoxes, setStep4EditorBoxes] = useState([]);
  const [step4EditorTarget, setStep4EditorTarget] = useState({ userId: null, memberIndex: -1 });
  const [step4SavingBoxes, setStep4SavingBoxes] = useState(false);

  // Disable background scrolling when modal is open
  useEffect(() => {
    if (!showMenu) return;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    // Cleanup on unmount or when showMenu becomes false
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [showMenu]);

  // Default pre-populated Tax Filing summary table (matches screenshot)
  const DEFAULT_TAX_SUMMARY_TABLE = {
    columns: ["PARTICULARS", "CURRENT YEAR", "PREVIOUS YEAR"],
    rows: [
      ["Total Income  ", "", ""],
      ["Total Tax ", "", ""]
    ]
  };

  const cloneDefaultTable = () => ({
    columns: [...DEFAULT_TAX_SUMMARY_TABLE.columns],
    rows: DEFAULT_TAX_SUMMARY_TABLE.rows.map(row => [...row])
  });

  // Helpers for editable Tax Filing summary tables
  const getPrimarySummaryTable = () => {
    const t = selectedMenuUser?.taxFilingSummaryTable;
    if (t && Array.isArray(t.columns) && t.columns.length > 0) return t;
    return cloneDefaultTable();
  };

  const handlePrimaryTableChange = (updater) => {
    setSelectedMenuUser(prev => {
      if (!prev) return prev;
      const t = prev.taxFilingSummaryTable;
      const current = (t && Array.isArray(t.columns) && t.columns.length > 0) ? t : cloneDefaultTable();
      const updated = updater(current);
      return { ...prev, taxFilingSummaryTable: updated };
    });
  };

  const getMemberSummaryTable = (member) => {
    const t = member?.taxFilingSummaryTable;
    if (t && Array.isArray(t.columns) && t.columns.length > 0) return t;
    return cloneDefaultTable();
  };

  const handleMemberTableChange = (memberIndex, updater) => {
    setSelectedMenuUser(prev => {
      if (!prev || !prev.members) return prev;
      const members = [...prev.members];
      const currentMember = members[memberIndex];
      if (!currentMember) return prev;

      const t = currentMember.taxFilingSummaryTable;
      const currentTable = (t && Array.isArray(t.columns) && t.columns.length > 0) ? t : DEFAULT_TAX_SUMMARY_TABLE;
      const updatedTable = updater(currentTable);

      members[memberIndex] = {
        ...currentMember,
        taxFilingSummaryTable: updatedTable
      };

      return { ...prev, members };
    });
  };

  useEffect(() => {
    if (!selectedMenuUser) return;
    const cents = selectedMenuUser.taxFilingUnlockPriceCents;
    const usd = (Number.isFinite(cents) && cents >= 100) ? (cents / 100) : 150;
    setTaxUnlockPriceUsd(String(usd));
  }, [selectedMenuUser]);

  // Fetch collaborators for bookkeeping tab
  useEffect(() => {
    if (!selectedMenuUser || activeTab !== 'bookkeeping') return;

    const fetchCollaborators = async () => {
      try {
        const token = localStorage.getItem("adminToken");
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000'}/api/auth/collaborators/${selectedMenuUser._id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.ok) {
          const data = await response.json();
          setBookkeepingCollaborators(data.collaborators || []);
        }
      } catch (err) {
        console.error('Error fetching collaborators:', err);
      }
    };

    fetchCollaborators();
  }, [selectedMenuUser, activeTab]);

  const handleRemoveCollaborator = async (collaboratorId, collaboratorName) => {
    if (!window.confirm(`Are you sure you want to remove ${collaboratorName} as a collaborator?`)) {
      return;
    }
    try {
      const token = localStorage.getItem("adminToken");
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000'}/api/auth/remove-collaborator`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ collaboratorId })
        }
      );
      if (response.ok) {
        setBookkeepingCollaborators(prev => prev.filter(c => c._id !== collaboratorId));
      } else {
        const data = await response.json();
        alert(data.message || "Failed to remove collaborator");
      }
    } catch (err) {
      console.error("Error removing collaborator:", err);
      alert("Server error. Failed to remove collaborator.");
    }
  };

  const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

  const handlePaymentStatusUpdate = async (userId, memberIndex, newStatus) => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`${API_BASE}/api/auth/update-payment-status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          userId,
          memberIndex: memberIndex === -1 ? null : memberIndex,
          paymentStatus: newStatus
        }),
      });

      if (!response.ok) {
        let errMessage = 'Failed to update payment status';
        try { const errData = await response.json(); if (errData.message) errMessage = errData.message; } catch(e){}
        throw new Error(errMessage);
      }

      const data = await response.json();
      setSelectedMenuUser(data.user);
      alert('Payment status updated successfully!');
    } catch (error) {
      console.error('Error updating payment status:', error);
      alert(error.message);
    }
  };

  // Step 4: Upload signature document handler
  const handleStep4DocUpload = async (userId, memberIndex, file) => {
    if (!file) return;

    // Check Step 3 status before allowing upload
    const isPrimary = memberIndex === -1 || memberIndex === null || memberIndex === undefined;
    const step3Status = getStep3Status ? getStep3Status(userId, isPrimary ? -1 : memberIndex) : 'pending';

    if (step3Status !== 'submitted') {
      alert('Step 4 upload is only possible after Step 3 is completed.');
      return;
    }

    setStep4DocUploading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const formData = new FormData();
      formData.append('document', file);
      formData.append('userId', userId);
      formData.append('memberIndex', memberIndex !== null && memberIndex !== undefined ? memberIndex : -1);
      const res = await axios.post(`${API_BASE}/api/auth/upload-signature-document`, formData, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
      });
      if (res.data?.signatureDocument) {
        // Refresh user data by updating the local state
        const isPrimary = memberIndex === -1 || memberIndex === null || memberIndex === undefined;
        setSelectedMenuUser(prev => {
          if (!prev) return prev;
          const updated = { ...prev };
          if (isPrimary) {
            const steps = [...(updated.steps || [])];
            const s4 = steps.find(s => s.step === 4);
            if (s4) s4.signatureDocument = res.data.signatureDocument;
            updated.steps = steps;
          } else {
            const members = [...(updated.members || [])];
            if (members[memberIndex]) {
              const steps = [...(members[memberIndex].steps || [])];
              const s4 = steps.find(s => s.step === 4);
              if (s4) s4.signatureDocument = res.data.signatureDocument;
              members[memberIndex] = { ...members[memberIndex], steps };
            }
            updated.members = members;
          }
          return updated;
        });
      }
    } catch (err) {
      console.error('Error uploading Step 4 document:', err);
      alert(err.response?.data?.message || 'Failed to upload document');
    } finally {
      setStep4DocUploading(false);
    }
  };

  // Step 4: Open signature box editor
  const openStep4Editor = (userId, memberIndex) => {
    const isPrimary = memberIndex === -1 || memberIndex === null || memberIndex === undefined;
    let sigDoc;
    if (isPrimary) {
      const s4 = selectedMenuUser?.steps?.find(s => s.step === 4);
      sigDoc = s4?.signatureDocument;
    } else {
      const s4 = selectedMenuUser?.members?.[memberIndex]?.steps?.find(s => s.step === 4);
      sigDoc = s4?.signatureDocument;
    }
    if (!sigDoc?.fileUrl) return;
    setStep4EditorDocUrl(`${API_BASE}${sigDoc.fileUrl}`);
    setStep4EditorBoxes(sigDoc.signatureBoxes || []);
    setStep4EditorTarget({ userId, memberIndex: isPrimary ? -1 : memberIndex });
    setStep4EditorOpen(true);
  };

  // Step 4: Save signature boxes
  const handleStep4SaveBoxes = async (boxes) => {
    setStep4SavingBoxes(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.post(`${API_BASE}/api/auth/save-signature-boxes`, {
        userId: step4EditorTarget.userId,
        memberIndex: step4EditorTarget.memberIndex,
        signatureBoxes: boxes
      }, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data) {
        const isPrimary = step4EditorTarget.memberIndex === -1;
        setSelectedMenuUser(prev => {
          if (!prev) return prev;
          const updated = { ...prev };
          if (isPrimary) {
            const steps = [...(updated.steps || [])];
            const s4 = steps.find(s => s.step === 4);
            if (s4) {
              s4.signatureDocument = { ...s4.signatureDocument, signatureBoxes: boxes };
              s4.status = 'client-pending';
            }
            updated.steps = steps;
          } else {
            const mIdx = step4EditorTarget.memberIndex;
            const members = [...(updated.members || [])];
            if (members[mIdx]) {
              const steps = [...(members[mIdx].steps || [])];
              const s4 = steps.find(s => s.step === 4);
              if (s4) {
                s4.signatureDocument = { ...s4.signatureDocument, signatureBoxes: boxes };
                s4.status = 'client-pending';
              }
              members[mIdx] = { ...members[mIdx], steps };
            }
            updated.members = members;
          }
          return updated;
        });
        setStep4EditorOpen(false);
      }
    } catch (err) {
      console.error('Error saving signature boxes:', err);
      alert(err.response?.data?.message || 'Failed to save signature boxes');
    } finally {
      setStep4SavingBoxes(false);
    }
  };

  // Helper: Get step 4 signature document status
  const getStep4DocStatus = (userId, memberIndex) => {
    const isPrimary = memberIndex === -1 || memberIndex === null || memberIndex === undefined;
    let s4;
    if (isPrimary) {
      s4 = selectedMenuUser?.steps?.find(s => s.step === 4);
    } else {
      s4 = selectedMenuUser?.members?.[memberIndex]?.steps?.find(s => s.step === 4);
    }
    if (!s4?.signatureDocument?.fileUrl) return 'no-document';
    if (s4.signatureDocument.signedFileUrl) return 'signed';
    if (s4.signatureDocument.signatureBoxes?.length > 0) return 'boxes-placed';
    return 'document-uploaded';
  };

  const handleTabSelect = (tab) => {
    setActiveTab(tab);
    setActiveMemberAccordion(null);
    if (tab === 'primary') setTaxFilingSubTab('primary-member');
  };

  const toggleMemberAccordion = (index) => {
    setActiveMemberAccordion(activeMemberAccordion === index ? null : index);
  };

  const handleAddMemberWithService = async () => {
    try {
      const nameToSend = (newMemberName || "").trim();
      const resData = await addMember(selectedMenuUser._id, nameToSend);
      if (resData && resData.user) {
        setSelectedMenuUser(resData.user);
        setNewMemberName("");
        const newIdx = resData.memberIndex !== undefined ? resData.memberIndex : (resData.user.members ? resData.user.members.length - 1 : 0);
        setActiveMemberIndex(newIdx);
      }
    } catch (error) {
      console.error("Error adding member:", error);
    }
  };

  // Helper function to format date for display
  const formatDateForDisplay = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  // Helper function to format date for input field
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  // Helper function to format date strictly as MM-DD-YYYY
  const formatDateMMDDYYYY = (dateVal) => {
    if (!dateVal) return '';
    if (typeof dateVal === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(dateVal.trim())) {
      return dateVal.trim();
    }
    const str = String(dateVal).trim();
    const mdy = str.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
    if (mdy) {
      return `${mdy[1].padStart(2, '0')}-${mdy[2].padStart(2, '0')}-${mdy[3]}`;
    }
    const date = new Date(str);
    if (isNaN(date.getTime())) return String(dateVal);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}-${dd}-${yyyy}`;
  };

  const formatDetailedDateTime = (dateString) => {
    if (!dateString) return <span className="text-gray-400 italic">Not yet recorded</span>;
    const date = new Date(dateString);
    return (
      <div className="flex flex-col">
        <span className="font-semibold text-gray-900 dark:text-white">
          {date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
        </span>
        <span className="text-sm text-gray-600 dark:text-gray-400">
          {date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
          })}
        </span>
      </div>
    );
  };

  // Helper function to get due date period text
  const getDueDatePeriod = (formType) => {
    if (formType === '1040' || formType === '1120') {
      return '3.5 months';
    } else if (formType === '1065' || formType === '1120-S') {
      return '2.5 months';
    }
    return '';
  };

  // Check if all steps are completed (handles both old 5-step and new 4-step structures)
  const areAllStepsCompleted = (user, memberIndex = null) => {
    let steps;
    if (memberIndex !== null && memberIndex >= 0) {
      steps = user?.members?.[memberIndex]?.steps;
    } else {
      steps = user?.steps;
    }
    if (!steps || steps.length === 0) return false;
    const relevantSteps = steps.filter(s => s.step <= 4);
    return relevantSteps.length >= 4 && relevantSteps.every(s => s.status === 'submitted');
  };

  const formatTaxFilingStatusShort = (status) => {
    if (status === 'in-progress') return 'In Progress';
    if (status === 'client-pending') return 'Client Pending';
    if (status === 'submitted') return 'Completed';
    return 'Pending';
  };

  const renderTaxFilingActivityReport = (memberIndex = -1) => {
    const isPrimary = memberIndex < 0;
    const subject = isPrimary
      ? selectedMenuUser
      : selectedMenuUser?.members?.[memberIndex];
    if (!subject) return null;

    const stepsList = getTaxFilingStepsList(memberIndex);
    const stepCompletionCount = [1, 2, 3, 4].filter(
      (s) => subject[`step${s}CompletionDate`]
    ).length;
    const label = isPrimary
      ? 'Primary Member'
      : (subject.name || `Member ${memberIndex + 1}`);

    return (
      <div className="mt-8 pt-8 border-t border-gray-200 dark:border-dark-700">
        <h5 className="font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
          <FaHistory className="text-primary-500" /> Tax Filing Activity Report
        </h5>
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-xl p-5 border border-blue-200 dark:border-blue-800">
          <h6 className="font-bold text-lg text-blue-900 dark:text-blue-300 mb-4 flex items-center gap-2 flex-wrap">
            <FaClipboardCheck /> {label}
            {subject.assignedForm && (
              <span className="px-2.5 py-0.5 rounded-lg bg-primary-100 dark:bg-primary-900/40 text-primary-700 dark:text-primary-300 text-xs font-semibold">
                Form {subject.assignedForm}
              </span>
            )}
          </h6>
          <div className="space-y-4">
            <div className="bg-white dark:bg-dark-800 rounded-lg p-4 shadow-sm">
              <h6 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Tax Filing Enabled Date</h6>
              {formatDetailedDateTime(subject.taxFilingEnabledAt)}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
              {stepsList.map((step) => (
                <div key={step.step} className="bg-white dark:bg-dark-800 rounded-lg p-4 shadow-sm">
                  <div className="flex items-center justify-between gap-2 mb-1">
                    <h6 className="text-xs font-semibold text-gray-700 dark:text-gray-300">
                      Step {step.step}: {step.title}
                    </h6>
                    {subject.assignedForm && (
                      <span className="shrink-0 px-1.5 py-0.5 rounded bg-primary-50 dark:bg-primary-900/30 text-primary-600 dark:text-primary-300 text-[10px] font-bold">
                        {subject.assignedForm}
                      </span>
                    )}
                  </div>
                  <p className="text-[10px] font-bold uppercase text-primary-600 mb-2">
                    {formatTaxFilingStatusShort(step.status)}
                  </p>
                  <p className="text-[10px] font-semibold text-gray-500 dark:text-gray-400 mb-1">Completed At</p>
                  {formatDetailedDateTime(subject[`step${step.step}CompletionDate`])}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-6 bg-gradient-to-br from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-xl p-5 border border-purple-200 dark:border-purple-800">
          <h6 className="font-bold text-lg text-purple-900 dark:text-purple-300 mb-4">Activity Summary</h6>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="bg-white dark:bg-dark-800 rounded-lg p-3 text-center">
              <div className="text-2xl font-bold text-primary-600">
                {isPrimary ? (selectedMenuUser?.isTaxFilingEnabled ? '✓' : '✗') : (subject.assignedForm ? '✓' : '✗')}
              </div>
              <div className="text-[10px] text-gray-600 dark:text-gray-400 mt-1 uppercase font-bold">Service Active</div>
            </div>
            <div className="bg-white dark:bg-dark-800 rounded-lg p-3 text-center">
              <div className="text-2xl font-bold text-green-600">{stepCompletionCount}</div>
              <div className="text-[10px] text-gray-600 dark:text-gray-400 mt-1 uppercase font-bold">Steps Completed</div>
            </div>
            {isPrimary ? (
              <div className="bg-white dark:bg-dark-800 rounded-lg p-3 text-center">
                <div className="text-2xl font-bold text-blue-600">{selectedMenuUser?.members?.length || 0}</div>
                <div className="text-[10px] text-gray-600 dark:text-gray-400 mt-1 uppercase font-bold">Total Members</div>
              </div>
            ) : (
              <div className="bg-white dark:bg-dark-800 rounded-lg p-3 text-center">
                <div className="text-lg font-bold text-blue-600 uppercase">{subject.paymentStatus || '—'}</div>
                <div className="text-[10px] text-gray-600 dark:text-gray-400 mt-1 uppercase font-bold">Payment Status</div>
              </div>
            )}
            <div className="bg-white dark:bg-dark-800 rounded-lg p-3 text-center">
              <div className="text-lg font-bold text-orange-600">
                {(isPrimary ? selectedMenuUser?.taxFilingLocked : subject.taxFilingLocked) ? 'Locked' : 'Active'}
              </div>
              <div className="text-[10px] text-gray-600 dark:text-gray-400 mt-1 uppercase font-bold">Filing Status</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const formatUSAFormationStatusShort = (status) => {
    if (status === 'in-progress') return 'In Progress';
    if (status === 'submitted') return 'Completed';
    return 'Pending';
  };

  const renderUSAFormationActivityReport = () => {
    if (!selectedMenuUser) return null;

    const stepsList = getUSAFormationStepsList();
    const completedCount = stepsList.filter((s) => s.status === 'submitted').length;
    const inProgressStep = stepsList.find((s) => s.status === 'in-progress');
    const formationStatus = completedCount === 3
      ? 'Completed'
      : inProgressStep
      ? `Step ${inProgressStep.step} In Progress`
      : 'Not Started';

    return (
      <div className="mt-8 pt-8 border-t border-gray-200 dark:border-dark-700">
        <h5 className="font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
          <FaHistory className="text-primary-500" /> USA Company Formation Activity Report
        </h5>
        <div className="bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 rounded-xl p-5 border border-amber-200 dark:border-amber-800">
          <h6 className="font-bold text-lg text-amber-900 dark:text-amber-300 mb-4 flex items-center gap-2">
            <FaStar /> {selectedMenuUser.name || 'Client'}
          </h6>
          <div className="space-y-4">
            <div className="bg-white dark:bg-dark-800 rounded-lg p-4 shadow-sm max-w-md">
              <h6 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Formation Started</h6>
              {formatDetailedDateTime(selectedMenuUser.usaCompanyFormation?.createdAt)}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {stepsList.map((step) => (
                <div key={step.step} className="bg-white dark:bg-dark-800 rounded-lg p-4 shadow-sm">
                  <h6 className="text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1">
                    Step {step.step}: {step.title}
                  </h6>
                  <p className="text-[10px] font-bold uppercase text-primary-600 mb-2">
                    {formatUSAFormationStatusShort(step.status)}
                  </p>
                  {step.step === 1 && step.status === 'in-progress' && typeof step.progress === 'number' && (
                    <p className="text-[10px] text-gray-500 dark:text-gray-400 mb-2">
                      Checklist progress: {step.progress}%
                    </p>
                  )}
                  <p className="text-[10px] font-semibold text-gray-500 dark:text-gray-400 mb-1">Completed At</p>
                  {formatDetailedDateTime(step.submittedAt)}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-6 bg-gradient-to-br from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-xl p-5 border border-purple-200 dark:border-purple-800">
          <h6 className="font-bold text-lg text-purple-900 dark:text-purple-300 mb-4">Activity Summary</h6>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="bg-white dark:bg-dark-800 rounded-lg p-3 text-center">
              <div className="text-2xl font-bold text-primary-600">
                {selectedMenuUser.isUSAEnabled ? '✓' : '✗'}
              </div>
              <div className="text-[10px] text-gray-600 dark:text-gray-400 mt-1 uppercase font-bold">Service Active</div>
            </div>
            <div className="bg-white dark:bg-dark-800 rounded-lg p-3 text-center">
              <div className="text-2xl font-bold text-green-600">{completedCount}/3</div>
              <div className="text-[10px] text-gray-600 dark:text-gray-400 mt-1 uppercase font-bold">Steps Completed</div>
            </div>
            <div className="bg-white dark:bg-dark-800 rounded-lg p-3 text-center">
              <div className="text-lg font-bold text-blue-600 uppercase">
                {selectedMenuUser.assignedCompanyForm || 'LLC'}
              </div>
              <div className="text-[10px] text-gray-600 dark:text-gray-400 mt-1 uppercase font-bold">Entity Type</div>
            </div>
            <div className="bg-white dark:bg-dark-800 rounded-lg p-3 text-center">
              <div className="text-sm font-bold text-orange-600">{formationStatus}</div>
              <div className="text-[10px] text-gray-600 dark:text-gray-400 mt-1 uppercase font-bold">Formation Status</div>
            </div>
          </div>
          {selectedMenuUser.usaFeedback?.rating && (
            <div className="mt-4 bg-white dark:bg-dark-800 rounded-lg p-4 shadow-sm">
              <h6 className="text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1">Client Feedback</h6>
              <p className="text-sm text-gray-900 dark:text-white">
                {'★'.repeat(selectedMenuUser.usaFeedback.rating)}{'☆'.repeat(5 - selectedMenuUser.usaFeedback.rating)}
                {selectedMenuUser.usaFeedback.comment && (
                  <span className="block mt-1 text-xs text-gray-500 dark:text-gray-400">{selectedMenuUser.usaFeedback.comment}</span>
                )}
              </p>
              {selectedMenuUser.usaFeedback.submittedAt && (
                <p className="text-[10px] text-gray-400 mt-2">
                  Submitted {new Date(selectedMenuUser.usaFeedback.submittedAt).toLocaleDateString()}
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  // Handle move to history confirmation
  const confirmMoveToHistory = async () => {
    if (handleMoveToHistory) {
      await handleMoveToHistory(selectedMenuUser._id, moveToHistoryMemberIndex, newCycleTaxYearEndDate, newCycleDueDate);
      setShowMoveToHistoryConfirm(false);
      setNewCycleTaxYearEndDate("");
      setNewCycleDueDate("");
      setMoveToHistoryMemberIndex(null);
    }
  };

  if (!showMenu) return null;

  const tabs = [
    { id: 'profile', label: 'Profile' },
    { id: 'services', label: 'Services' },
    { id: 'primary', label: 'Tax Filing' },
    { id: 'usa-formation', label: 'USA Company Formation' },
    { id: 'documents', label: 'Documents' },
    { id: 'annual-report', label: 'Annual Report' },
    { id: 'sales-tax', label: 'Sales Tax' },
    { id: 'registered-agent', label: 'Registered Agent' },
    { id: 'bookkeeping', label: 'Bookkeeping' },
    { id: 'quick-payment', label: 'Quick Payment' },
    { id: 'export-data', label: 'Export Data' }
  ];

  const filteredSwitcherUsers = users.filter(user => 
    user.name.toLowerCase().includes(switcherSearch.toLowerCase()) || 
    user.email.toLowerCase().includes(switcherSearch.toLowerCase()) ||
    (user.members && user.members.some(member => member.name.toLowerCase().includes(switcherSearch.toLowerCase())))
  );

  return createPortal(
    <div className="fixed inset-0 z-50 flex" onClick={() => setShowMenu(false)}>
      {/* Backdrop with fade-in */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity duration-300" />

      {/* Main Container for Switcher + Side Menu */}
      <div 
        className="ml-auto relative flex h-full shadow-2xl animate-slideInRight bg-white dark:bg-dark-900"
        onClick={e => e.stopPropagation()}
        style={{ 
          animation: 'slideInRight 0.3s ease-out forwards',
          width: `${sidebarWidth}px`,
          maxWidth: '95vw'
        }}
      >
        {/* Resize Handle */}
        <div
          onMouseDown={(e) => {
            e.preventDefault();
            setIsResizing(true);
          }}
          className={`absolute left-0 top-0 w-1.5 h-full cursor-col-resize z-50 group transition-all ${
            isResizing ? 'bg-primary-500 shadow-[0_0_15px_rgba(37,99,235,0.5)]' : 'hover:bg-primary-400/30'
          }`}
        >
          <div className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 w-0.5 h-12 bg-gray-300 dark:bg-dark-600 rounded-full group-hover:bg-primary-400 transition-colors" />
        </div>

        {/* User Switcher Column */}
        <div className="w-72 bg-white dark:bg-dark-900 border-r border-gray-200 dark:border-dark-700 flex flex-col h-full overflow-hidden">
          <div className="p-4 border-b border-gray-100 dark:border-dark-800 bg-gray-50/50 dark:bg-dark-800/50">
            <h6 className="text-[10px] uppercase font-bold text-gray-500 dark:text-gray-400 tracking-widest mb-3">Client Switcher</h6>
            <div className="relative">
              <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-3 h-3" />
              <input
                type="text"
                placeholder="Search clients..."
                value={switcherSearch}
                onChange={(e) => setSwitcherSearch(e.target.value)}
                className="w-full pl-9 pr-4 py-2 bg-white dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-xs text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 transition-all outline-none"
              />
            </div>
          </div>
          <div className="flex-1 overflow-y-auto p-2 space-y-1 custom-scrollbar">
            {filteredSwitcherUsers.map((user) => (
              <div key={user._id} className="space-y-0.5">
                <button
                  onClick={() => handleClientSwitch(user)}
                  className={`w-full flex items-center gap-3 p-3 rounded-xl transition-all ${
                    selectedMenuUser?._id === user._id 
                    ? 'bg-primary-50 dark:bg-primary-900/20 border border-primary-100 dark:border-primary-800' 
                    : 'hover:bg-gray-50 dark:hover:bg-dark-800 border border-transparent'
                  }`}
                >
                  <div className="relative shrink-0">
                    {user.profilePicture ? (
                      <img
                        src={user.profilePicture}
                        alt={user.name}
                        className="w-8 h-8 rounded-full object-cover border border-primary-200/50"
                        onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}&background=random&color=fff`; }}
                      />
                    ) : (
                      <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold ${
                        selectedMenuUser?._id === user._id
                        ? 'bg-primary-600 text-white'
                        : 'bg-gray-200 dark:bg-dark-700 text-gray-600 dark:text-gray-400'
                      }`}>
                        {user.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)}
                      </div>
                    )}
                    {onlineUserIds.includes(user._id) && (
                      <span
                        className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 bg-emerald-500 border-2 border-white dark:border-dark-900 rounded-full animate-pulse"
                        title="Online Now"
                      />
                    )}
                  </div>
                  <div className="text-left overflow-hidden">
                    <p className={`text-xs font-bold truncate flex items-center gap-1.5 ${selectedMenuUser?._id === user._id ? 'text-primary-700 dark:text-primary-400' : 'text-gray-900 dark:text-white'}`}>
                      <span className="truncate">{user.name}</span>
                      {onlineUserIds.includes(user._id) && (
                        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 shrink-0" title="Active Now" />
                      )}
                    </p>
                    <p className="text-[10px] text-gray-500 truncate">{user.email}</p>
                  </div>
                  {selectedMenuUser?._id === user._id && (
                    <div className="ml-auto w-1.5 h-1.5 rounded-full bg-primary-600 shadow-[0_0_8px_var(--primary-500)]" />
                  )}
                </button>

                {/* Members List */}
                {user.members && user.members.length > 0 && (
                  <div className="ml-11 space-y-0.5 mt-0.5 border-l-2 border-gray-100 dark:border-dark-700 pl-3 pb-1">
                    {user.members.map((member, mIdx) => (
                      <button
                        key={mIdx}
                        onClick={() => handleMemberSwitch(user, mIdx)}
                        className={`w-full flex items-center gap-2 py-1.5 px-2 rounded-lg text-left transition-all group ${
                          selectedMenuUser?._id === user._id && activeMemberIndex === mIdx && taxFilingSubTab === 'member'
                          ? 'bg-primary-50/50 dark:bg-primary-900/10 text-primary-700 dark:text-primary-400 font-bold'
                          : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'
                        }`}
                      >
                        <FaUser className={`w-2 h-2 transition-colors ${
                          selectedMenuUser?._id === user._id && activeMemberIndex === mIdx && taxFilingSubTab === 'member'
                          ? 'text-primary-500'
                          : 'text-gray-300 group-hover:text-gray-400'
                        }`} />
                        <span className="text-[11px] truncate leading-none">{member.name}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}
            {filteredSwitcherUsers.length === 0 && (
              <div className="text-center py-10">
                <p className="text-xs text-gray-400">No clients found</p>
              </div>
            )}
          </div>
        </div>

        {/* Vertical Tab Navigation (Original) */}
        <div className="w-16 bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 flex flex-col items-center py-4 gap-1 shrink-0">
          {/* Close Button at Top */}
          <button
            onClick={() => setShowMenu(false)}
            className="w-10 h-10 flex items-center justify-center text-red-500 hover:text-white bg-red-50 dark:bg-red-900/20 hover:bg-red-600 rounded-xl transition-all mb-6 shadow-sm border border-red-100 dark:border-red-900/40 group"
            title="Close Menu"
          >
            <FaTimes size={16} className="group-hover:rotate-90 transition-transform duration-300" />
          </button>

          {/* Tab Icons */}
          {tabs.map(tab => {
            const tabIcons = {
              'profile': <FaUser size={16} />,
              'services': <FaCog size={16} />,
              'primary': <FaClipboardCheck size={16} />,
              'usa-formation': <FaStar size={16} />,
              'documents': <FaFolder size={16} />,
              'annual-report': <FaFileUpload size={16} />,
              'sales-tax': <FaReceipt size={16} />,
              'registered-agent': <FaCheck size={16} />,
              'bookkeeping': <FaChartLine size={16} />,
              'quick-payment': <FaDollarSign size={16} />,
              'export-data': <FaDownload size={16} />
            };
            return (
              <button
                key={tab.id}
                onClick={() => handleTabSelect(tab.id)}
                className={`w-12 h-12 flex flex-col items-center justify-center rounded-xl transition-all duration-200 group relative ${activeTab === tab.id
                  ? 'bg-primary-600 text-white shadow-lg shadow-primary-600/30'
                  : 'text-gray-500 hover:text-white hover:bg-white/10'
                  }`}
                title={tab.label}
              >
                {tabIcons[tab.id]}
                <span className="text-[8px] mt-0.5 font-medium leading-tight text-center truncate w-full px-0.5">
                  {tab.label.split(' ')[0]}
                </span>
                {/* Tooltip on hover */}
                <div className="absolute left-full ml-2 px-2.5 py-1.5 bg-gray-900 text-white text-xs font-medium rounded-lg whitespace-nowrap opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity z-10 shadow-lg">
                  {tab.label}
                  <div className="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-gray-900" />
                </div>
              </button>
            );
          })}
        </div>

        {/* Main Content Area */}
        <div className="flex-1 flex flex-col bg-white dark:bg-dark-800 overflow-hidden">
          {/* Header with Client Info */}
          <div className="px-6 py-4 border-b border-gray-100 dark:border-dark-700 bg-gradient-to-r from-gray-50 to-white dark:from-dark-800 dark:to-dark-750 shrink-0">
            <div className="flex items-center gap-4">
              {/* Avatar */}
              <div className="relative shrink-0">
                {selectedMenuUser?.profilePicture ? (
                  <img
                    src={selectedMenuUser.profilePicture}
                    alt={selectedMenuUser.name}
                    className="w-11 h-11 rounded-xl object-cover shadow-lg shadow-primary-500/20 border-2 border-primary-100"
                    onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedMenuUser.name)}&background=random&color=fff`; }}
                  />
                ) : (
                  <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center text-white font-bold text-lg shadow-lg shadow-primary-500/20">
                    {selectedMenuUser?.name?.charAt(0)?.toUpperCase() || 'C'}
                  </div>
                )}
                {onlineUserIds.includes(selectedMenuUser?._id) && (
                  <span
                    className="absolute -bottom-1 -right-1 w-3.5 h-3.5 bg-emerald-500 border-2 border-white dark:border-dark-800 rounded-full animate-pulse"
                    title="Online Now"
                  />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h2 className="text-lg font-bold text-gray-900 dark:text-white truncate">
                    {selectedMenuUser?.name || 'Client'}
                  </h2>
                  {onlineUserIds.includes(selectedMenuUser?._id) && (
                    <span className="flex items-center gap-1 text-[10px] font-extrabold uppercase text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/30 px-2 py-0.5 rounded-full border border-emerald-200/50 dark:border-emerald-800/50">
                      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-ping" />
                      Active
                    </span>
                  )}
                </div>
                <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                  {selectedMenuUser?.email || 'No email'}
                </p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <button
                  type="button"
                  onClick={() => onToggleVerify && selectedMenuUser && onToggleVerify(selectedMenuUser._id)}
                  className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold rounded-xl transition-all shadow-sm cursor-pointer ${
                    selectedMenuUser?.isVerified
                      ? "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/30 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-800 hover:bg-amber-100 dark:hover:bg-amber-900/50"
                      : "bg-red-50 text-red-700 dark:bg-red-950/30 dark:text-red-400 border border-red-200 dark:border-red-800 hover:bg-emerald-100 dark:hover:bg-emerald-900/50"
                  }`}
                  title={selectedMenuUser?.isVerified ? "Account Verified (Click to Block Access)" : "Account Blocked (Click to Allow Access)"}
                >
                  <FaUserShield className="w-3.5 h-3.5" />
                  <span>{selectedMenuUser?.isVerified ? "Verified" : "Blocked"}</span>
                </button>
                <button
                  onClick={() => onChatClick(selectedMenuUser)}
                  className="flex items-center gap-1.5 px-3.5 py-1.5 bg-primary-600 hover:bg-primary-700 text-white text-xs font-bold rounded-xl transition-all shadow-md shadow-primary-500/20 cursor-pointer active:scale-95"
                  title="Open Chat with Client"
                >
                  <img src="/chat-icon.png" className="w-4 h-4 object-contain" alt="Chat" />
                  <span>Chat</span>
                </button>
                <span className="px-3 py-1 text-xs font-semibold rounded-full bg-primary-50 text-primary-700 dark:bg-primary-900/30 dark:text-primary-400 border border-primary-200 dark:border-primary-800">
                  {tabs.find(t => t.id === activeTab)?.label}
                </span>
              </div>
            </div>
          </div>

          {/* Scrollable Content */}
          <div className="flex-1 p-6 overflow-y-auto">
            {/* Profile Tab */}
            {activeTab === 'profile' && (
              <div className="space-y-6">
                {/* Profile Header Card with Picture */}
                <div className="flex flex-col items-center sm:flex-row sm:items-start gap-6 bg-white dark:bg-dark-800/60 rounded-2xl p-6 border border-gray-100 dark:border-dark-700 shadow-sm">
                  <div 
                    className="relative flex-shrink-0 cursor-pointer hover:scale-105 transition-transform duration-200 group/avatar"
                    onClick={() => setShowProfilePicLightbox(true)}
                    title="Click to view full size"
                  >
                    {selectedMenuUser?.profilePicture ? (
                      <img
                        src={selectedMenuUser.profilePicture}
                        alt={selectedMenuUser.name}
                        className="w-24 h-24 rounded-full object-cover border-4 border-primary-100 dark:border-primary-950 shadow-md"
                        onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedMenuUser.name)}&background=random&color=fff&size=128`; }}
                      />
                    ) : (
                      <div className="w-24 h-24 rounded-full bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center text-white font-bold text-3xl shadow-md border-4 border-primary-100 dark:border-primary-950">
                        {selectedMenuUser?.name?.charAt(0)?.toUpperCase() || 'C'}
                      </div>
                    )}
                    {onlineUserIds.includes(selectedMenuUser?._id) && (
                      <span className="absolute bottom-1 right-1 w-5 h-5 bg-emerald-500 border-4 border-white dark:border-dark-800 rounded-full animate-pulse" title="Online Now" />
                    )}
                  </div>
                  <div className="flex-1 text-center sm:text-left pt-2">
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white flex items-center justify-center sm:justify-start gap-2">
                      {selectedMenuUser?.name}
                      {onlineUserIds.includes(selectedMenuUser?._id) && (
                        <span className="flex items-center gap-1 text-[10px] font-extrabold uppercase text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/30 px-2 py-0.5 rounded-full border border-emerald-200/50 dark:border-emerald-800/50">
                          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-ping" />
                          Active
                        </span>
                      )}
                    </h3>
                    <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{selectedMenuUser?.email}</p>
                    <p className="text-xs text-gray-450 dark:text-gray-450 mt-2">Client ID: <span className="font-mono bg-gray-50 dark:bg-dark-750 px-2 py-0.5 rounded-md border border-gray-100 dark:border-dark-700">{selectedMenuUser?._id}</span></p>

                    {/* Account Access Rights Control */}
                    <div className="mt-4 pt-3 border-t border-gray-100 dark:border-dark-700/60 flex flex-wrap items-center gap-3">
                      <span className="text-xs font-bold text-gray-700 dark:text-gray-300">Account Access Rights:</span>
                      <button
                        type="button"
                        onClick={() => onToggleVerify && selectedMenuUser && onToggleVerify(selectedMenuUser._id)}
                        className={`px-3 py-1.5 text-xs font-bold rounded-xl transition-all shadow-sm flex items-center gap-2 cursor-pointer ${
                          selectedMenuUser?.isVerified
                            ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-300 border border-emerald-300 dark:border-emerald-800 hover:bg-amber-100 hover:text-amber-900"
                            : "bg-red-100 text-red-800 dark:bg-red-950/50 dark:text-red-300 border border-red-300 dark:border-red-800 hover:bg-emerald-100 hover:text-emerald-900"
                        }`}
                        title={selectedMenuUser?.isVerified ? "Click to Block Access / Unverify User" : "Click to Allow Access / Verify User"}
                      >
                        <FaUserShield className="w-4 h-4" />
                        <span>{selectedMenuUser?.isVerified ? "Verified (Access Allowed)" : "Blocked (Access Denied)"}</span>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Profile Picture Full Screen Lightbox Overlay */}
                {showProfilePicLightbox && createPortal(
                  <div 
                    className="fixed inset-0 z-[999999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4"
                    onClick={() => setShowProfilePicLightbox(false)}
                  >
                    <button 
                      onClick={() => setShowProfilePicLightbox(false)}
                      className="absolute top-6 right-6 p-3 text-white/70 hover:text-white bg-white/10 hover:bg-white/20 rounded-full transition-all cursor-pointer z-[1000000]"
                      title="Close Preview"
                    >
                      <FaTimes size={20} />
                    </button>
                    <img
                      src={selectedMenuUser?.profilePicture || `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedMenuUser?.name || 'C')}&background=random&color=fff&size=512`}
                      alt={selectedMenuUser?.name}
                      className="w-full max-w-[480px] h-auto max-h-[80vh] rounded-3xl object-contain shadow-2xl border-4 border-white/15 bg-white dark:bg-dark-900 p-3 animate-in zoom-in-95 duration-200"
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>,
                  document.body
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Personal Information Card */}
                  <div className="bg-white dark:bg-dark-800/60 rounded-2xl p-6 border border-gray-100 dark:border-dark-700 shadow-sm">
                    <h4 className="text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider mb-5 pb-3 border-b border-gray-100 dark:border-dark-700 flex items-center justify-between">
                      <span className="flex items-center gap-2">
                        <FaUser className="text-primary-500" /> Account Details
                      </span>
                      {!isEditingProfile ? (
                        <button
                          onClick={() => setIsEditingProfile(true)}
                          className="px-3 py-1 bg-primary-50 hover:bg-primary-100 text-primary-600 text-xs font-bold rounded-lg transition-colors border border-primary-200 cursor-pointer"
                        >
                          Edit Profile
                        </button>
                      ) : (
                        <div className="flex gap-2">
                          <button
                            onClick={handleSaveProfile}
                            disabled={isSavingProfile}
                            className="px-3 py-1 bg-green-600 hover:bg-green-700 text-white text-xs font-bold rounded-lg transition-colors disabled:opacity-50 cursor-pointer"
                          >
                            {isSavingProfile ? 'Saving...' : 'Save'}
                          </button>
                          <button
                            onClick={() => {
                              setIsEditingProfile(false);
                              setProfileEditData({
                                name: selectedMenuUser.name || "",
                                email: selectedMenuUser.email || "",
                                organization: selectedMenuUser.organization || "",
                                address: selectedMenuUser.address || "",
                                dateOfBirth: selectedMenuUser.dateOfBirth ? new Date(selectedMenuUser.dateOfBirth).toISOString().split("T")[0] : ""
                              });
                            }}
                            disabled={isSavingProfile}
                            className="px-3 py-1 bg-gray-100 hover:bg-gray-200 text-gray-600 dark:bg-dark-700 dark:hover:bg-dark-600 dark:text-gray-300 text-xs font-bold rounded-lg transition-colors cursor-pointer"
                          >
                            Cancel
                          </button>
                        </div>
                      )}
                    </h4>
                    <div className="space-y-4">
                      {isEditingProfile ? (
                        <>
                          <div>
                            <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1">Full Name</span>
                            <input
                              type="text"
                              value={profileEditData.name}
                              onChange={(e) => setProfileEditData({ ...profileEditData, name: e.target.value })}
                              className="w-full px-3 py-2 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500/25 focus:border-primary-500 outline-none transition-all"
                              placeholder="Name"
                            />
                          </div>
                          <div>
                            <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1">Email Address</span>
                            <input
                              type="email"
                              value={profileEditData.email}
                              onChange={(e) => setProfileEditData({ ...profileEditData, email: e.target.value })}
                              className="w-full px-3 py-2 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500/25 focus:border-primary-500 outline-none transition-all"
                              placeholder="Email"
                            />
                          </div>
                          <div>
                            <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1">Birthdate (Date of Birth)</span>
                            <input
                              type="date"
                              value={profileEditData.dateOfBirth}
                              onChange={(e) => setProfileEditData({ ...profileEditData, dateOfBirth: e.target.value })}
                              className="w-full px-3 py-2 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500/25 focus:border-primary-500 outline-none transition-all"
                            />
                          </div>
                          <div>
                            <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1">Organization</span>
                            <input
                              type="text"
                              value={profileEditData.organization}
                              onChange={(e) => setProfileEditData({ ...profileEditData, organization: e.target.value })}
                              className="w-full px-3 py-2 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500/25 focus:border-primary-500 outline-none transition-all"
                              placeholder="Organization"
                            />
                          </div>
                          <div>
                            <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1">Physical Address</span>
                            <textarea
                              value={profileEditData.address}
                              onChange={(e) => setProfileEditData({ ...profileEditData, address: e.target.value })}
                              rows={3}
                              className="w-full px-3 py-2 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500/25 focus:border-primary-500 outline-none resize-none transition-all"
                              placeholder="Address"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1">Full Name</span>
                            <span className="text-sm font-semibold text-gray-900 dark:text-white">{selectedMenuUser?.name || 'N/A'}</span>
                          </div>
                          <div>
                            <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1">Email Address</span>
                            <span className="text-sm font-semibold text-gray-900 dark:text-white">{selectedMenuUser?.email || 'N/A'}</span>
                          </div>
                          <div>
                            <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1">Birthdate (Date of Birth)</span>
                            <span className="text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-1.5">
                              {selectedMenuUser?.dateOfBirth ? (
                                <>
                                  <span className="text-pink-500 font-bold">🎂</span>
                                  <span>{new Date(selectedMenuUser.dateOfBirth).toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' })}</span>
                                </>
                              ) : (
                                <span className="text-gray-400 font-normal italic">Not Provided</span>
                              )}
                            </span>
                          </div>
                          <div>
                            <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1">Organization</span>
                            <span className="text-sm font-semibold text-gray-900 dark:text-white">{selectedMenuUser?.organization || 'Not Provided'}</span>
                          </div>
                          <div>
                            <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1">Physical Address</span>
                            <span className="text-sm font-semibold text-gray-900 dark:text-white whitespace-pre-line">{selectedMenuUser?.address || 'Not Provided'}</span>
                          </div>
                        </>
                      )}
                      <div className="grid grid-cols-2 gap-4 pt-2 border-t border-gray-100 dark:border-dark-700">
                        <div>
                          <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1">Account Verified</span>
                          <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-bold ${
                            selectedMenuUser?.isVerified 
                              ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/30 dark:text-emerald-400' 
                              : 'bg-red-50 text-red-700 dark:bg-red-950/30 dark:text-red-400'
                          }`}>
                            {selectedMenuUser?.isVerified ? 'Verified' : 'Unverified'}
                          </span>
                        </div>
                        <div>
                          <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1">Registered On</span>
                          <span className="text-sm font-semibold text-gray-900 dark:text-white">
                            {selectedMenuUser?.createdAt ? new Date(selectedMenuUser.createdAt).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' }) : 'N/A'}
                          </span>
                        </div>
                      </div>
                      <div className="pt-2 border-t border-gray-100 dark:border-dark-700">
                        <button
                          type="button"
                          onClick={async () => {
                            try {
                              const token = localStorage.getItem("adminToken");
                              const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/check-birthdays`, {
                                method: 'POST',
                                headers: { Authorization: `Bearer ${token}` }
                              });
                              const data = await res.json();
                              if (data.success) {
                                alert(data.count > 0 
                                  ? `🎂 Birthday Alert Sent! ${data.count} client(s) celebrating today. Admin notified via email.` 
                                  : "🎂 Birthday Check Complete: No clients have birthdays today.");
                              } else {
                                alert("Failed to check birthdays: " + (data.message || data.error));
                              }
                            } catch (err) {
                              alert("Error checking birthdays: " + err.message);
                            }
                          }}
                          className="w-full py-2 px-3 bg-pink-50 hover:bg-pink-100 dark:bg-pink-950/20 dark:hover:bg-pink-950/40 text-pink-700 dark:text-pink-300 text-xs font-bold rounded-xl border border-pink-200 dark:border-pink-800 transition-all flex items-center justify-center gap-2 cursor-pointer shadow-xs"
                        >
                          <span>🎂 Test Birthday Email Alert to Admin</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Referral & Credits Card */}
                  <div className="bg-white dark:bg-dark-800/60 rounded-2xl p-6 border border-gray-100 dark:border-dark-700 shadow-sm flex flex-col justify-between">
                    <div>
                      <h4 className="text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider mb-5 pb-3 border-b border-gray-100 dark:border-dark-700 flex items-center gap-2">
                        <FaStar className="text-amber-500" /> Referral System
                      </h4>
                      <div className="space-y-4">
                        <div>
                          <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1">Referral Code</span>
                          <span className="font-mono text-sm font-bold text-primary-600 dark:text-primary-400 bg-primary-50 dark:bg-primary-950/30 px-3 py-1 rounded-lg border border-primary-100/50 dark:border-primary-900/50">
                            {selectedMenuUser?.referralCode || 'N/A'}
                          </span>
                        </div>
                        <div>
                          <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-1">Referral Credits</span>
                          <span className="text-lg font-extrabold text-amber-600 dark:text-amber-400">
                            {selectedMenuUser?.referralCredits || 0} Credits
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Active Services Summary Grid */}
                    <div className="mt-6 pt-6 border-t border-gray-100 dark:border-dark-700">
                      <h4 className="text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider mb-4 flex items-center gap-2">
                        <FaCog className="text-gray-500" /> Active Services Status
                      </h4>
                      <div className="grid grid-cols-2 gap-2">
                        {[
                          { label: 'USA Formation', active: selectedMenuUser?.isUSAEnabled },
                          { label: 'Tax Filing', active: selectedMenuUser?.isTaxFilingEnabled },
                          { label: 'Bookkeeping', active: selectedMenuUser?.isBookkeepingEnabled },
                          { label: 'CFO Advisory', active: selectedMenuUser?.isCFOEnabled },
                          { label: 'Registered Agent', active: selectedMenuUser?.isRegisteredAgentEnabled },
                          { label: 'Annual Report', active: selectedMenuUser?.isAnnualReportServiceEnabled },
                          { label: 'Sales Tax', active: selectedMenuUser?.isSalesTaxEnabled }
                        ].map((srv, sIdx) => (
                          <div key={sIdx} className="flex items-center gap-2 px-3 py-2 bg-gray-50 dark:bg-dark-750 rounded-xl border border-gray-100/50 dark:border-dark-700">
                            <span className={`w-2 h-2 rounded-full ${srv.active ? 'bg-emerald-500 animate-pulse' : 'bg-gray-300'}`} />
                            <span className="text-xs font-semibold text-gray-700 dark:text-gray-300">{srv.label}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Services Tab */}
            {activeTab === 'services' && (
              <div>
                <h5 className="font-bold text-gray-900 dark:text-white mb-4">Service Lock/Unlock</h5>
                <div className="space-y-2 bg-gray-50 dark:bg-dark-700 p-4 rounded-xl">
                  {[
                    { id: "usa-company-switch", label: "USA Company Formation", key: "isUSAEnabled" },
                    { id: "tax-filing-switch", label: "Tax Filing", key: "isTaxFilingEnabled" },
                    { id: "bookkeeping-switch", label: "Bookkeeping", key: "isBookkeepingEnabled" },
                    { id: "cfo-switch", label: "CFO Advisory", key: "isCFOEnabled" },
                    { id: "registered-agent-switch", label: "Registered Agent", key: "isRegisteredAgentEnabled" },
                    { id: "annual-report-switch", label: "Annual Report Service", key: "isAnnualReportServiceEnabled" },
                    { id: "sales-tax-switch", label: "Sales Tax Module", key: "isSalesTaxEnabled" }
                  ].map(service => {
                    const toggleKey = `${selectedMenuUser?._id}-${service.label}`;
                    const isLoading = toggleLoading?.[toggleKey] || false;

                    return (
                      <div key={service.id} className="flex justify-between items-center py-2 border-b border-gray-200 dark:border-dark-600 last:border-0">
                        <span className="font-medium text-gray-700 dark:text-gray-300">{service.label}</span>
                        <label className={`relative inline-flex items-center ${isLoading ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                          <input
                            type="checkbox"
                            checked={selectedMenuUser?.[service.key] || false}
                            onChange={(e) => toggleServiceLock(selectedMenuUser._id, service.label, e.target.checked)}
                            className="sr-only peer"
                            disabled={isLoading}
                          />
                          <div className={`w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 dark:peer-focus:ring-primary-800 rounded-full peer dark:bg-dark-600 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary-600 transition-all duration-200 ${isLoading ? 'opacity-60' : ''}`}></div>
                        </label>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Tax Filing Tab */}
            {activeTab === 'primary' && (
              <div className="space-y-6">
                {/* Sub-tabs: Primary Member | Member */}
                <div className="flex border-b border-gray-200 dark:border-dark-600">
                  <button
                    onClick={() => setTaxFilingSubTab('primary-member')}
                    className={`px-5 py-2.5 text-sm font-semibold transition-all ${taxFilingSubTab === 'primary-member'
                      ? 'text-primary-600 border-b-2 border-primary-600 bg-primary-50/50 dark:bg-primary-900/10'
                      : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-dark-700'
                      }`}
                  >
                    Primary Member
                  </button>
                  <button
                    onClick={() => setTaxFilingSubTab('member')}
                    className={`px-5 py-2.5 text-sm font-semibold transition-all ${taxFilingSubTab === 'member'
                      ? 'text-primary-600 border-b-2 border-primary-600 bg-primary-50/50 dark:bg-primary-900/10'
                      : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-dark-700'
                      }`}
                  >
                    Member {selectedMenuUser?.members?.length > 0 ? `(${selectedMenuUser.members.length})` : ''}
                  </button>
                </div>

                {/* Primary Member Sub-tab Content */}
                {taxFilingSubTab === 'primary-member' && (
                  <>
                    <div className="space-y-4">
                    <div className="grid gap-4 lg:grid-cols-2 items-start">
                      <div className={formCardClass}>
                        <label className={formLabelClass}>Assign Form</label>
                        <div className="flex items-stretch gap-2">
                          <select
                            value={selectedMenuUser?.assignedForm || "1040"}
                            onChange={(e) => setSelectedMenuUser({ ...selectedMenuUser, assignedForm: e.target.value })}
                            className={`${formSelectClass} flex-1 min-w-0`}
                          >
                            <option value="1040">1040</option>
                            <option value="1065">1065</option>
                            <option value="1120-S">1120-S</option>
                            <option value="1120">1120</option>
                          </select>
                          <button
                            type="button"
                            onClick={handlePrimaryFormAssign}
                            className="shrink-0 px-4 py-2.5 bg-primary-600 text-white text-sm font-semibold rounded-xl hover:bg-primary-700 transition-colors"
                          >
                            Assign
                          </button>
                        </div>
                      </div>

                      <div className={formCardClass}>
                        <label className={formLabelClass}>Payment Status</label>
                        <select
                          value={selectedMenuUser?.paymentStatus || (selectedMenuUser?.taxFilingLocked ? 'unpaid' : 'paid')}
                          onChange={(e) => handlePaymentStatusUpdate(selectedMenuUser._id, -1, e.target.value)}
                          className={formSelectClass}
                        >
                          <option value="paid">Paid</option>
                          <option value="unpaid">Unpaid</option>
                          <option value="wip-unpaid">WIP–Unpaid</option>
                          <option value="p-extension">P Extension</option>
                          <option value="up-extension">UP Extension</option>
                        </select>
                      </div>
                    </div>

                    <div className="grid gap-4 lg:grid-cols-2 items-start">
                      <div className={formCardClass}>
                        <label className={formLabelClass}>Tax Year End Date & Due Date</label>
                        <div className="grid grid-cols-2 gap-3 mb-3">
                          <div>
                            <label className="block text-[10px] font-medium text-gray-500 dark:text-gray-400 mb-1">Tax Year End</label>
                            <input type="date" value={primaryTaxYearEndDate || formatDateForInput(selectedMenuUser?.taxYearEndDate)} onChange={(e) => setPrimaryTaxYearEndDate(e.target.value)} className="w-full px-3 py-2.5 text-sm bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500/25 focus:border-primary-500 outline-none" />
                          </div>
                          <div>
                            <label className="block text-[10px] font-medium text-gray-500 dark:text-gray-400 mb-1">Due Date (Optional)</label>
                            <input type="date" value={primaryDueDate || formatDateForInput(selectedMenuUser?.dueDate)} onChange={(e) => setPrimaryDueDate(e.target.value)} className="w-full px-3 py-2.5 text-sm bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500/25 focus:border-primary-500 outline-none" />
                          </div>
                        </div>
                        <button
                          onClick={() => {
                            const tyed = primaryTaxYearEndDate || formatDateForInput(selectedMenuUser?.taxYearEndDate);
                            const dd = primaryDueDate || formatDateForInput(selectedMenuUser?.dueDate);
                            if (tyed) {
                              handleTaxDateUpdate(selectedMenuUser._id, tyed, dd);
                              setPrimaryTaxYearEndDate("");
                              setPrimaryDueDate("");
                            }
                          }}
                          disabled={!primaryTaxYearEndDate && !selectedMenuUser?.taxYearEndDate}
                          className="w-full px-4 py-2.5 text-sm bg-green-600 text-white font-semibold rounded-xl hover:bg-green-700 disabled:opacity-50 transition-colors"
                        >
                          Update Tax Dates
                        </button>
                        {(selectedMenuUser?.taxYearEndDate || selectedMenuUser?.dueDate) && (
                          <button
                            type="button"
                            onClick={() => setClearDatesModal({ type: 'primary', memberIndex: null })}
                            className="w-full mt-2 px-4 py-2.5 text-sm bg-red-50 text-red-600 font-medium rounded-xl hover:bg-red-100 transition-colors cursor-pointer"
                          >
                            Remove Dates
                          </button>
                        )}
                        {selectedMenuUser?.taxYearEndDate && selectedMenuUser?.dueDate && (
                          <div className="mt-3 p-3 bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-400 rounded-xl text-xs leading-relaxed">
                            <div className="flex flex-col gap-2">
                              <div className="flex items-center justify-between gap-2">
                                <div>
                                  <strong>Tax Year End:</strong> {formatDateForDisplay(selectedMenuUser.taxYearEndDate)}<br />
                                  <strong>Due Date:</strong> {formatDateForDisplay(selectedMenuUser.dueDate)}
                                  {getDueDatePeriod(selectedMenuUser.assignedForm) && <span className="text-primary-600"> ({getDueDatePeriod(selectedMenuUser.assignedForm)})</span>}
                                </div>
                                <button
                                  onClick={() => handleSendTaxReminder(selectedMenuUser._id)}
                                  disabled={manualReminderLoading}
                                  className="flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 hover:bg-primary-700 text-white text-[10px] font-bold rounded-lg transition-all shadow-sm shadow-primary-500/20 shrink-0"
                                >
                                  {manualReminderLoading ? <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin" /> : <FaBell />}
                                  Instant Reminder
                                </button>
                              </div>
                              {renderReminderTracking(selectedMenuUser.oneMonthReminderSent, selectedMenuUser.fifteenDayReminderSent)}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    </div>

                    {renderTaxFilingStepsStatus(-1)}

                    {/* Step 4: Document Upload & Signature Boxes (Primary) - Only shown when Step 3 completed and Step 4 NOT yet submitted */}
                    {selectedMenuUser?.assignedForm &&
                      getStep3Status?.(selectedMenuUser._id, -1) === 'submitted' &&
                      !isStepSubmitted(selectedMenuUser, 4) && (
                        <div className="mt-6">
                          <h5 className="font-bold text-gray-900 dark:text-white mb-3 flex items-center gap-2">
                            <FaFileSignature className="text-purple-500" /> Step 4: Document Upload & Signature Boxes
                          </h5>
                          <div className="p-4 bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-xl space-y-3">
                            {/* Upload Document */}
                            <div>
                              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                Upload PDF Document for Signing
                              </label>
                              <div className="flex gap-2">
                                <input
                                  type="file"
                                  accept=".pdf"
                                  onChange={(e) => {
                                    if (e.target.files[0]) handleStep4DocUpload(selectedMenuUser._id, -1, e.target.files[0]);
                                    e.target.value = '';
                                  }}
                                  disabled={step4DocUploading}
                                  className="flex-1 px-3 py-2 bg-white dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-lg text-gray-900 dark:text-white text-sm file:mr-3 file:py-1 file:px-3 file:rounded-md file:border-0 file:bg-purple-600 file:text-white file:text-xs file:font-medium file:cursor-pointer"
                                />
                              </div>
                              {step4DocUploading && <p className="text-xs text-purple-600 mt-1 animate-pulse">Uploading document...</p>}
                            </div>

                            {/* Status & Actions */}
                            {(() => {
                              const status = getStep4DocStatus(selectedMenuUser._id, -1);
                              const s4 = selectedMenuUser?.steps?.find(s => s.step === 4);
                              return (
                                <>
                                  {status === 'no-document' && (
                                    <p className="text-xs text-gray-500">No document uploaded yet.</p>
                                  )}
                                  {status === 'document-uploaded' && (
                                    <div className="flex items-center justify-between bg-white dark:bg-dark-700 p-3 rounded-lg">
                                      <div>
                                        <p className="text-sm font-medium text-gray-800 dark:text-white">📄 {s4?.signatureDocument?.originalName}</p>
                                        <p className="text-xs text-blue-600">Document uploaded. Add signature boxes next.</p>
                                      </div>
                                      <button
                                        onClick={() => openStep4Editor(selectedMenuUser._id, -1)}
                                        className="flex items-center gap-2 px-4 py-2 bg-purple-600 text-white text-sm font-medium rounded-lg hover:bg-purple-700"
                                      >
                                        <FaDrawPolygon /> Add Signature Boxes
                                      </button>
                                    </div>
                                  )}
                                  {status === 'boxes-placed' && (
                                    <div className="flex items-center justify-between bg-white dark:bg-dark-700 p-3 rounded-lg">
                                      <div>
                                        <p className="text-sm font-medium text-gray-800 dark:text-white">📄 {s4?.signatureDocument?.originalName}</p>
                                        <p className="text-xs text-orange-600">✅ {s4?.signatureDocument?.signatureBoxes?.length} signature box(es) placed. Waiting for client to sign.</p>
                                      </div>
                                      <button
                                        onClick={() => openStep4Editor(selectedMenuUser._id, -1)}
                                        className="flex items-center gap-2 px-3 py-2 bg-indigo-600 text-white text-xs font-medium rounded-lg hover:bg-indigo-700"
                                      >
                                        <FaEye /> Edit Boxes
                                      </button>
                                    </div>
                                  )}
                                  {status === 'signed' && (
                                    <div className="bg-green-50 dark:bg-green-900/20 p-3 rounded-lg">
                                      <p className="text-sm font-medium text-green-700 dark:text-green-400">✅ Document signed by client</p>
                                      <p className="text-xs text-green-600">Signed at: {s4?.signatureDocument?.signedAt ? new Date(s4.signatureDocument.signedAt).toLocaleString() : 'N/A'}</p>
                                    </div>
                                  )}
                                </>
                              );
                            })()}
                          </div>
                        </div>
                      )}

                    {/* Primary Member Summary Table (Tax Filing) */}
                    <div>
                      <h5 className="font-bold text-gray-900 dark:text-white mb-3">Primary Member Tax Filing Table</h5>
                      <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">
                        Configure a custom summary table for the primary member&apos;s Tax Filing. This table will be visible to the user only after all four Tax Filing steps are completed.
                      </p>
                      <div className="border border-gray-200 dark:border-dark-600 rounded-xl overflow-hidden">
                        <div className="p-3 bg-gray-50 dark:bg-dark-700 flex flex-wrap items-center justify-between gap-2">
                          <button
                            type="button"
                            onClick={() =>
                              handlePrimaryTableChange(table => {
                                const columns = [...(table.columns || [])];
                                const rows = (table.rows || []).map(r => [...r]);
                                const newColumnName = `Column ${columns.length + 1}`;
                                columns.push(newColumnName);
                                const nextRows = rows.map(r => [...r, ""]);
                                return { ...table, columns, rows: nextRows };
                              })
                            }
                            className="px-3 py-1.5 text-xs font-medium rounded-lg bg-primary-600 text-white hover:bg-primary-700"
                          >
                            + Add Column
                          </button>
                          <button
                            type="button"
                            onClick={() =>
                              handlePrimaryTableChange(table => {
                                const columns = table.columns || [];
                                const rows = [...(table.rows || [])];
                                const newRow = columns.map(() => "");
                                rows.push(newRow);
                                return { ...table, rows };
                              })
                            }
                            className="px-3 py-1.5 text-xs font-medium rounded-lg bg-green-600 text-white hover:bg-green-700"
                          >
                            + Add Row
                          </button>
                          <button
                            type="button"
                            onClick={() =>
                              handlePrimaryTableChange(() => cloneDefaultTable())
                            }
                            className="px-3 py-1.5 text-xs font-medium rounded-lg bg-red-50 text-red-600 hover:bg-red-100 dark:bg-red-900/20 dark:hover:bg-red-900/40"
                          >
                            Reset Table
                          </button>
                        </div>

                        <div className="overflow-x-auto">
                          <table className="min-w-full border-t border-gray-200 dark:border-dark-600 text-xs">
                            <thead className="bg-gray-50 dark:bg-dark-700">
                              <tr>
                                {(getPrimarySummaryTable().columns || []).map((col, colIndex) => (
                                  <th key={colIndex} className="px-2 py-2 border-b border-gray-200 dark:border-dark-600">
                                    <div className="flex items-center gap-2">
                                      <input
                                        type="text"
                                        value={col}
                                        onChange={e =>
                                          handlePrimaryTableChange(table => {
                                            const columns = [...(table.columns || [])];
                                            columns[colIndex] = e.target.value;
                                            return { ...table, columns };
                                          })
                                        }
                                        className="w-full px-2 py-1 rounded border border-gray-200 dark:border-dark-600 bg-white dark:bg-dark-800 text-gray-900 dark:text-white font-semibold"
                                        placeholder={`Column ${colIndex + 1}`}
                                      />
                                      {(getPrimarySummaryTable().columns?.length || 0) > 1 && (
                                        <button
                                          type="button"
                                          onClick={() =>
                                            handlePrimaryTableChange(table => {
                                              const columns = (table.columns || []).filter((_, index) => index !== colIndex);
                                              const rows = (table.rows || []).map(row => row.filter((_, index) => index !== colIndex));
                                              return { ...table, columns, rows };
                                            })
                                          }
                                          className="text-red-600 hover:text-red-800"
                                          aria-label="Delete Column"
                                        >
                                          ×
                                        </button>
                                      )}
                                    </div>
                                  </th>
                                ))}
                                {((getPrimarySummaryTable().columns?.length || 0) > 0) && (
                                  <th className="px-2 py-2 border-b border-gray-200 dark:border-dark-600 text-right text-gray-500 dark:text-gray-400 text-[10px]">
                                    Actions
                                  </th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {(getPrimarySummaryTable().rows || []).map((row, rowIndex) => (
                                <tr key={rowIndex} className="odd:bg-white even:bg-gray-50 dark:odd:bg-dark-800 dark:even:bg-dark-700/70">
                                  {(getPrimarySummaryTable().columns || []).map((_, colIndex) => (
                                    <td key={colIndex} className="px-2 py-1.5 border-b border-gray-100 dark:border-dark-700">
                                      <input
                                        type="text"
                                        value={row[colIndex] ?? ""}
                                        onChange={e =>
                                          handlePrimaryTableChange(table => {
                                            const rows = (table.rows || []).map(r => [...r]);
                                            if (!rows[rowIndex]) {
                                              rows[rowIndex] = (table.columns || []).map(() => "");
                                            }
                                            rows[rowIndex][colIndex] = e.target.value;
                                            return { ...table, rows };
                                          })
                                        }
                                        className="w-full px-2 py-1 rounded border border-gray-200 dark:border-dark-600 bg-white dark:bg-dark-900 text-gray-900 dark:text-white"
                                      />
                                    </td>
                                  ))}
                                  {getPrimarySummaryTable().columns?.length > 0 && (
                                    <td className="px-2 py-1.5 border-b border-gray-100 dark:border-dark-700 text-right">
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handlePrimaryTableChange(table => {
                                            const rows = (table.rows || []).filter((_, idx) => idx !== rowIndex);
                                            return { ...table, rows };
                                          })
                                        }
                                        className="inline-flex items-center justify-center px-2 py-1 text-[10px] font-medium rounded bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300"
                                      >
                                        Delete Row
                                      </button>
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        {handleUpdateTaxSummaryTable && (
                          <div className="p-3 border-t border-gray-200 dark:border-dark-600 flex justify-end">
                            <button
                              type="button"
                              onClick={async () => {
                                if (!selectedMenuUser?._id) return;
                                await handleUpdateTaxSummaryTable(
                                  selectedMenuUser._id,
                                  null,
                                  getPrimarySummaryTable()
                                );
                              }}
                              className="px-4 py-2 text-xs font-semibold rounded-lg bg-primary-600 text-white hover:bg-primary-700"
                            >
                              Save Table
                            </button>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Tax Filing Lock Status */}
                    <div>
                      <h5 className="font-bold text-gray-900 dark:text-white mb-3">Tax Filing Lock Status</h5>
                      <div className={`p-4 rounded-xl ${selectedMenuUser?.taxFilingLocked ? 'bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800' : 'bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800'}`}>
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            {selectedMenuUser?.taxFilingLocked ? (
                              <><FaLock className="text-orange-500" /><span className="font-medium text-orange-700 dark:text-orange-400">Tax Filing is Locked</span></>
                            ) : (
                              <><FaUnlock className="text-green-500" /><span className="font-medium text-green-700 dark:text-green-400">Tax Filing is Unlocked</span></>
                            )}
                          </div>
                          {selectedMenuUser?.taxFilingLocked && handleUnlockTaxFiling && (
                            <button onClick={() => handleUnlockTaxFiling(selectedMenuUser._id, null)} className="px-4 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 text-sm">
                              Unlock (Admin)
                            </button>
                          )}
                        </div>
                      </div>

                    </div>

                    {/* Move to History Section */}
                    {areAllStepsCompleted(selectedMenuUser) && !selectedMenuUser?.taxFilingLocked && (
                      <div>
                        <h5 className="font-bold text-gray-900 dark:text-white mb-3 flex items-center gap-2">
                          <FaHistory className="text-primary-500" /> Move to History & Start New Cycle
                        </h5>
                        <div className="p-4 bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-xl">
                          <p className="text-sm text-purple-700 dark:text-purple-400 mb-3">
                            All 4 steps are completed. You can move this tax filing cycle to history and start a new locked cycle.
                          </p>
                          <div className="grid grid-cols-2 gap-3 mb-3">
                            <div>
                              <label className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">New Tax Year End Date</label>
                              <input type="date" value={newCycleTaxYearEndDate} onChange={(e) => setNewCycleTaxYearEndDate(e.target.value)} className="w-full px-3 py-2 bg-white dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-lg text-gray-900 dark:text-white text-sm" />
                            </div>
                            <div>
                              <label className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">New Due Date</label>
                              <input type="date" value={newCycleDueDate} onChange={(e) => setNewCycleDueDate(e.target.value)} className="w-full px-3 py-2 bg-white dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-lg text-gray-900 dark:text-white text-sm" />
                            </div>
                          </div>
                          <button onClick={() => { setMoveToHistoryMemberIndex(null); setShowMoveToHistoryConfirm(true); }} className="w-full px-4 py-2.5 bg-purple-600 text-white font-medium rounded-xl hover:bg-purple-700 flex items-center justify-center gap-2">
                            <FaHistory /> Move to History & Lock New Cycle
                          </button>
                        </div>
                      </div>
                    )}

                    {/* Tax Filing History */}
                    {selectedMenuUser?.taxFilingHistory?.length > 0 && (
                      <div>
                        <h5 className="font-bold text-gray-900 dark:text-white mb-3 flex items-center gap-2">
                          <FaHistory className="text-gray-500" /> Tax Filing History ({selectedMenuUser.taxFilingHistory.length})
                        </h5>
                        <div className="space-y-2 max-h-40 overflow-y-auto">
                          {selectedMenuUser.taxFilingHistory.map((history, idx) => (
                            <div key={idx} className="p-3 bg-gray-50 dark:bg-dark-700 rounded-lg text-sm">
                              <div className="flex items-center justify-between">
                                <span className="font-medium text-gray-900 dark:text-white">Form {history.assignedForm}</span>
                                <div className="flex items-center gap-2">
                                  {editingHistory?.type === 'primary' && editingHistory?.historyIndex === idx ? (
                                    <>
                                      <button
                                        onClick={() => {
                                          handleHistoryTaxDateUpdate(selectedMenuUser._id, null, idx, historyEditTaxYearEnd, historyEditDueDate);
                                          setEditingHistory(null);
                                        }}
                                        className="text-green-600 hover:text-green-700 text-xs font-bold"
                                      >
                                        Save
                                      </button>
                                      <button
                                        onClick={() => setEditingHistory(null)}
                                        className="text-gray-400 hover:text-gray-600 text-xs"
                                      >
                                        Cancel
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      onClick={() => {
                                        setEditingHistory({ type: 'primary', historyIndex: idx });
                                        setHistoryEditTaxYearEnd(formatDateForInput(history.taxYearEndDate));
                                        setHistoryEditDueDate(formatDateForInput(history.dueDate));
                                      }}
                                      className="text-primary-600 hover:text-primary-700 text-xs flex items-center gap-1"
                                    >
                                      <FaEdit /> Edit
                                    </button>
                                  )}
                                  <span className="text-green-600 dark:text-green-400 text-xs">✓ Completed</span>
                                </div>
                              </div>
                              {editingHistory?.type === 'primary' && editingHistory?.historyIndex === idx ? (
                                <div className="grid grid-cols-2 gap-2 mt-2">
                                  <div>
                                    <label className="block text-[10px] text-gray-500">Tax Year End</label>
                                    <input
                                      type="date"
                                      value={historyEditTaxYearEnd}
                                      onChange={(e) => setHistoryEditTaxYearEnd(e.target.value)}
                                      className="w-full px-2 py-1 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded text-xs"
                                    />
                                  </div>
                                  <div>
                                    <label className="block text-[10px] text-gray-500">Due Date</label>
                                    <input
                                      type="date"
                                      value={historyEditDueDate}
                                      onChange={(e) => setHistoryEditDueDate(e.target.value)}
                                      className="w-full px-2 py-1 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded text-xs"
                                    />
                                  </div>
                                </div>
                              ) : (
                                <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                  Tax Year: {formatDateForDisplay(history.taxYearEndDate)} | Due: {formatDateForDisplay(history.dueDate)} | Completed: {formatDateForDisplay(history.completedAt)}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {renderTaxFilingActivityReport(-1)}

                  </>
                )}

                {/* Member Sub-tab Content */}
                {taxFilingSubTab === 'member' && (
                  <div className="space-y-6">
                    {/* Compact Add Member Bar */}
                    <div className="bg-gray-50 dark:bg-dark-700 p-4 rounded-2xl border border-gray-100 dark:border-dark-600">
                      <h5 className="text-sm font-bold text-gray-900 dark:text-white mb-3">Add New Member</h5>
                      <div className="flex gap-2">
                        <input 
                          type="text" 
                          placeholder="Enter new member name..." 
                          value={newMemberName} 
                          onChange={(e) => setNewMemberName(e.target.value)} 
                          className="flex-1 px-4 py-2.5 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white text-sm focus:ring-2 focus:ring-primary-500 outline-none transition-all" 
                        />
                        <button 
                          onClick={handleAddMemberWithService} 
                          disabled={selectedMenuUser?.members?.length >= 50} 
                          className="px-6 py-2.5 bg-primary-600 text-white font-bold rounded-xl hover:bg-primary-700 disabled:opacity-50 flex items-center gap-2 transition-all shadow-sm"
                        >
                          <FaPlus /> Add Member
                        </button>
                      </div>
                    </div>

                    {/* Member Selection List */}
                    {selectedMenuUser?.members?.length > 0 && (
                      <div className="space-y-4">
                        <div className="flex items-center justify-between">
                          <h5 className="text-sm font-bold text-gray-900 dark:text-white">Member List ({selectedMenuUser.members.length})</h5>
                        </div>
                        <div className="flex flex-wrap gap-2">
                          {selectedMenuUser.members.map((member, index) => (
                            <button
                              key={index}
                              onClick={() => setActiveMemberIndex(index)}
                              className={`px-4 py-2 rounded-xl text-sm font-medium transition-all flex items-center gap-2 border ${
                                activeMemberIndex === index
                                  ? 'bg-primary-600 border-primary-600 text-white shadow-md scale-105'
                                  : 'bg-white dark:bg-dark-800 border-gray-200 dark:border-dark-600 text-gray-600 dark:text-gray-400 hover:border-primary-500'
                              }`}
                            >
                              <span className={`w-2 h-2 rounded-full ${member?.paymentStatus === 'paid' ? 'bg-green-500' : 'bg-orange-500'}`}></span>
                              {member.name || `Member ${index + 1}`}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Member Details Section */}
                    {selectedMenuUser?.members?.[activeMemberIndex] ? (
                      <div className="bg-white dark:bg-dark-800 rounded-2xl border border-gray-200 dark:border-dark-700 overflow-hidden shadow-sm">
                        {/* Member Detail Header */}
                        <div className="p-4 bg-gray-50 dark:bg-dark-700 border-b border-gray-200 dark:border-dark-600 flex flex-wrap items-center justify-between gap-4">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center text-primary-600 font-bold text-lg">
                              {(selectedMenuUser.members[activeMemberIndex].name || "?")[0].toUpperCase()}
                            </div>
                            <div>
                                <input 
                                  type="text" 
                                  value={selectedMenuUser.members[activeMemberIndex].name || ""} 
                                  placeholder={`Member Name`} 
                                  onChange={(e) => { 
                                    const u = [...selectedMenuUser.members]; 
                                    u[activeMemberIndex].name = e.target.value; 
                                    setSelectedMenuUser({ ...selectedMenuUser, members: u }); 
                                  }} 
                                  className="bg-transparent border-none text-gray-900 dark:text-white font-bold text-base focus:ring-0 p-0 w-48" 
                                />
                                <div className="text-[10px] text-gray-500 flex items-center gap-2">
                                    Member #{activeMemberIndex + 1} 
                                    {selectedMenuUser.members[activeMemberIndex]?.feedback?.rating && (
                                      <span className="flex items-center gap-0.5 ml-2">
                                        {[1, 2, 3, 4, 5].map(star => (
                                          <FaStar key={star} size={8} className={`${star <= selectedMenuUser.members[activeMemberIndex].feedback.rating ? 'text-yellow-400' : 'text-gray-300'}`} />
                                        ))}
                                      </span>
                                    )}
                                </div>
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            <button 
                              onClick={async () => {
                                try {
                                  const data = await handleMemberNameUpdate(selectedMenuUser._id, activeMemberIndex, selectedMenuUser.members[activeMemberIndex].name);
                                  if (data && data.user) {
                                    setSelectedMenuUser(data.user);
                                  }
                                } catch (err) {
                                  console.error("Error updating member name:", err);
                                }
                              }} 
                              className="px-3 py-1.5 bg-primary-600 text-white text-xs font-bold rounded-lg hover:bg-primary-700 transition-colors cursor-pointer"
                            >
                              Update Name
                            </button>
                            <button 
                              onClick={() => {
                                const mName = selectedMenuUser.members?.[activeMemberIndex]?.name || `Member ${activeMemberIndex + 1}`;
                                setMemberToDeleteModal({ index: activeMemberIndex, name: mName });
                              }} 
                              className="p-2 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors cursor-pointer"
                              title="Delete Member"
                            >
                              <FaTrash size={14} />
                            </button>
                          </div>
                        </div>

                        {/* Member Controls Content */}
                        <div className="p-6 space-y-6">
                            {/* Row 1: Assign Form & Payment Status */}
                            <div className="grid gap-4 lg:grid-cols-2 items-start">
                              <div className={formCardClass}>
                                <label className={formLabelClass}>Assign Form</label>
                                <div className="flex items-stretch gap-2">
                                  <select 
                                    value={selectedMenuUser.members[activeMemberIndex].assignedForm || "1040"} 
                                    onChange={(e) => { 
                                      const u = [...selectedMenuUser.members]; 
                                      u[activeMemberIndex].assignedForm = e.target.value; 
                                      setSelectedMenuUser({ ...selectedMenuUser, members: u }); 
                                    }} 
                                    className={`${formSelectClass} flex-1 min-w-0`}
                                  >
                                    <option value="1040">1040</option>
                                    <option value="1065">1065</option>
                                    <option value="1120-S">1120-S</option>
                                    <option value="1120">1120</option>
                                  </select>
                                  <button type="button" onClick={handleMemberFormAssignConfirm} className="shrink-0 px-4 py-2.5 bg-primary-600 text-white text-sm font-semibold rounded-xl hover:bg-primary-700 transition-colors">Assign</button>
                                </div>
                              </div>

                              <div className={formCardClass}>
                                <label className={formLabelClass}>Payment Status</label>
                                <select 
                                  value={selectedMenuUser.members[activeMemberIndex]?.paymentStatus || (selectedMenuUser.members[activeMemberIndex]?.taxFilingLocked ? 'unpaid' : 'paid')} 
                                  onChange={(e) => handlePaymentStatusUpdate(selectedMenuUser._id, activeMemberIndex, e.target.value)} 
                                  className={formSelectClass}
                                >
                                  <option value="paid">Paid</option>
                                  <option value="unpaid">Unpaid</option>
                                  <option value="wip-unpaid">WIP–Unpaid</option>
                                  <option value="p-extension">P Extension</option>
                                  <option value="up-extension">UP Extension</option>
                                </select>
                              </div>
                            </div>

                            {/* Row 2: Tax Year End Date & Due Date */}
                            <div className="grid gap-4 lg:grid-cols-2 items-start">
                              <div className={formCardClass}>
                                <label className={formLabelClass}>Tax Year End Date & Due Date</label>
                                <div className="grid grid-cols-2 gap-3 mb-3">
                                  <div>
                                    <label className="block text-[10px] font-medium text-gray-500 dark:text-gray-400 mb-1">Tax Year End</label>
                                    <input type="date" value={memberTaxYearEndDates[activeMemberIndex] || formatDateForInput(selectedMenuUser.members[activeMemberIndex]?.taxYearEndDate)} onChange={(e) => setMemberTaxYearEndDates({ ...memberTaxYearEndDates, [activeMemberIndex]: e.target.value })} className="w-full px-3 py-2.5 text-sm bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500/25 focus:border-primary-500 outline-none" />
                                  </div>
                                  <div>
                                    <label className="block text-[10px] font-medium text-gray-500 dark:text-gray-400 mb-1">Due Date (Optional)</label>
                                    <input type="date" value={memberDueDates[activeMemberIndex] || formatDateForInput(selectedMenuUser.members[activeMemberIndex]?.dueDate)} onChange={(e) => setMemberDueDates({ ...memberDueDates, [activeMemberIndex]: e.target.value })} className="w-full px-3 py-2.5 text-sm bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500/25 focus:border-primary-500 outline-none" />
                                  </div>
                                </div>
                                <div className="flex gap-2">
                                  <button
                                    onClick={() => {
                                      const tyed = memberTaxYearEndDates[activeMemberIndex] || formatDateForInput(selectedMenuUser.members[activeMemberIndex]?.taxYearEndDate);
                                      const dd = memberDueDates[activeMemberIndex] || formatDateForInput(selectedMenuUser.members[activeMemberIndex]?.dueDate);
                                      if (tyed) {
                                        handleMemberTaxDateUpdate(selectedMenuUser._id, activeMemberIndex, tyed, dd);
                                        setMemberTaxYearEndDates({ ...memberTaxYearEndDates, [activeMemberIndex]: "" });
                                        setMemberDueDates({ ...memberDueDates, [activeMemberIndex]: "" });
                                      }
                                    }}
                                    disabled={!memberTaxYearEndDates[activeMemberIndex] && !selectedMenuUser.members[activeMemberIndex]?.taxYearEndDate}
                                    className="flex-1 px-4 py-2.5 text-sm bg-green-600 text-white font-semibold rounded-xl hover:bg-green-700 disabled:opacity-50 transition-colors"
                                  >
                                    Update Tax Dates
                                  </button>
                                  {(selectedMenuUser.members[activeMemberIndex]?.taxYearEndDate || selectedMenuUser.members[activeMemberIndex]?.dueDate) && (
                                    <button
                                      type="button"
                                      onClick={() => setClearDatesModal({ type: 'member', memberIndex: activeMemberIndex })}
                                      className="px-4 py-2.5 bg-red-100 text-red-600 text-sm font-semibold rounded-xl hover:bg-red-200 transition-colors cursor-pointer"
                                    >
                                      Clear
                                    </button>
                                  )}
                                </div>
                                {selectedMenuUser.members[activeMemberIndex]?.taxYearEndDate && (
                                  <div className="mt-3 text-xs p-2.5 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-xl border border-blue-100 dark:border-blue-800 flex flex-col gap-2">
                                    <div className="flex items-center justify-between">
                                      <p className="m-0">
                                        <strong>Current Settings:</strong> {formatDateForDisplay(selectedMenuUser.members[activeMemberIndex].taxYearEndDate)} {selectedMenuUser.members[activeMemberIndex].dueDate ? ` to ${formatDateForDisplay(selectedMenuUser.members[activeMemberIndex].dueDate)}` : ""}
                                      </p>
                                      <button
                                        onClick={() => handleSendTaxReminder(selectedMenuUser._id, activeMemberIndex)}
                                        disabled={manualReminderLoading}
                                        className="flex items-center gap-1.5 px-2.5 py-1 bg-primary-600 hover:bg-primary-700 text-white text-xs font-bold rounded-lg transition-all shadow-sm"
                                      >
                                        {manualReminderLoading ? <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin" /> : <FaBell className="w-3 h-3" />}
                                        Instant Reminder
                                      </button>
                                    </div>
                                    {renderReminderTracking(selectedMenuUser.members[activeMemberIndex].oneMonthReminderSent, selectedMenuUser.members[activeMemberIndex].fifteenDayReminderSent)}
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Full-width Tax Filing Steps Status */}
                            {renderTaxFilingStepsStatus(activeMemberIndex)}

                            {/* Full Width Bottom: Document Signature & Summary Table */}
                            <div className="space-y-8 pt-4 border-t border-gray-100 dark:border-dark-700">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                    {/* Step 4 Doc */}
                                    {selectedMenuUser.members[activeMemberIndex].assignedForm && getStep3Status?.(selectedMenuUser._id, activeMemberIndex) === 'submitted' && !isMemberStepSubmitted(selectedMenuUser, activeMemberIndex, 4) && (
                                      <div>
                                        <h6 className="text-[11px] uppercase tracking-wider font-bold text-gray-500 dark:text-gray-400 mb-3 flex items-center gap-2">
                                          <FaFileSignature className="text-purple-500" /> Step 4: Documents
                                        </h6>
                                        <div className="p-4 bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-xl space-y-3">
                                          <input type="file" accept=".pdf" onChange={(e) => { if (e.target.files[0]) handleStep4DocUpload(selectedMenuUser._id, activeMemberIndex, e.target.files[0]); e.target.value = ''; }} disabled={step4DocUploading} className="w-full px-3 py-2 bg-white dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-lg text-gray-900 dark:text-white text-xs file:mr-3 file:py-1 file:px-3 file:rounded file:border-0 file:bg-purple-600 file:text-white file:text-[10px] file:font-bold file:cursor-pointer" />
                                          {step4DocUploading && <p className="text-[10px] text-purple-600 animate-pulse font-bold text-center">Uploading Document...</p>}
                                          {(() => {
                                            const status = getStep4DocStatus(selectedMenuUser._id, activeMemberIndex);
                                            const s4 = selectedMenuUser.members[activeMemberIndex]?.steps?.find(s => s.step === 4);
                                            return (
                                              <>
                                                {status === 'document-uploaded' && (
                                                  <div className="flex items-center justify-between bg-white dark:bg-dark-700 p-3 rounded-lg shadow-sm">
                                                    <p className="text-xs text-blue-600 truncate flex-1 font-medium">📄 {s4?.signatureDocument?.originalName}</p>
                                                    <button onClick={() => openStep4Editor(selectedMenuUser._id, activeMemberIndex)} className="flex items-center gap-1.5 px-3 py-1.5 bg-purple-600 text-white text-[10px] font-bold rounded-lg hover:bg-purple-700 ml-3"><FaDrawPolygon size={10} /> Add Boxes</button>
                                                  </div>
                                                )}
                                                {status === 'boxes-placed' && (
                                                  <div className="flex items-center justify-between bg-white dark:bg-dark-700 p-3 rounded-lg shadow-sm">
                                                    <div className="flex-1"><p className="text-xs text-orange-600 font-bold">✅ {s4?.signatureDocument?.signatureBoxes?.length} Boxes — Client Pending</p></div>
                                                    <button onClick={() => openStep4Editor(selectedMenuUser._id, activeMemberIndex)} className="flex items-center gap-1.5 px-3 py-1.5 bg-indigo-600 text-white text-[10px] font-bold rounded-lg hover:bg-indigo-700 ml-3"><FaEye size={10} /> View/Edit</button>
                                                  </div>
                                                )}
                                                {status === 'signed' && (<div className="p-3 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 text-xs font-bold rounded-lg text-center">✅ Document Signed and Completed</div>)}
                                              </>
                                            );
                                          })()}
                                        </div>
                                      </div>
                                    )}

                                    {/* Feedback Section */}
                                    <div>
                                      <h6 className="text-[11px] uppercase tracking-wider font-bold text-gray-500 dark:text-gray-400 mb-3 flex items-center gap-2">
                                        <FaStar className="text-yellow-400" /> Member Feedback
                                      </h6>
                                      {selectedMenuUser.members[activeMemberIndex]?.feedback?.rating ? (
                                        <div className="p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-100 dark:border-yellow-800 rounded-xl">
                                          <div className="flex items-center gap-3 mb-2">
                                            <div className="flex items-center gap-0.5">{[1, 2, 3, 4, 5].map(star => (<FaStar key={star} size={12} className={`${star <= selectedMenuUser.members[activeMemberIndex].feedback.rating ? 'text-yellow-400' : 'text-gray-200'}`} />))}</div>
                                            <span className="text-sm font-bold text-gray-900 dark:text-white">{selectedMenuUser.members[activeMemberIndex].feedback.rating}/5</span>
                                          </div>
                                          {selectedMenuUser.members[activeMemberIndex].feedback.comment && (<p className="text-xs text-gray-700 dark:text-gray-300 italic bg-white/50 dark:bg-dark-800/50 p-3 rounded-lg border border-yellow-200 dark:border-yellow-900/50">&ldquo;{selectedMenuUser.members[activeMemberIndex].feedback.comment}&rdquo;</p>)}
                                          {selectedMenuUser.members[activeMemberIndex].feedback.submittedAt && (<p className="text-[10px] text-gray-400 mt-3 flex items-center gap-1"><FaHistory size={8} /> {formatDateForDisplay(selectedMenuUser.members[activeMemberIndex].feedback.submittedAt)}</p>)}
                                        </div>
                                      ) : (
                                        <div className="p-4 bg-gray-50 dark:bg-dark-900/30 border border-gray-100 dark:border-dark-700 rounded-xl text-center"><p className="text-xs text-gray-400">No feedback provided yet.</p></div>
                                      )}
                                    </div>
                                </div>

                                {/* Custom Summary Table */}
                                <div>
                                    <div className="flex items-center justify-between mb-4">
                                      <h6 className="text-[11px] uppercase tracking-wider font-bold text-gray-500 dark:text-gray-400">Tax Filing Summary Table</h6>
                                      <div className="flex items-center gap-2">
                                        <button onClick={() => handleMemberTableChange(activeMemberIndex, table => { const columns = [...(table.columns || [])]; const rows = (table.rows || []).map(r => [...r]); columns.push(`New Col`); const nextRows = rows.map(r => [...r, ""]); return { ...table, columns, rows: nextRows }; })} className="px-3 py-1 bg-primary-50 text-primary-600 text-[10px] font-bold rounded-lg hover:bg-primary-100">+ Add Col</button>
                                        <button onClick={() => handleMemberTableChange(activeMemberIndex, table => { const columns = table.columns || []; const rows = [...(table.rows || [])]; rows.push(columns.map(() => "")); return { ...table, rows }; })} className="px-3 py-1 bg-green-50 text-green-600 text-[10px] font-bold rounded-lg hover:bg-green-100">+ Add Row</button>
                                        <button onClick={() => handleMemberTableChange(activeMemberIndex, () => cloneDefaultTable())} className="px-3 py-1 bg-red-50 text-red-600 text-[10px] font-bold rounded-lg hover:bg-red-100">Reset</button>
                                      </div>
                                    </div>
                                    
                                    <div className="border border-gray-200 dark:border-dark-700 rounded-2xl overflow-hidden shadow-sm">
                                        <div className="overflow-x-auto">
                                          <table className="min-w-full text-[11px] bg-white dark:bg-dark-950">
                                            <thead className="bg-gray-50 dark:bg-dark-800">
                                              <tr>
                                                {(getMemberSummaryTable(selectedMenuUser.members[activeMemberIndex]).columns || []).map((col, colIndex) => (
                                                  <th key={colIndex} className="px-3 py-2.5 border-b border-gray-200 dark:border-dark-700">
                                                    <div className="flex items-center gap-2">
                                                      <input type="text" value={col} onChange={e => handleMemberTableChange(activeMemberIndex, table => { const columns = [...(table.columns || [])]; columns[colIndex] = e.target.value; return { ...table, columns }; })} className="w-full px-2 py-1 bg-transparent text-gray-900 dark:text-white font-bold outline-none focus:bg-white dark:focus:bg-dark-700 rounded" />
                                                      {(getMemberSummaryTable(selectedMenuUser.members[activeMemberIndex]).columns?.length || 0) > 1 && (
                                                        <button onClick={() => handleMemberTableChange(activeMemberIndex, table => { const columns = (table.columns || []).filter((_, idx) => idx !== colIndex); const rows = (table.rows || []).map(row => row.filter((_, idx) => idx !== colIndex)); return { ...table, columns, rows }; })} className="text-red-400 hover:text-red-600">×</button>
                                                      )}
                                                    </div>
                                                  </th>
                                                ))}
                                                {((getMemberSummaryTable(selectedMenuUser.members[activeMemberIndex]).columns?.length || 0) > 0) && (<th className="px-3 py-2.5 border-b border-gray-200 dark:border-dark-700 text-right text-[9px] font-bold text-gray-400 uppercase">Actions</th>)}
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {(getMemberSummaryTable(selectedMenuUser.members[activeMemberIndex]).rows || []).map((row, rowIndex) => (
                                                <tr key={rowIndex} className="border-b border-gray-100 dark:border-dark-800 hover:bg-gray-50/50 dark:hover:bg-dark-900/50">
                                                  {(getMemberSummaryTable(selectedMenuUser.members[activeMemberIndex]).columns || []).map((_, colIndex) => (
                                                    <td key={colIndex} className="px-3 py-2">
                                                      <input type="text" value={row[colIndex] ?? ""} onChange={e => handleMemberTableChange(activeMemberIndex, table => { const rows = (table.rows || []).map(r => [...r]); if (!rows[rowIndex]) rows[rowIndex] = (table.columns || []).map(() => ""); rows[rowIndex][colIndex] = e.target.value; return { ...table, rows }; })} className="w-full px-2 py-1 bg-transparent text-gray-700 dark:text-gray-300 outline-none focus:bg-white dark:focus:bg-dark-800 rounded transition-all" />
                                                    </td>
                                                  ))}
                                                  <td className="px-3 py-2 text-right">
                                                    <button onClick={() => handleMemberTableChange(activeMemberIndex, table => { const rows = (table.rows || []).filter((_, idx) => idx !== rowIndex); return { ...table, rows }; })} className="p-1 px-2 text-[9px] font-bold text-red-500 hover:bg-red-50 dark:hover:bg-red-900/30 rounded">Remove</button>
                                                  </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </div>
                                        <div className="p-3 bg-gray-50 dark:bg-dark-800 border-t border-gray-200 dark:border-dark-700 flex justify-end">
                                          <button onClick={async () => await handleUpdateTaxSummaryTable(selectedMenuUser._id, activeMemberIndex, getMemberSummaryTable(selectedMenuUser.members[activeMemberIndex]))} className="px-6 py-2 bg-primary-600 text-white text-xs font-bold rounded-xl hover:bg-primary-700 shadow-sm transition-all">Save Changes</button>
                                        </div>
                                    </div>
                                </div>

                                {/* History Management */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                    {areAllStepsCompleted(selectedMenuUser, activeMemberIndex) && !selectedMenuUser.members[activeMemberIndex]?.taxFilingLocked && (
                                      <div className="p-5 bg-purple-50 dark:bg-purple-900/30 rounded-2xl border border-purple-100 dark:border-purple-800">
                                          <h6 className="font-bold text-purple-900 dark:text-purple-300 mb-2 flex items-center gap-2 text-sm"><FaHistory /> Archive & Restart Cycle</h6>
                                          <p className="text-xs text-purple-700 dark:text-purple-400 mb-4">All steps are completed. You can move this cycle to history and lock a new one.</p>
                                          <div className="grid grid-cols-2 gap-3 mb-4">
                                            <div><label className="block text-[10px] font-bold text-purple-600 mb-1">New Tax Year End</label><input type="date" value={newCycleTaxYearEndDate} onChange={(e) => setNewCycleTaxYearEndDate(e.target.value)} className="w-full px-3 py-2 bg-white dark:bg-dark-800 border-none rounded-lg text-xs shadow-sm" /></div>
                                            <div><label className="block text-[10px] font-bold text-purple-600 mb-1">New Due Date</label><input type="date" value={newCycleDueDate} onChange={(e) => setNewCycleDueDate(e.target.value)} className="w-full px-3 py-2 bg-white dark:bg-dark-800 border-none rounded-lg text-xs shadow-sm" /></div>
                                          </div>
                                          <button onClick={() => { setMoveToHistoryMemberIndex(activeMemberIndex); setShowMoveToHistoryConfirm(true); }} className="w-full py-2.5 bg-purple-600 text-white text-xs font-bold rounded-xl hover:bg-purple-700 shadow-md flex items-center justify-center gap-2"><FaHistory /> Move to History</button>
                                      </div>
                                    )}

                                    {selectedMenuUser.members[activeMemberIndex]?.taxFilingLocked && (
                                      <div className="p-5 bg-orange-50 dark:bg-orange-900/30 rounded-2xl border border-orange-100 dark:border-orange-800 flex flex-col justify-center items-center text-center">
                                          <div className="w-12 h-12 bg-orange-100 dark:bg-orange-900/50 rounded-full flex items-center justify-center mb-3 text-orange-600"><FaLock size={20} /></div>
                                          <h6 className="font-bold text-orange-900 dark:text-orange-300 mb-1 text-sm">Tax Filing Locked</h6>
                                          <p className="text-xs text-orange-600/80 dark:text-orange-400/80 mb-4">A new cycle has been created but is currently locked.</p>
                                          <button onClick={() => handleUnlockTaxFiling && handleUnlockTaxFiling(selectedMenuUser._id, activeMemberIndex)} className="w-full py-2.5 bg-green-600 text-white text-xs font-bold rounded-xl hover:bg-green-700 shadow-md flex items-center justify-center gap-2"><FaUnlock /> Admin Unlock</button>
                                      </div>
                                    )}
                                </div>

                                {renderTaxFilingActivityReport(activeMemberIndex)}
                            </div>
                        </div>
                      </div>
                    ) : (
                      <div className="py-20 flex flex-col items-center justify-center text-center opacity-50">
                        <div className="w-20 h-20 bg-gray-100 dark:bg-dark-700 rounded-full flex items-center justify-center mb-4 text-gray-400">
                          <FaPlus size={32} />
                        </div>
                        <h4 className="text-lg font-bold text-gray-900 dark:text-white">No Member Selected</h4>
                        <p className="text-xs text-gray-500 max-w-xs">Select a member from the list above or add a new one to manage their details.</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* USA Formation Tab */}
            {activeTab === 'usa-formation' && (
              <div>
                <h5 className="font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                  <FaChartLine className="text-primary-500" /> USA Company Formation Steps Status
                </h5>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {getUSAFormationStepsList().map((step) => {
                      const isUpdating = updatingUSAFormationStep[step.step];
                      return (
                        <div
                          key={step.step}
                          className={`p-4 rounded-xl border-2 transition-all ${
                            step.status === 'submitted'
                              ? 'bg-blue-50/50 dark:bg-blue-900/10 border-blue-200 dark:border-blue-800'
                              : step.status === 'in-progress'
                              ? 'bg-amber-50/50 dark:bg-amber-900/10 border-amber-200 dark:border-amber-800'
                              : 'bg-gray-50/50 dark:bg-dark-900/50 border-gray-200 dark:border-dark-700'
                          }`}
                        >
                          <div className="flex items-center justify-between mb-2">
                            <span className="text-[10px] font-bold text-gray-400 uppercase">Step {step.step}</span>
                            <span className={`px-2 py-0.5 text-[9px] font-black rounded-full uppercase tracking-wider ${
                              step.status === 'submitted'
                                ? 'bg-blue-500 text-white'
                                : step.status === 'in-progress'
                                ? 'bg-amber-500 text-white'
                                : 'bg-gray-500 text-white'
                            }`}>
                              {formatUSAFormationStatusLabel(step.status)}
                            </span>
                          </div>

                          <h6 className="font-bold text-gray-900 dark:text-white text-xs mb-1.5">{step.title}</h6>

                          <div className="relative mt-3">
                            <label className="block text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase mb-1">
                              Update Status
                            </label>
                            <div className="relative">
                              <select
                                value={step.status || 'pending'}
                                onChange={(e) => handleUpdateUSAFormationStepStatus(step.step, e.target.value)}
                                disabled={isUpdating}
                                className="w-full pl-3 pr-8 py-2 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-xs font-semibold text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 outline-none transition-all appearance-none cursor-pointer"
                              >
                                <option value="pending">Pending</option>
                                <option value="in-progress">In Progress</option>
                                <option value="submitted">Submitted / Completed</option>
                              </select>
                              <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
                                {isUpdating ? (
                                  <div className="w-3.5 h-3.5 border-2 border-primary-600 border-t-transparent rounded-full animate-spin" />
                                ) : (
                                  <FaChevronDown className="w-2.5 h-2.5" />
                                )}
                              </div>
                            </div>
                          </div>

                          {step.status === 'submitted' && (
                            <button
                              type="button"
                              onClick={() => handleUpdateUSAFormationStepStatus(step.step, 'in-progress')}
                              disabled={isUpdating}
                              className="w-full mt-2 py-1.5 bg-amber-100 hover:bg-amber-200 text-amber-700 text-[10px] font-bold rounded-lg transition-all flex items-center justify-center gap-1.5"
                            >
                              <FaUnlock className="w-3 h-3" /> Re-open Step {step.step}
                            </button>
                          )}
                        </div>
                      );
                    })}
                </div>

                {renderUSAFormationActivityReport()}
              </div>
            )}

            {/* Annual Report Tab */}
            {activeTab === 'annual-report' && (
              <div className="space-y-4">
                <h5 className="font-bold text-gray-900 dark:text-white">Annual Report Service - Due Date Setup</h5>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Select State</label>
                  <select value={annualReportState || selectedMenuUser?.annualReportService?.state || ""} onChange={(e) => { setAnnualReportState(e.target.value); setShowEntityTypeSelect(e.target.value !== ""); setAnnualReportEntityType(""); setAnnualReportRegistrationDate(""); }} className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white">
                    <option value="">-- Select State --</option>
                    <option value="Delaware">Delaware</option>
                    <option value="Wyoming">Wyoming</option>
                    <option value="New Jersey">New Jersey</option>
                    <option value="Florida">Florida</option>
                    <option value="Pennsylvania">Pennsylvania</option>
                    <option value="Washington">Washington</option>
                  </select>
                </div>

                {(showEntityTypeSelect || selectedMenuUser?.annualReportService?.state) && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Select Entity Type</label>
                    <select value={annualReportEntityType || selectedMenuUser?.annualReportService?.entityType || ""} onChange={(e) => setAnnualReportEntityType(e.target.value)} className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white">
                      <option value="">-- Select Entity Type --</option>
                      <option value="LLC">LLC</option>
                      <option value="C-Corp">C-Corp</option>
                    </select>
                  </div>
                )}

                {(annualReportEntityType || selectedMenuUser?.annualReportService?.entityType) && (
                  <div className="flex gap-3">
                    <div className="flex-1">
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Registration/Formation Date</label>
                      <input type="date" value={annualReportRegistrationDate || formatDateForInput(selectedMenuUser?.annualReportService?.registrationDate)} onChange={(e) => setAnnualReportRegistrationDate(e.target.value)} className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white" />
                    </div>
                    <div className="w-32">
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Filing Year</label>
                      <div className="relative">
                        <input type="number" placeholder="YYYY" value={annualReportYearsToAdd || selectedMenuUser?.annualReportService?.yearsToAdd || ""} onChange={(e) => setAnnualReportYearsToAdd(e.target.value)} className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white" />
                      </div>
                    </div>
                  </div>
                )}
                {(annualReportEntityType || selectedMenuUser?.annualReportService?.entityType) && (
                  <p className="text-xs text-gray-500 mt-1">Enter the date when the company was registered/formed</p>
                )}

                {(annualReportState || selectedMenuUser?.annualReportService?.state) && (
                  <div className="p-3 bg-gray-100 dark:bg-dark-700 rounded-xl text-sm">
                    <strong className="text-gray-900 dark:text-white">Due Date Rules for {annualReportState || selectedMenuUser?.annualReportService?.state}:</strong>
                    <ul className="mt-2 space-y-1 text-gray-600 dark:text-gray-400 list-disc list-inside">
                      {(annualReportState || selectedMenuUser?.annualReportService?.state) === 'Delaware' && (<><li><strong>LLC:</strong> Due Date is June 1st of the following year</li><li><strong>C-Corp:</strong> Due Date is March 1st of the following year</li></>)}
                      {(annualReportState || selectedMenuUser?.annualReportService?.state) === 'Wyoming' && <li>Due Date is the 1st day of the anniversary month of the following year</li>}
                      {(annualReportState || selectedMenuUser?.annualReportService?.state) === 'New Jersey' && <li>Due Date is the last day of the anniversary month of the following year</li>}
                      {(annualReportState || selectedMenuUser?.annualReportService?.state) === 'Florida' && <li>Due between January 1 - May 1 each year. Final deadline: May 1st (by 11:59 PM)</li>}
                      {(annualReportState || selectedMenuUser?.annualReportService?.state) === 'Pennsylvania' && (<><li><strong>LLC:</strong> Due Date is September 30th of the following year</li><li><strong>C-Corp:</strong> Due Date is June 30th of the following year</li></>)}
                      {(annualReportState || selectedMenuUser?.annualReportService?.state) === 'Washington' && <li>Due Date is the last day of the anniversary month of the following year</li>}
                    </ul>
                  </div>
                )}

                <button 
                  onClick={async () => { 
                    const s = annualReportState || selectedMenuUser?.annualReportService?.state; 
                    const e = annualReportEntityType || selectedMenuUser?.annualReportService?.entityType; 
                    const r = annualReportRegistrationDate || formatDateForInput(selectedMenuUser?.annualReportService?.registrationDate); 
                    const y = annualReportYearsToAdd !== "" ? annualReportYearsToAdd : (selectedMenuUser?.annualReportService?.yearsToAdd || 0); 
                    if (s && e && r && !isSavingAnnualReportDueDate) { 
                      setIsSavingAnnualReportDueDate(true);
                      try {
                        await handleAnnualReportServiceUpdate(selectedMenuUser._id, s, e, r, y); 
                        setAnnualReportState(""); 
                        setAnnualReportEntityType(""); 
                        setAnnualReportRegistrationDate(""); 
                        setAnnualReportYearsToAdd(""); 
                        setShowEntityTypeSelect(false); 
                      } finally {
                        setIsSavingAnnualReportDueDate(false);
                      }
                    } 
                  }} 
                  disabled={isSavingAnnualReportDueDate || !(annualReportState || selectedMenuUser?.annualReportService?.state) || !(annualReportEntityType || selectedMenuUser?.annualReportService?.entityType) || !(annualReportRegistrationDate || selectedMenuUser?.annualReportService?.registrationDate)} 
                  className="w-full px-4 py-2.5 bg-green-600 text-white font-medium rounded-xl hover:bg-green-700 disabled:opacity-50 flex items-center justify-center gap-2 cursor-pointer transition-all"
                >
                  {isSavingAnnualReportDueDate ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                      <span>Saving & Calculating...</span>
                    </>
                  ) : (
                    <span>Save & Calculate Due Date</span>
                  )}
                </button>

                {selectedMenuUser?.annualReportService?.dueDate && (
                  <div className="p-5 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/10 dark:to-indigo-900/10 rounded-2xl border border-blue-100 dark:border-blue-800">
                    <div className="flex items-center justify-between mb-3">
                      <h6 className="font-bold text-blue-900 dark:text-blue-300 flex items-center gap-2">
                        <FaInfoCircle className="text-blue-500" /> Current Annual Report Status
                      </h6>
                      <button 
                        onClick={() => handleRemoveAnnualReportService(selectedMenuUser._id)}
                        className="px-3 py-1 bg-red-100 hover:bg-red-200 text-red-600 text-[10px] font-bold rounded-lg transition-colors flex items-center gap-1.5"
                      >
                        <FaTrash className="w-2.5 h-2.5" /> Remove Setup
                      </button>
                    </div>
                    <div className="grid grid-cols-3 gap-4 mb-4">
                      <div className="p-3 bg-white dark:bg-dark-800 rounded-xl shadow-sm border border-gray-100 dark:border-dark-700">
                        <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">State</p>
                        <div className="text-sm font-bold text-gray-900 dark:text-white">{selectedMenuUser.annualReportService.state}</div>
                      </div>
                      <div className="p-3 bg-white dark:bg-dark-800 rounded-xl shadow-sm border border-gray-100 dark:border-dark-700">
                        <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">Entity Type</p>
                        <div className="text-sm font-bold text-gray-900 dark:text-white">{selectedMenuUser.annualReportService.entityType}</div>
                      </div>
                      <div className="p-3 bg-white dark:bg-dark-800 rounded-xl shadow-sm border border-gray-100 dark:border-dark-700">
                        <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">Filing Year</p>
                        <div className="text-sm font-bold text-gray-900 dark:text-white">{selectedMenuUser.annualReportService.filingYear || 'N/A'}</div>
                      </div>
                    </div>
                    <div className="p-4 bg-white dark:bg-dark-800 rounded-xl border border-gray-100 dark:border-dark-700">
                      <p className="text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase mb-2">Due Date Display</p>
                      {(() => {
                        const text = selectedMenuUser.annualReportService.dueDateText || formatDateForDisplay(selectedMenuUser.annualReportService.dueDate);
                        const deadlineMatch = text.match(/(.*)\s*\((Final deadline:.*)\)/);
                        return (
                          <div className="space-y-3">
                            {deadlineMatch ? (
                              <div className="space-y-2">
                                <div className="flex items-center justify-between">
                                  <span className="text-xs text-gray-500">Window:</span>
                                  <span className="text-xs font-bold text-gray-900 dark:text-white">{deadlineMatch[1].trim()}</span>
                                </div>
                                <div className="flex items-center justify-between pt-2 border-t border-gray-50 dark:border-dark-700">
                                  <span className="text-xs text-red-500 font-bold">Deadline:</span>
                                  <span className="text-xs font-black text-red-600 animate-pulse">{deadlineMatch[2].replace('Final deadline:', '').replace(')', '').trim()}</span>
                                </div>
                              </div>
                            ) : (
                              <div className="text-red-600 font-black text-lg">{text}</div>
                            )}
                            <button
                              onClick={() => handleSendAnnualReportReminder(selectedMenuUser._id)}
                              disabled={manualReminderLoading}
                              className="w-full flex items-center justify-center gap-2 py-2 bg-primary-50 hover:bg-primary-100 text-primary-600 text-[10px] font-bold rounded-lg transition-all"
                            >
                              {manualReminderLoading ? <div className="w-3 h-3 border-2 border-primary-600 border-t-transparent rounded-full animate-spin" /> : <FaBell />}
                              Send Instant Reminder
                            </button>
                            {renderReminderTracking(selectedMenuUser.annualReportService.oneMonthReminderSent, selectedMenuUser.annualReportService.fifteenDayReminderSent)}
                          </div>
                        );
                      })()}
                    </div>
                  </div>
                )}

                {selectedMenuUser?.annualReportService?.dueDate && (
                  <div className="mt-4 space-y-3">
                    <h5 className="font-bold text-gray-900 dark:text-white">Annual Report Payment / Lock</h5>
                    <div className="grid gap-3 sm:grid-cols-2">
                      <div className={formCardClass}>
                        <label className={formLabelClass}>Payment Status</label>
                        <select
                          value={
                            selectedMenuUser?.annualReportPaymentStatus
                            || (selectedMenuUser?.annualReportLocked ? 'unpaid' : 'paid')
                          }
                          onChange={(e) => {
                            if (handleAnnualReportPaymentStatusUpdate) {
                              handleAnnualReportPaymentStatusUpdate(selectedMenuUser._id, e.target.value);
                            }
                          }}
                          className={formSelectClass}
                        >
                          <option value="paid">Paid (Unlocked)</option>
                          <option value="unpaid">Unpaid (Locked)</option>
                        </select>
                        <p className="mt-2 text-[10px] text-gray-500 dark:text-gray-400">
                          Unpaid locks step cards for the client until payment.
                        </p>
                      </div>
                      <div className={`p-4 rounded-xl border flex flex-col justify-center ${
                        selectedMenuUser?.annualReportLocked
                          ? 'bg-orange-50 dark:bg-orange-900/20 border-orange-200 dark:border-orange-800'
                          : 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800'
                      }`}>
                        <div className="flex items-center justify-between gap-3">
                          <div className="flex items-center gap-2">
                            {selectedMenuUser?.annualReportLocked ? (
                              <>
                                <FaLock className="text-orange-500" />
                                <span className="font-medium text-orange-700 dark:text-orange-400">Locked</span>
                              </>
                            ) : (
                              <>
                                <FaUnlock className="text-green-500" />
                                <span className="font-medium text-green-700 dark:text-green-400">Unlocked</span>
                              </>
                            )}
                          </div>
                          {selectedMenuUser?.annualReportLocked && handleUnlockAnnualReport && (
                            <button
                              type="button"
                              onClick={() => handleUnlockAnnualReport(selectedMenuUser._id)}
                              className="px-3 py-1.5 bg-green-600 text-white text-xs font-semibold rounded-lg hover:bg-green-700 inline-flex items-center gap-1.5"
                            >
                              <FaUnlock /> Unlock
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {(selectedMenuUser?.annualReportService?.state === 'Florida' || 
                  selectedMenuUser?.annualReportService?.state === 'Wyoming' || 
                  selectedMenuUser?.annualReportService?.state === 'New Jersey' ||
                  selectedMenuUser?.annualReportService?.state === 'Delaware') && (
                  <div className="mt-8 pt-6 border-t border-gray-100 dark:border-dark-700">
                    <h5 className="font-bold text-gray-900 dark:text-white mb-4">Annual Report Workflow Management</h5>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* Step 1: Checklist */}
                      <div className={`p-4 rounded-xl border-2 transition-all ${
                        selectedMenuUser?.annualReportSteps?.find(s => s.step === 1)?.status === 'submitted' 
                        ? 'bg-green-50 dark:bg-green-900/10 border-green-200 dark:border-green-800' 
                        : 'bg-gray-50 dark:bg-dark-900/50 border-gray-200 dark:border-dark-700'
                      }`}>
                        <div className="flex items-center justify-between mb-2">
                          <span className="text-xs font-bold text-gray-500 uppercase">Step 1</span>
                          {selectedMenuUser?.annualReportSteps?.find(s => s.step === 1)?.status === 'submitted' ? (
                            <span className="px-2 py-0.5 bg-green-500 text-white text-[10px] font-bold rounded-full uppercase">Submitted</span>
                          ) : selectedMenuUser?.annualReportSteps?.find(s => s.step === 1)?.status === 'in-progress' ? (
                            <span className="px-2 py-0.5 bg-blue-500 text-white text-[10px] font-bold rounded-full uppercase">Draft Saved</span>
                          ) : null}
                        </div>
                        <h6 className="font-bold text-gray-900 dark:text-white text-sm mb-1">
                          {selectedMenuUser?.annualReportService?.state} Initial Information Required
                        </h6>
                        <p className="text-[10px] text-gray-500 mb-3">User fills and submits business details.</p>
                        {selectedMenuUser?.annualReportSteps?.find(s => s.step === 1)?.status === 'submitted' && (
                          <div className="flex flex-col gap-2 mt-3">
                            {selectedMenuUser?.annualReportSteps?.find(s => s.step === 1)?.pdfUrl && (
                              <a 
                                href={`${process.env.REACT_APP_API_BASE_URL}${selectedMenuUser.annualReportSteps.find(s => s.step === 1).pdfUrl}`} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-1.5 text-xs font-bold text-primary-600 hover:text-primary-700"
                              >
                                <FaFilePdf /> View Submitted PDF
                              </a>
                            )}
                            <button
                              onClick={() => handleReopenAnnualReportChecklist(selectedMenuUser._id)}
                              className="w-full py-1.5 bg-amber-100 hover:bg-amber-200 text-amber-700 text-[10px] font-bold rounded-lg transition-all flex items-center justify-center gap-1.5"
                            >
                              <FaUnlock className="w-3 h-3" /> Re-open for User
                            </button>
                          </div>
                        )}
                      </div>

                      {/* Step 2: Annual Report Filed */}
                      {(() => {
                        const step2RawStatus = selectedMenuUser?.annualReportSteps?.find(s => s.step === 2)?.status || 'pending';
                        const step1Submitted = selectedMenuUser?.annualReportSteps?.find(s => s.step === 1)?.status === 'submitted';
                        const step2Status = step1Submitted && step2RawStatus !== 'submitted'
                          ? (step2RawStatus === 'pending' ? 'in-progress' : step2RawStatus)
                          : step2RawStatus;
                        const step2CardClass = step2Status === 'submitted'
                          ? 'bg-green-50 dark:bg-green-900/10 border-green-200 dark:border-green-800'
                          : step2Status === 'in-progress'
                          ? 'bg-slate-100 dark:bg-slate-900/40 border-slate-300 dark:border-slate-600'
                          : 'bg-amber-50 dark:bg-amber-900/10 border-amber-200 dark:border-amber-800';
                        return (
                      <div className={`p-4 rounded-xl border-2 transition-all ${step2CardClass}`}>
                        <div className="flex items-center justify-between mb-2">
                          <span className="text-xs font-bold text-gray-500 uppercase">Step 2</span>
                          {step2Status === 'submitted' ? (
                            <span className="px-2 py-0.5 bg-green-500 text-white text-[10px] font-bold rounded-full uppercase">Completed</span>
                          ) : step2Status === 'in-progress' ? (
                            <span className="px-2 py-0.5 bg-slate-600 text-white text-[10px] font-bold rounded-full uppercase">In Progress</span>
                          ) : (
                            <span className="px-2 py-0.5 bg-amber-500 text-white text-[10px] font-bold rounded-full uppercase">Pending</span>
                          )}
                        </div>
                        <h6 className="font-bold text-gray-900 dark:text-white text-sm mb-1">Annual Report Filed</h6>
                        <p className="text-[10px] text-gray-500 mb-3">Admin review and filing completion.</p>
                        <label className={formLabelClass}>Status</label>
                        <select
                          className={formSelectClass}
                          value={step2Status}
                          onChange={(e) => handleAnnualReportStepStatusChange(selectedMenuUser._id, 2, e.target.value)}
                          disabled={!step1Submitted}
                        >
                          {step1Submitted ? (
                            <>
                              <option value="in-progress">In Progress</option>
                              <option value="submitted">Completed</option>
                            </>
                          ) : (
                            <option value="pending">Pending</option>
                          )}
                        </select>
                        {!step1Submitted && (
                          <p className="text-[10px] text-gray-400 mt-2">Available after Step 1 is submitted.</p>
                        )}
                        {step1Submitted && (
                          <p className="text-[10px] text-gray-400 mt-2">User sees In Progress until marked Completed.</p>
                        )}
                      </div>
                        );
                      })()}
                    </div>
                  </div>
                )}

                {Array.isArray(selectedMenuUser?.annualReportHistory) && selectedMenuUser.annualReportHistory.length > 0 && (
                  <div className="mt-8 pt-6 border-t border-gray-100 dark:border-dark-700 space-y-3">
                    <h5 className="font-bold text-gray-900 dark:text-white flex items-center gap-2">
                      <FaHistory className="text-gray-500" /> Previous Filing History ({selectedMenuUser.annualReportHistory.length})
                    </h5>
                    {selectedMenuUser.annualReportHistory.map((historyItem, historyIndex) => (
                      <div
                        key={`ar-admin-history-${historyIndex}-${historyItem.filingYear || historyIndex}`}
                        className="rounded-xl border border-gray-200 dark:border-dark-700 overflow-hidden"
                      >
                        <div className="px-4 py-3 bg-gray-50 dark:bg-dark-800/80 flex flex-wrap items-center justify-between gap-2">
                          <div className="flex flex-wrap items-center gap-2">
                            <span className="text-sm font-bold text-gray-900 dark:text-white">
                              Filing Year {historyItem.filingYear || 'N/A'}
                            </span>
                            {historyItem.entityType && (
                              <span className="px-2 py-0.5 rounded-lg bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 text-xs font-semibold">
                                {historyItem.entityType}
                              </span>
                            )}
                            {historyItem.state && (
                              <span className="px-2 py-0.5 rounded-lg bg-slate-100 dark:bg-dark-700 text-slate-600 dark:text-slate-300 text-xs font-semibold">
                                {historyItem.state}
                              </span>
                            )}
                          </div>
                          <span className="text-xs font-semibold text-green-600 dark:text-green-400">✓ Completed</span>
                        </div>
                        <div className="p-3 grid grid-cols-1 sm:grid-cols-2 gap-2">
                          {(historyItem.steps || []).map((s) => (
                            <div
                              key={`ar-admin-history-${historyIndex}-step-${s.step}`}
                              className="p-3 rounded-lg bg-green-500 text-white text-center min-h-[72px] flex flex-col justify-center"
                            >
                              <div className="text-[10px] font-bold uppercase opacity-80">Step {s.step}</div>
                              <div className="text-xs font-semibold">{s.title}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* Sales Tax Tab */}
            {activeTab === 'sales-tax' && (
              <div className="space-y-4">
                <div className="flex items-center justify-between pb-2 border-b border-gray-100 dark:border-dark-700">
                  <div>
                    <h5 className="font-bold text-gray-900 dark:text-white text-base">Sales Tax Module - Due Date Setup</h5>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Configure state sales tax rules, filing frequency, and track compliance.</p>
                  </div>
                  {selectedMenuUser?.salesTaxService?.dueDate && (
                    <div className="flex items-center gap-2">
                      <span className={`px-2.5 py-1 rounded-full text-xs font-bold flex items-center gap-1.5 ${
                        (selectedMenuUser?.salesTaxService?.emailStatus === 'Sent' || selectedMenuUser?.salesTaxService?.reminderCount > 0)
                          ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300'
                          : selectedMenuUser?.salesTaxService?.emailStatus === 'Failed'
                          ? 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300'
                          : 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300'
                      }`}>
                        <span className={`w-1.5 h-1.5 rounded-full ${
                          (selectedMenuUser?.salesTaxService?.emailStatus === 'Sent' || selectedMenuUser?.salesTaxService?.reminderCount > 0)
                            ? 'bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.8)]'
                            : selectedMenuUser?.salesTaxService?.emailStatus === 'Failed'
                            ? 'bg-red-500'
                            : 'bg-amber-500 animate-pulse'
                        }`} />
                        Email: {(selectedMenuUser?.salesTaxService?.emailStatus === 'Sent' || selectedMenuUser?.salesTaxService?.reminderCount > 0) ? 'Sent' : (selectedMenuUser?.salesTaxService?.emailStatus || 'Pending')}
                      </span>
                      <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400 flex items-center gap-1">
                        <FaCheck className="w-3 h-3" /> Active
                      </span>
                    </div>
                  )}
                </div>

                {/* State Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Select State</label>
                  <select 
                    value={salesTaxState || selectedMenuUser?.salesTaxService?.state || ""} 
                    onChange={(e) => setSalesTaxState(e.target.value)} 
                    className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white"
                  >
                    <option value="">-- Select State --</option>
                    <option value="Virginia">Virginia</option>
                    <option value="Minnesota">Minnesota</option>
                    <option value="Illinois">Illinois</option>
                    <option value="New Jersey">New Jersey</option>
                    <option value="Ohio">Ohio</option>
                  </select>
                </div>

                {/* Entity Type Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Select Entity Type</label>
                  <select 
                    value={salesTaxEntityType || selectedMenuUser?.salesTaxService?.entityType || ""} 
                    onChange={(e) => setSalesTaxEntityType(e.target.value)} 
                    className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white"
                  >
                    <option value="">-- Select Entity Type --</option>
                    <option value="LLC">LLC</option>
                    <option value="C-Corp">C-Corp</option>
                  </select>
                </div>

                {/* Registration Date & Filing Frequency */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Sales Tax Registration Date</label>
                    <input 
                      type="date" 
                      value={salesTaxRegistrationDate || formatDateForInput(selectedMenuUser?.salesTaxService?.registrationDate)} 
                      onChange={(e) => setSalesTaxRegistrationDate(e.target.value)} 
                      className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white" 
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Filing Frequency</label>
                    <select 
                      value={salesTaxFrequency || selectedMenuUser?.salesTaxService?.frequency || "Quarterly"} 
                      onChange={(e) => setSalesTaxFrequency(e.target.value)} 
                      className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white"
                    >
                      <option value="Quarterly">Quarterly</option>
                      <option value="Semi-Annual">Semi-Annual</option>
                      <option value="Annual">Annual</option>
                    </select>
                  </div>
                </div>

                {/* Filing Period & Filing Year (Optional Controls) */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Filing Period / Quarter <span className="text-xs text-gray-400 font-normal">(Optional)</span>
                    </label>
                    <select
                      value={salesTaxPeriod || selectedMenuUser?.salesTaxService?.periodText || ""}
                      onChange={(e) => setSalesTaxPeriod(e.target.value)}
                      className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white"
                    >
                      <option value="">Auto (From Registration Date)</option>
                      {(salesTaxFrequency || selectedMenuUser?.salesTaxService?.frequency || "Quarterly") === 'Quarterly' && (
                        <>
                          <option value="Q1">Q1 (Jan 1 - Mar 31) - Due April 20/23</option>
                          <option value="Q2">Q2 (Apr 1 - Jun 30) - Due July 20/23</option>
                          <option value="Q3">Q3 (Jul 1 - Sep 30) - Due October 20/23</option>
                          <option value="Q4">Q4 (Oct 1 - Dec 31) - Due January 20/23 next year</option>
                        </>
                      )}
                      {(salesTaxFrequency || selectedMenuUser?.salesTaxService?.frequency) === 'Semi-Annual' && (
                        <>
                          <option value="H1">Period 1 (Jan - Jun) - Due July 20/23</option>
                          <option value="H2">Period 2 (Jul - Dec) - Due January 20/23 next year</option>
                        </>
                      )}
                      {(salesTaxFrequency || selectedMenuUser?.salesTaxService?.frequency) === 'Annual' && (
                        <option value="Annual">Full Year Annual Return</option>
                      )}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Filing Year <span className="text-xs text-gray-400 font-normal">(e.g. 2026)</span>
                    </label>
                    <input 
                      type="number" 
                      placeholder="e.g. 2026"
                      value={salesTaxFilingYear || selectedMenuUser?.salesTaxService?.filingYear || ""} 
                      onChange={(e) => setSalesTaxFilingYear(e.target.value)} 
                      className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white" 
                    />
                  </div>
                </div>

                {/* State Due Date Rules Box */}
                {(salesTaxState || selectedMenuUser?.salesTaxService?.state) && (
                  <div className="p-3 bg-blue-50/70 dark:bg-dark-700/60 border border-blue-200/60 dark:border-dark-600 rounded-xl text-sm">
                    <strong className="text-gray-900 dark:text-white flex items-center gap-2">
                      <FaInfoCircle className="text-blue-500" />
                      Due Date Rules for {salesTaxState || selectedMenuUser?.salesTaxService?.state}:
                    </strong>
                    <ul className="mt-2 space-y-1.5 text-xs text-gray-700 dark:text-gray-300 list-disc list-inside">
                      {(salesTaxState || selectedMenuUser?.salesTaxService?.state) === 'New Jersey' && (
                        <>
                          <li><strong>Quarterly:</strong> Due on the 20th of the month following quarter end (Q1: April 20, Q2: July 20, Q3: October 20, Q4: January 20).</li>
                          <li><strong>Annual:</strong> Due January 20th.</li>
                        </>
                      )}
                      {(salesTaxState || selectedMenuUser?.salesTaxService?.state) === 'Virginia' && (
                        <>
                          <li><strong>Quarterly:</strong> Due on the 20th day of the month following quarter end.</li>
                          <li><strong>Semi-Annual:</strong> Due July 20th (Period 1) & January 20th (Period 2).</li>
                          <li><strong>Annual:</strong> Due January 20th.</li>
                        </>
                      )}
                      {(salesTaxState || selectedMenuUser?.salesTaxService?.state) === 'Minnesota' && (
                        <>
                          <li><strong>Quarterly:</strong> Due on the 20th day of the month following quarter end.</li>
                          <li><strong>Annual:</strong> Due February 5th.</li>
                        </>
                      )}
                      {(salesTaxState || selectedMenuUser?.salesTaxService?.state) === 'Illinois' && (
                        <>
                          <li><strong>Quarterly (Form ST-1):</strong> Due on or before the 20th of the month following the quarter end.</li>
                          <li><strong>Annual:</strong> Due January 20th.</li>
                        </>
                      )}
                      {(salesTaxState || selectedMenuUser?.salesTaxService?.state) === 'Ohio' && (
                        <>
                          <li><strong>Semi-Annual (Standard):</strong> Period 1 (Jan-Jun) due July 23rd; Period 2 (Jul-Dec) due January 23rd.</li>
                          <li><strong>Quarterly:</strong> Due on the 23rd of the month following quarter end.</li>
                          <li><strong>Annual:</strong> Due January 23rd.</li>
                        </>
                      )}
                    </ul>
                  </div>
                )}

                {/* Save & Calculate Due Date Button */}
                <button
                  onClick={async () => {
                    const s = salesTaxState || selectedMenuUser?.salesTaxService?.state;
                    const e = salesTaxEntityType || selectedMenuUser?.salesTaxService?.entityType || "LLC";
                    const r = salesTaxRegistrationDate || formatDateForInput(selectedMenuUser?.salesTaxService?.registrationDate) || new Date().toISOString().split('T')[0];
                    const f = salesTaxFrequency || selectedMenuUser?.salesTaxService?.frequency || "Quarterly";
                    const p = salesTaxPeriod !== "" ? salesTaxPeriod : (selectedMenuUser?.salesTaxService?.periodText || "");
                    const y = salesTaxFilingYear !== "" ? salesTaxFilingYear : (selectedMenuUser?.salesTaxService?.filingYear || "");
                    const c = salesTaxCustomDueDate || "";
                    
                    if (s && !isSavingSalesTaxDueDate) {
                      setIsSavingSalesTaxDueDate(true);
                      try {
                        await handleSalesTaxServiceUpdate(selectedMenuUser._id, s, e, r, f, p, y, c);
                        setSalesTaxState("");
                        setSalesTaxEntityType("");
                        setSalesTaxRegistrationDate("");
                        setSalesTaxPeriod("");
                        setSalesTaxFilingYear("");
                        setSalesTaxCustomDueDate("");
                      } finally {
                        setIsSavingSalesTaxDueDate(false);
                      }
                    }
                  }}
                  disabled={isSavingSalesTaxDueDate || !(salesTaxState || selectedMenuUser?.salesTaxService?.state)}
                  className="w-full px-4 py-2.5 bg-green-600 text-white font-medium rounded-xl hover:bg-green-700 disabled:opacity-50 flex items-center justify-center gap-2 cursor-pointer transition-all shadow-md"
                >
                  {isSavingSalesTaxDueDate ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                      <span>Saving & Calculating...</span>
                    </>
                  ) : (
                    <span>Save & Calculate Due Date</span>
                  )}
                </button>

                {/* Active Sales Tax Status Card */}
                {selectedMenuUser?.salesTaxService?.dueDate && (
                  <div className="p-5 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/10 dark:to-indigo-900/10 rounded-2xl border border-blue-100 dark:border-blue-800">
                    <div className="flex items-center justify-between mb-3">
                      <h6 className="font-bold text-blue-900 dark:text-blue-300 flex items-center gap-2">
                        <FaInfoCircle className="text-blue-500" /> Current Sales Tax Status
                      </h6>
                      <button 
                        onClick={() => handleRemoveSalesTaxService(selectedMenuUser._id)}
                        className="px-3 py-1 bg-red-100 hover:bg-red-200 text-red-600 text-[10px] font-bold rounded-lg transition-colors flex items-center gap-1.5 cursor-pointer"
                      >
                        <FaTrash className="w-2.5 h-2.5" /> Remove Setup
                      </button>
                    </div>
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
                      <div className="p-3 bg-white dark:bg-dark-800 rounded-xl shadow-xs border border-gray-100 dark:border-dark-700">
                        <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">State</p>
                        <div className="text-sm font-bold text-gray-900 dark:text-white truncate">{selectedMenuUser.salesTaxService.state}</div>
                      </div>
                      <div className="p-3 bg-white dark:bg-dark-800 rounded-xl shadow-xs border border-gray-100 dark:border-dark-700">
                        <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">Entity</p>
                        <div className="text-sm font-bold text-gray-900 dark:text-white truncate">{selectedMenuUser.salesTaxService.entityType || 'LLC'}</div>
                      </div>
                      <div className="p-3 bg-white dark:bg-dark-800 rounded-xl shadow-xs border border-gray-100 dark:border-dark-700">
                        <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">Frequency</p>
                        <div className="text-sm font-bold text-gray-900 dark:text-white truncate">{selectedMenuUser.salesTaxService.frequency || 'Quarterly'}</div>
                      </div>
                      <div className="p-3 bg-white dark:bg-dark-800 rounded-xl shadow-xs border border-gray-100 dark:border-dark-700">
                        <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">Filing Period</p>
                        <div className="text-sm font-bold text-gray-900 dark:text-white truncate">{selectedMenuUser.salesTaxService.periodText || 'Auto'}</div>
                      </div>
                    </div>

                    <div className="p-4 bg-white dark:bg-dark-800 rounded-xl border border-gray-100 dark:border-dark-700 flex items-center justify-between">
                      <div>
                        <p className="text-[10px] font-bold text-gray-500 uppercase mb-0.5">Calculated Due Date</p>
                        <p className="text-base font-extrabold text-red-600">
                          {selectedMenuUser.salesTaxService.dueDateText || formatDateForDisplay(selectedMenuUser.salesTaxService.dueDate)}
                        </p>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="px-3 py-1 bg-red-50 text-red-600 text-xs font-bold rounded-lg border border-red-200">
                          Due Date Set
                        </span>
                        <span className={`px-3 py-1 text-xs font-bold rounded-lg border flex items-center gap-1.5 ${
                          (selectedMenuUser?.salesTaxService?.emailStatus === 'Sent' || selectedMenuUser?.salesTaxService?.reminderCount > 0)
                            ? 'bg-green-50 text-green-700 border-green-200 dark:bg-green-900/20 dark:text-green-300 dark:border-green-800'
                            : selectedMenuUser?.salesTaxService?.emailStatus === 'Failed'
                            ? 'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/20 dark:text-red-300 dark:border-red-800'
                            : 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/20 dark:text-amber-300 dark:border-amber-800'
                        }`}>
                          <span className={`w-2 h-2 rounded-full ${
                            (selectedMenuUser?.salesTaxService?.emailStatus === 'Sent' || selectedMenuUser?.salesTaxService?.reminderCount > 0)
                              ? 'bg-green-500'
                              : selectedMenuUser?.salesTaxService?.emailStatus === 'Failed'
                              ? 'bg-red-500'
                              : 'bg-amber-500'
                          }`} />
                          Email Status: {(selectedMenuUser?.salesTaxService?.emailStatus === 'Sent' || selectedMenuUser?.salesTaxService?.reminderCount > 0) ? 'Sent' : (selectedMenuUser?.salesTaxService?.emailStatus || 'Pending')}
                        </span>
                      </div>
                    </div>

                    {/* Email Reminder Tracking & Manual Actions */}
                    <div className="p-4 bg-white dark:bg-dark-800 rounded-xl border border-gray-100 dark:border-dark-700 shadow-sm space-y-3 mt-3">
                      <div className="flex items-center justify-between flex-wrap gap-2">
                        <span className="text-[10px] font-bold uppercase tracking-wider text-gray-400 flex items-center gap-1.5">
                          <FaBell className="text-amber-500" /> Reminder Email Status
                        </span>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2.5 text-xs">
                        <div className="p-2.5 bg-gray-50 dark:bg-dark-700/60 rounded-lg border border-gray-100 dark:border-dark-700">
                          <span className="text-[10px] text-gray-400 block font-semibold">Email Status</span>
                          <div className="flex items-center gap-1.5 mt-0.5">
                            <span className={`w-2 h-2 rounded-full ${
                              (selectedMenuUser?.salesTaxService?.emailStatus === 'Sent' || selectedMenuUser?.salesTaxService?.reminderCount > 0)
                                ? 'bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.6)]'
                                : selectedMenuUser?.salesTaxService?.emailStatus === 'Failed'
                                ? 'bg-red-500'
                                : 'bg-amber-500 animate-pulse'
                            }`} />
                            <span className={`font-bold text-xs ${
                              (selectedMenuUser?.salesTaxService?.emailStatus === 'Sent' || selectedMenuUser?.salesTaxService?.reminderCount > 0)
                                ? 'text-green-600 dark:text-green-400'
                                : selectedMenuUser?.salesTaxService?.emailStatus === 'Failed'
                                ? 'text-red-600 dark:text-red-400'
                                : 'text-amber-600 dark:text-amber-400'
                            }`}>
                              {(selectedMenuUser?.salesTaxService?.emailStatus === 'Sent' || selectedMenuUser?.salesTaxService?.reminderCount > 0) ? 'Sent' : (selectedMenuUser?.salesTaxService?.emailStatus || 'Pending')}
                            </span>
                          </div>
                          <span className="block mt-1 text-[9px] text-gray-500 truncate">
                            Client & CC notification
                          </span>
                        </div>

                        <div className="p-2.5 bg-gray-50 dark:bg-dark-700/60 rounded-lg border border-gray-100 dark:border-dark-700">
                          <span className="text-[10px] text-gray-400 block font-semibold">Last Reminder Sent</span>
                          <span className="font-bold text-gray-800 dark:text-gray-200 text-xs block truncate mt-0.5">
                            {selectedMenuUser?.salesTaxService?.lastReminderSentAt 
                              ? new Date(selectedMenuUser.salesTaxService.lastReminderSentAt).toLocaleString('en-US', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
                              : 'Pending / Not Sent'}
                          </span>
                          {selectedMenuUser?.salesTaxService?.lastReminderType && (
                            <span className="inline-block mt-1 text-[9px] font-semibold px-1.5 py-0.5 bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300 rounded">
                              {selectedMenuUser.salesTaxService.lastReminderType === 'manual'
                                ? 'Manual (Admin)'
                                : (selectedMenuUser.salesTaxService.lastReminderType === '15-day'
                                    ? '15-Day Auto Reminder'
                                    : (selectedMenuUser.salesTaxService.lastReminderType === 'daily'
                                        ? 'Daily Reminder'
                                        : 'Due Date Setup'))}
                            </span>
                          )}
                        </div>

                        <div className="p-2.5 bg-gray-50 dark:bg-dark-700/60 rounded-lg border border-gray-100 dark:border-dark-700">
                          <span className="text-[10px] text-gray-400 block font-semibold">Total Reminders</span>
                          <span className="font-bold text-gray-800 dark:text-gray-200 text-xs block mt-0.5">
                            {selectedMenuUser?.salesTaxService?.reminderCount || 0} Sent
                          </span>
                          <span className="block mt-1 text-[9px] text-gray-500 truncate">
                            Sent to Client + CC
                          </span>
                        </div>
                      </div>

                      {/* Manual Send Reminder Button */}
                      <div className="flex gap-2 pt-1">
                        <button
                          type="button"
                          onClick={() => handleSendSalesTaxReminder(selectedMenuUser._id)}
                          disabled={manualSalesTaxReminderLoading}
                          className="flex-1 flex items-center justify-center gap-1.5 py-2 px-3 bg-primary-600 hover:bg-primary-700 text-white text-xs font-bold rounded-lg transition-all disabled:opacity-50 shadow-sm cursor-pointer"
                          title="Send an immediate Sales Tax document upload reminder email to this client"
                        >
                          {manualSalesTaxReminderLoading ? (
                            <div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                          ) : (
                            <FaPaperPlane className="w-3 h-3" />
                          )}
                          <span>Send Reminder Email Now</span>
                        </button>
                      </div>

                      {/* Recent Sales Tax Reminder History */}
                      {selectedMenuUser?.salesTaxService?.reminderLogs && selectedMenuUser.salesTaxService.reminderLogs.length > 0 && (
                        <div className="pt-2 border-t border-gray-100 dark:border-dark-700">
                          <span className="text-[9px] font-bold uppercase tracking-wider text-gray-400 block mb-1.5">Recent Reminder History</span>
                          <div className="space-y-1 max-h-24 overflow-y-auto">
                            {selectedMenuUser.salesTaxService.reminderLogs.slice(-3).reverse().map((log, idx) => (
                              <div key={idx} className="flex items-center justify-between text-[10px] p-1.5 rounded bg-gray-50 dark:bg-dark-700/60 text-gray-600 dark:text-gray-300">
                                <span className="font-medium">
                                  {new Date(log.sentAt).toLocaleString('en-US', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
                                </span>
                                <span className="px-1.5 py-0.5 rounded text-[9px] font-semibold bg-gray-200 dark:bg-dark-600 text-gray-700 dark:text-gray-300 uppercase">
                                  {log.reminderType === '15-day' ? '15-Day Auto' : (log.reminderType === 'manual' ? 'Manual' : (log.reminderType === 'daily' ? 'Daily' : 'Due Date Setup'))}
                                </span>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Workflow Management: Step 1 & Step 2 */}
                <div className="mt-6 pt-6 border-t border-gray-100 dark:border-dark-700">
                  <h5 className="font-bold text-gray-900 dark:text-white mb-4">Sales Tax Workflow Management</h5>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Step 1: Initial Information Required */}
                    {(() => {
                      const step1 = selectedMenuUser?.salesTaxSteps?.find(s => s.step === 1);
                      const isSubmitted = step1?.status === 'submitted' || step1?.status === 'completed';
                      const answers = step1?.answers || {};
                      return (
                        <div className={`p-4 rounded-xl border-2 transition-all ${
                          isSubmitted ? 'bg-green-50 dark:bg-green-900/10 border-green-200 dark:border-green-800' : 'bg-gray-50 dark:bg-dark-900/50 border-gray-200 dark:border-dark-700'
                        }`}>
                          <div className="flex items-center justify-between mb-2">
                            <span className="text-xs font-bold text-gray-500 uppercase">Step 1</span>
                            {isSubmitted ? (
                              <span className="px-2 py-0.5 bg-green-500 text-white text-[10px] font-bold rounded-full uppercase">Submitted</span>
                            ) : (
                              <span className="px-2 py-0.5 bg-blue-500 text-white text-[10px] font-bold rounded-full uppercase">In Progress</span>
                            )}
                          </div>
                          <h6 className="font-bold text-gray-900 dark:text-white text-sm mb-1">
                            {selectedMenuUser?.salesTaxService?.state || 'New Jersey'} Checklist (4 Questions)
                          </h6>
                          <p className="text-[10px] text-gray-500 mb-3">Client submits sales tax financial details.</p>

                          {isSubmitted ? (
                            <div className="space-y-2 mt-2 pt-2 border-t border-green-200 dark:border-green-800 text-xs">
                              <div className="flex justify-between py-1 bg-white/70 dark:bg-dark-800/70 px-2.5 rounded-lg border border-gray-100 dark:border-dark-700">
                                <span className="text-gray-600 dark:text-gray-400">1. Total Gross Receipts:</span>
                                <span className="font-bold text-gray-900 dark:text-white">${answers.grossReceipts || '0.00'}</span>
                              </div>
                              <div className="flex justify-between py-1 bg-white/70 dark:bg-dark-800/70 px-2.5 rounded-lg border border-gray-100 dark:border-dark-700">
                                <span className="text-gray-600 dark:text-gray-400">2. Non-taxable Receipts:</span>
                                <span className="font-bold text-gray-900 dark:text-white">${answers.nonTaxableReceipts || '0.00'}</span>
                              </div>
                              <div className="flex justify-between py-1 bg-white/70 dark:bg-dark-800/70 px-2.5 rounded-lg border border-gray-100 dark:border-dark-700">
                                <span className="text-gray-600 dark:text-gray-400">3. Sales Tax Collected:</span>
                                <span className="font-bold text-emerald-600 dark:text-emerald-400">${answers.salesTaxCollected || '0.00'}</span>
                              </div>
                              <div className="flex justify-between py-1 bg-white/70 dark:bg-dark-800/70 px-2.5 rounded-lg border border-gray-100 dark:border-dark-700">
                                <span className="text-gray-600 dark:text-gray-400">4. Use Tax Due:</span>
                                <span className="font-bold text-gray-900 dark:text-white">${answers.useTaxDue || '0.00'}</span>
                              </div>
                              {step1?.pdfUrl && (
                                <a
                                  href={`${process.env.REACT_APP_API_BASE_URL || ''}${step1.pdfUrl}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="w-full mt-2 py-1.5 bg-indigo-50 hover:bg-indigo-100 text-indigo-700 dark:bg-indigo-950/30 dark:text-indigo-300 text-[10px] font-bold rounded-lg transition-all flex items-center justify-center gap-1.5"
                                >
                                  <FaFilePdf className="w-3 h-3 text-red-500" /> View / Download Submitted PDF
                                </a>
                              )}
                              <button
                                onClick={() => handleSalesTaxStepStatusChange(selectedMenuUser._id, 1, 'in-progress')}
                                className="w-full mt-2 py-1.5 bg-amber-100 hover:bg-amber-200 text-amber-700 text-[10px] font-bold rounded-lg transition-all flex items-center justify-center gap-1.5 cursor-pointer"
                              >
                                <FaUnlock className="w-3 h-3" /> Re-open Checklist for User
                              </button>
                            </div>
                          ) : (
                            <p className="text-xs text-gray-400 italic">Waiting for client to submit the 4-question checklist. A 15-day advance reminder will be sent automatically.</p>
                          )}
                        </div>
                      );
                    })()}

                    {/* Step 2: Sales Tax Filed */}
                    {(() => {
                      const step2 = selectedMenuUser?.salesTaxSteps?.find(s => s.step === 2);
                      const step1Submitted = selectedMenuUser?.salesTaxSteps?.find(s => s.step === 1)?.status === 'submitted';
                      const step2Status = step2?.status || (step1Submitted ? 'in-progress' : 'pending');
                      const cardBg = step2Status === 'completed'
                        ? 'bg-green-50 dark:bg-green-900/10 border-green-200 dark:border-green-800'
                        : step2Status === 'in-progress'
                        ? 'bg-blue-50 dark:bg-blue-900/10 border-blue-200 dark:border-blue-800'
                        : 'bg-gray-50 dark:bg-dark-900/50 border-gray-200 dark:border-dark-700';
                      return (
                        <div className={`p-4 rounded-xl border-2 transition-all ${cardBg}`}>
                          <div className="flex items-center justify-between mb-2">
                            <span className="text-xs font-bold text-gray-500 uppercase">Step 2</span>
                            <span className={`px-2 py-0.5 text-white text-[10px] font-bold rounded-full uppercase ${
                              step2Status === 'completed' ? 'bg-green-500' : step2Status === 'in-progress' ? 'bg-blue-500' : 'bg-gray-400'
                            }`}>
                              {step2Status === 'completed' ? 'Completed' : step2Status === 'in-progress' ? 'In Progress' : 'Pending'}
                            </span>
                          </div>
                          <h6 className="font-bold text-gray-900 dark:text-white text-sm mb-1">Sales Tax Filed</h6>
                          <p className="text-[10px] text-gray-500 mb-3">Admin reviews figures and files sales tax return.</p>

                          <label className={formLabelClass}>Filing Status</label>
                          <select
                            className={formSelectClass}
                            value={step2Status}
                            onChange={(e) => handleSalesTaxStepStatusChange(selectedMenuUser._id, 2, e.target.value)}
                          >
                            <option value="pending">Pending</option>
                            <option value="in-progress">In Progress (Working for Employee)</option>
                            <option value="completed">Completed (Sales Tax Filed)</option>
                          </select>
                          <p className="text-[10px] text-gray-400 mt-2">
                            {step2Status === 'completed' 
                              ? 'Filing marked as complete. User sees Step 2 completed.' 
                              : 'User sees "Working for Employee" while in progress.'}
                          </p>
                        </div>
                      );
                    })()}
                  </div>
                </div>
              </div>
            )}

            {/* Registered Agent Tab */}
            {activeTab === 'registered-agent' && (
              <div className="space-y-6">
                <div>
                  <h5 className="font-bold text-gray-900 dark:text-white text-base">Registered Agent Service – Due Date Setup</h5>
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Manage state registrations and renewal due dates for this client (supports up to 2 states).</p>
                </div>

                {/* Registered Agent Service 1 */}
                <div className="p-4 bg-gray-50 dark:bg-dark-700/60 rounded-2xl border border-gray-200 dark:border-dark-600 space-y-4">
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-bold uppercase tracking-wider text-primary-600 dark:text-primary-400 flex items-center gap-1.5">
                      <span className="w-5 h-5 rounded-full bg-primary-100 dark:bg-primary-900/40 text-primary-600 dark:text-primary-400 flex items-center justify-center text-[11px] font-bold">1</span>
                      Registered Agent Service 1
                    </span>
                    {selectedMenuUser?.registeredAgentService?.dueDate && (
                      <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400">
                        Active
                      </span>
                    )}
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1">Select State</label>
                      <select
                        value={registeredAgentState1}
                        onChange={(e) => setRegisteredAgentState1(e.target.value)}
                        className="w-full px-3.5 py-2.5 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500"
                      >
                        <option value="">-- Select State --</option>
                        {ANNUAL_REPORT_STATES.map((s) => (
                          <option key={s} value={s}>{s}</option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <div className="flex items-center gap-1.5 mb-1">
                        <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300">Renewal Due Date</label>
                        <div className="group relative">
                          <FaInfoCircle className="w-3.5 h-3.5 text-primary-500 cursor-help" />
                          <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 w-60 p-2.5 bg-dark-800 text-white text-xs rounded-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 shadow-xl border border-dark-600 pointer-events-none">
                            <p className="font-semibold mb-1">Automatic Reminders Schedule:</p>
                            <ul className="list-disc list-inside space-y-0.5 text-gray-300 text-[11px]">
                              <li>1 month before the due date</li>
                              <li>15 days before the due date</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <input
                          type="date"
                          value={registeredAgentDueDate1}
                          onChange={(e) => setRegisteredAgentDueDate1(e.target.value)}
                          className="flex-1 px-3.5 py-2.5 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white"
                        />
                        <button
                          type="button"
                          onClick={() => {
                            if (!registeredAgentState1) {
                              alert("Please select a state for Registered Agent Service 1.");
                              return;
                            }
                            if (!registeredAgentDueDate1) {
                              alert("Please select a renewal due date for Registered Agent Service 1.");
                              return;
                            }
                            handleRegisteredAgentDueDateUpdate(selectedMenuUser._id, registeredAgentDueDate1, registeredAgentState1, 1);
                          }}
                          disabled={!registeredAgentState1 || !registeredAgentDueDate1}
                          className="px-4 py-2.5 bg-green-600 text-white text-sm font-medium rounded-xl hover:bg-green-700 disabled:opacity-50 transition-all active:scale-95 shadow-sm shrink-0"
                        >
                          Update
                        </button>
                        {selectedMenuUser?.registeredAgentService?.dueDate && (
                          <button
                            type="button"
                            onClick={() => {
                              if (window.confirm("Are you sure you want to remove Registered Agent Service 1?")) {
                                handleRegisteredAgentDueDateUpdate(selectedMenuUser._id, null, "", 1);
                                setRegisteredAgentState1("");
                                setRegisteredAgentDueDate1("");
                              }
                            }}
                            className="px-3 py-2.5 bg-red-50 text-red-600 font-medium rounded-xl hover:bg-red-600 hover:text-white transition-all active:scale-95 border border-red-200 shrink-0"
                            title="Remove Due Date"
                          >
                            <FaTrash className="w-3.5 h-3.5" />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                  {selectedMenuUser?.registeredAgentService?.dueDate && (
                    <div className="p-3.5 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-100 dark:border-blue-800/30">
                      <div className="flex items-center justify-between mb-2">
                        <h6 className="font-bold text-blue-900 dark:text-blue-300 text-xs">Current Registered Agent Due Date (Service 1)</h6>
                        {selectedMenuUser.registeredAgentService.state && (
                          <span className="text-[11px] font-bold px-2 py-0.5 rounded-full bg-blue-200/70 dark:bg-blue-800 text-blue-800 dark:text-blue-200">
                            {selectedMenuUser.registeredAgentService.state}
                          </span>
                        )}
                      </div>
                      <div className="p-2.5 bg-white dark:bg-dark-800 rounded-lg flex items-center justify-between">
                        <strong className="text-xs text-primary-600">Renewal Due Date:</strong>
                        <span className="text-red-600 font-bold text-sm">{formatDateForDisplay(selectedMenuUser.registeredAgentService.dueDate)}</span>
                      </div>
                      <div className="mt-2.5">
                        <p className="text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase mb-1.5">Automated Reminder Tracking</p>
                        {renderReminderTracking(selectedMenuUser.registeredAgentService.oneMonthReminderSent, selectedMenuUser.registeredAgentService.fifteenDayReminderSent)}
                      </div>
                      <div className="mt-2.5 pt-2.5 border-t border-blue-100 dark:border-blue-800/30 flex items-center justify-between gap-3">
                        <div>
                          <span className="block text-[10px] font-bold uppercase text-gray-500 dark:text-gray-400">Payment Status</span>
                          <select
                            value={selectedMenuUser?.registeredAgentService?.paymentStatus || 'unpaid'}
                            onChange={(e) => {
                              if (handleRegisteredAgentPaymentStatusUpdate) {
                                handleRegisteredAgentPaymentStatusUpdate(selectedMenuUser._id, e.target.value, 1);
                              }
                            }}
                            className="mt-1 px-3 py-1.5 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-lg text-xs font-semibold text-gray-900 dark:text-white"
                          >
                            <option value="paid">Paid</option>
                            <option value="unpaid">Unpaid</option>
                          </select>
                        </div>
                        {selectedMenuUser?.registeredAgentService?.paymentStatus === 'paid' && (
                          <div className="text-right">
                            <span className="text-[10px] text-gray-400 block">Status</span>
                            <span className="text-xs font-semibold text-green-600 dark:text-green-400">
                              {selectedMenuUser?.registeredAgentService?.paidAt ? new Date(selectedMenuUser.registeredAgentService.paidAt).toLocaleDateString() : 'Paid'}
                            </span>
                          </div>
                        )}
                      </div>
                      <button
                        type="button"
                        onClick={() => handleSendManualReminder(selectedMenuUser._id, 1)}
                        disabled={manualReminderLoading1}
                        className="mt-3 w-full flex items-center justify-center gap-2 px-4 py-2 bg-primary-600 text-white text-xs font-bold rounded-xl hover:bg-primary-700 transition-all disabled:opacity-50"
                      >
                        {manualReminderLoading1 ? (
                          <div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        ) : (
                          <>
                            <FaBell className="w-3 h-3" />
                            Send Manual Reminder Now (Service 1)
                          </>
                        )}
                      </button>
                    </div>
                  )}
                </div>

                {/* Registered Agent Service 2 */}
                <div className="p-4 bg-gray-50 dark:bg-dark-700/60 rounded-2xl border border-gray-200 dark:border-dark-600 space-y-4">
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-bold uppercase tracking-wider text-purple-600 dark:text-purple-400 flex items-center gap-1.5">
                      <span className="w-5 h-5 rounded-full bg-purple-100 dark:bg-purple-900/40 text-purple-600 dark:text-purple-400 flex items-center justify-center text-[11px] font-bold">2</span>
                      Registered Agent Service 2
                    </span>
                    {selectedMenuUser?.registeredAgentService?.dueDate2 && (
                      <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400">
                        Active
                      </span>
                    )}
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1">Select State</label>
                      <select
                        value={registeredAgentState2}
                        onChange={(e) => setRegisteredAgentState2(e.target.value)}
                        className="w-full px-3.5 py-2.5 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white focus:ring-2 focus:ring-purple-500"
                      >
                        <option value="">-- Select State --</option>
                        {ANNUAL_REPORT_STATES.map((s) => (
                          <option key={s} value={s}>{s}</option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <div className="flex items-center gap-1.5 mb-1">
                        <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300">Renewal Due Date</label>
                        <div className="group relative">
                          <FaInfoCircle className="w-3.5 h-3.5 text-primary-500 cursor-help" />
                          <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 w-60 p-2.5 bg-dark-800 text-white text-xs rounded-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 shadow-xl border border-dark-600 pointer-events-none">
                            <p className="font-semibold mb-1">Automatic Reminders Schedule:</p>
                            <ul className="list-disc list-inside space-y-0.5 text-gray-300 text-[11px]">
                              <li>1 month before the due date</li>
                              <li>15 days before the due date</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <input
                          type="date"
                          value={registeredAgentDueDate2}
                          onChange={(e) => setRegisteredAgentDueDate2(e.target.value)}
                          className="flex-1 px-3.5 py-2.5 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white"
                        />
                        <button
                          type="button"
                          onClick={() => {
                            if (!registeredAgentState2) {
                              alert("Please select a state for Registered Agent Service 2.");
                              return;
                            }
                            if (!registeredAgentDueDate2) {
                              alert("Please select a renewal due date for Registered Agent Service 2.");
                              return;
                            }
                            handleRegisteredAgentDueDateUpdate(selectedMenuUser._id, registeredAgentDueDate2, registeredAgentState2, 2);
                          }}
                          disabled={!registeredAgentState2 || !registeredAgentDueDate2}
                          className="px-4 py-2.5 bg-green-600 text-white text-sm font-medium rounded-xl hover:bg-green-700 disabled:opacity-50 transition-all active:scale-95 shadow-sm shrink-0"
                        >
                          Update
                        </button>
                        {selectedMenuUser?.registeredAgentService?.dueDate2 && (
                          <button
                            type="button"
                            onClick={() => {
                              if (window.confirm("Are you sure you want to remove Registered Agent Service 2?")) {
                                handleRegisteredAgentDueDateUpdate(selectedMenuUser._id, null, "", 2);
                                setRegisteredAgentState2("");
                                setRegisteredAgentDueDate2("");
                              }
                            }}
                            className="px-3 py-2.5 bg-red-50 text-red-600 font-medium rounded-xl hover:bg-red-600 hover:text-white transition-all active:scale-95 border border-red-200 shrink-0"
                            title="Remove Due Date"
                          >
                            <FaTrash className="w-3.5 h-3.5" />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                  {selectedMenuUser?.registeredAgentService?.dueDate2 && (
                    <div className="p-3.5 bg-purple-50 dark:bg-purple-900/20 rounded-xl border border-purple-100 dark:border-purple-800/30">
                      <div className="flex items-center justify-between mb-2">
                        <h6 className="font-bold text-purple-900 dark:text-purple-300 text-xs">Current Registered Agent Due Date (Service 2)</h6>
                        {selectedMenuUser.registeredAgentService.state2 && (
                          <span className="text-[11px] font-bold px-2 py-0.5 rounded-full bg-purple-200/70 dark:bg-purple-800 text-purple-800 dark:text-purple-200">
                            {selectedMenuUser.registeredAgentService.state2}
                          </span>
                        )}
                      </div>
                      <div className="p-2.5 bg-white dark:bg-dark-800 rounded-lg flex items-center justify-between">
                        <strong className="text-xs text-primary-600">Renewal Due Date:</strong>
                        <span className="text-red-600 font-bold text-sm">{formatDateForDisplay(selectedMenuUser.registeredAgentService.dueDate2)}</span>
                      </div>
                      <div className="mt-2.5">
                        <p className="text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase mb-1.5">Automated Reminder Tracking</p>
                        {renderReminderTracking(selectedMenuUser.registeredAgentService.oneMonthReminderSent2, selectedMenuUser.registeredAgentService.fifteenDayReminderSent2)}
                      </div>
                      <div className="mt-2.5 pt-2.5 border-t border-purple-100 dark:border-purple-800/30 flex items-center justify-between gap-3">
                        <div>
                          <span className="block text-[10px] font-bold uppercase text-gray-500 dark:text-gray-400">Payment Status</span>
                          <select
                            value={selectedMenuUser?.registeredAgentService?.paymentStatus2 || 'unpaid'}
                            onChange={(e) => {
                              if (handleRegisteredAgentPaymentStatusUpdate) {
                                handleRegisteredAgentPaymentStatusUpdate(selectedMenuUser._id, e.target.value, 2);
                              }
                            }}
                            className="mt-1 px-3 py-1.5 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-lg text-xs font-semibold text-gray-900 dark:text-white"
                          >
                            <option value="paid">Paid</option>
                            <option value="unpaid">Unpaid</option>
                          </select>
                        </div>
                        {selectedMenuUser?.registeredAgentService?.paymentStatus2 === 'paid' && (
                          <div className="text-right">
                            <span className="text-[10px] text-gray-400 block">Status</span>
                            <span className="text-xs font-semibold text-green-600 dark:text-green-400">
                              {selectedMenuUser?.registeredAgentService?.paidAt2 ? new Date(selectedMenuUser.registeredAgentService.paidAt2).toLocaleDateString() : 'Paid'}
                            </span>
                          </div>
                        )}
                      </div>
                      <button
                        type="button"
                        onClick={() => handleSendManualReminder(selectedMenuUser._id, 2)}
                        disabled={manualReminderLoading2}
                        className="mt-3 w-full flex items-center justify-center gap-2 px-4 py-2 bg-primary-600 text-white text-xs font-bold rounded-xl hover:bg-primary-700 transition-all disabled:opacity-50"
                      >
                        {manualReminderLoading2 ? (
                          <div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        ) : (
                          <>
                            <FaBell className="w-3 h-3" />
                            Send Manual Reminder Now (Service 2)
                          </>
                        )}
                      </button>
                    </div>
                  )}
                </div>

                {/* Registered Agent Payment History */}
                <div className="p-4 bg-white dark:bg-dark-800/60 rounded-2xl border border-gray-200 dark:border-dark-600 shadow-sm space-y-3">
                  <div className="flex items-center justify-between">
                    <h6 className="font-bold text-gray-900 dark:text-white text-xs flex items-center gap-2">
                      <FaDollarSign className="text-emerald-500" /> Registered Agent Payment History
                    </h6>
                    {raPaymentHistory.length > 0 && (
                      <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-800/40">
                        {raPaymentHistory.length} Record{raPaymentHistory.length !== 1 ? 's' : ''}
                      </span>
                    )}
                  </div>
                  {raPaymentHistory.length > 0 ? (
                    <div className="overflow-x-auto">
                      <table className="w-full text-left text-xs">
                        <thead className="bg-gray-50 dark:bg-dark-700 text-gray-500 dark:text-gray-400 uppercase text-[10px]">
                          <tr>
                            <th className="p-2">Date</th>
                            <th className="p-2">State / Service</th>
                            <th className="p-2">Amount</th>
                            <th className="p-2">Transaction ID</th>
                            <th className="p-2">Status</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100 dark:divide-dark-700">
                          {raPaymentHistory.map((p, idx) => (
                            <tr key={p._id || idx} className="hover:bg-gray-50 dark:hover:bg-dark-700/50">
                              <td className="p-2 whitespace-nowrap text-gray-900 dark:text-white font-medium">
                                {p.createdAt ? new Date(p.createdAt).toLocaleDateString() : 'N/A'}
                              </td>
                              <td className="p-2 whitespace-nowrap">
                                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300 border border-blue-200 dark:border-blue-800/40">
                                  {p.serviceState || p.state || 'Registered Agent'}{p.slot ? ` (Service ${p.slot})` : ''}
                                </span>
                              </td>
                              <td className="p-2 whitespace-nowrap font-bold text-gray-900 dark:text-white">
                                {p.currencySymbol || '$'}{p.displayAmount || (p.paidAmount ? p.paidAmount.toFixed(2) : '125.00')}
                              </td>
                              <td className="p-2 whitespace-nowrap font-mono text-[11px] text-gray-600 dark:text-gray-300">
                                {p.paymentId || p.orderId || '—'}
                              </td>
                              <td className="p-2 whitespace-nowrap">
                                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400">
                                  Paid
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p className="text-xs text-gray-400 italic text-center py-2">No payment records found for Registered Agent.</p>
                  )}
                </div>

                <div className="pt-4 border-t border-gray-100 dark:border-dark-700 mt-4">
                  <h6 className="font-bold text-gray-900 dark:text-white mb-3">Upload Registered Agent Documents</h6>
                  <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">Upload documents that will be visible to the user in their Registered Agent section.</p>
                  
                  <div className="flex flex-col gap-3">
                    <div className="relative">
                      <input
                        type="file"
                        multiple
                        onChange={async (e) => {
                          if (e.target.files && e.target.files.length > 0) {
                            setRegisteredAgentUploading(true);
                            try {
                              await handleRegisteredAgentDocumentUpload(selectedMenuUser._id, e.target.files);
                            } finally {
                              setRegisteredAgentUploading(false);
                            }
                            e.target.value = '';
                          }
                        }}
                        disabled={registeredAgentUploading}
                        className="w-full px-4 py-3 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white text-sm file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-primary-600 file:text-white file:font-semibold hover:file:bg-primary-700 cursor-pointer disabled:opacity-50"
                      />
                      {registeredAgentUploading && (
                        <div className="absolute right-4 top-1/2 -translate-y-1/2">
                          <div className="w-5 h-5 border-2 border-primary-600 border-t-transparent rounded-full animate-spin"></div>
                        </div>
                      )}
                    </div>
                    <p className="text-[10px] text-gray-400">Supported formats: PDF, Images, Word, etc. Max 200MB per file.</p>
                  </div>
                </div>

                {selectedMenuUser?.registeredAgentDocuments?.length > 0 && (
                  <div className="mt-6 border-t border-gray-100 dark:border-dark-700 pt-4">
                    <h6 className="font-bold text-gray-900 dark:text-white mb-3">Uploaded Documents</h6>
                    <div className="space-y-2">
                      {selectedMenuUser.registeredAgentDocuments.map((doc, idx) => (
                        <div key={idx} className="flex items-center justify-between p-3 bg-gray-50 dark:bg-dark-700 rounded-xl border border-gray-100 dark:border-dark-600">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-lg bg-white dark:bg-dark-800 flex items-center justify-center text-primary-500">
                              <FaFileAlt className="w-5 h-5" />
                            </div>
                            <div className="flex flex-col">
                              <span className="text-sm font-medium text-gray-900 dark:text-white line-clamp-1">{doc.originalName}</span>
                              <span className="text-[10px] text-gray-500">{new Date(doc.date).toLocaleDateString()}</span>
                            </div>
                          </div>
                          <div className="flex items-center gap-3">
                            {doc.read ? (
                              <span className="px-2 py-0.5 rounded-full bg-green-50 dark:bg-green-900/20 text-green-600 dark:text-green-400 text-[10px] font-bold uppercase border border-green-100 dark:border-green-800/30 tracking-tight">Read</span>
                            ) : (
                              <span className="px-2 py-0.5 rounded-full bg-orange-50 dark:bg-orange-900/20 text-orange-600 dark:text-orange-400 text-[10px] font-bold uppercase border border-orange-100 dark:border-orange-800/30 tracking-tight">Unread</span>
                            )}
                            <a
                              href={`${process.env.REACT_APP_API_BASE_URL}${doc.fileUrl}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="p-2 text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                              title="Download"
                            >
                              <FaDownload className="w-4 h-4" />
                            </a>
                            <button
                              onClick={() => handleRegisteredAgentDocumentDelete(selectedMenuUser._id, doc._id)}
                              className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                              title="Delete"
                            >
                              <FaTrash className="w-4 h-4" />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Bookkeeping Tab */}
            {activeTab === 'bookkeeping' && (
              <div className="space-y-6">
                <div className="space-y-4">
                  <h6 className="font-bold text-gray-900 dark:text-white flex items-center gap-2">
                    <FaBell className="text-amber-500" /> Due Date Setup
                  </h6>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Select Frequency</label>
                    <select 
                      value={bookkeepingFrequency || selectedMenuUser?.bookkeepingService?.frequency || ""} 
                      onChange={(e) => setBookkeepingFrequency(e.target.value)} 
                      className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white"
                    >
                      <option value="">-- Select Frequency --</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Quarterly">Quarterly</option>
                      <option value="Yearly">Yearly</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center justify-between">
                      <span>Start Date</span>
                      <span className="text-[11px] font-semibold text-indigo-600 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-900/30 px-2 py-0.5 rounded-md">MM-DD-YYYY</span>
                    </label>
                    <div className="relative flex items-center">
                      <input 
                        type="text" 
                        placeholder="MM-DD-YYYY (e.g., 12-10-2026)"
                        value={bookkeepingStartDate !== "" ? bookkeepingStartDate : (formatDateMMDDYYYY(selectedMenuUser?.bookkeepingService?.startDate) || "")} 
                        onChange={(e) => setBookkeepingStartDate(e.target.value)} 
                        className="w-full pl-4 pr-11 py-2.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white font-medium placeholder-gray-400 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 outline-none" 
                      />
                      <button
                        type="button"
                        onClick={() => {
                          if (bookkeepingDatePickerRef.current) {
                            if (typeof bookkeepingDatePickerRef.current.showPicker === 'function') {
                              bookkeepingDatePickerRef.current.showPicker();
                            } else {
                              bookkeepingDatePickerRef.current.focus();
                            }
                          }
                        }}
                        className="absolute right-2.5 p-1.5 text-gray-500 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors rounded-lg hover:bg-gray-200 dark:hover:bg-dark-600"
                        title="Pick date from calendar"
                      >
                        <FaCalendarAlt className="w-4 h-4" />
                      </button>
                      <input
                        ref={bookkeepingDatePickerRef}
                        type="date"
                        tabIndex={-1}
                        className="absolute opacity-0 pointer-events-none w-0 h-0 bottom-0 right-3"
                        onChange={(e) => {
                          if (e.target.value) {
                            const [y, m, d] = e.target.value.split('-');
                            setBookkeepingStartDate(`${m}-${d}-${y}`);
                          }
                        }}
                      />
                    </div>
                    <span className="text-[11px] text-gray-500 dark:text-gray-400 mt-1 block">
                      Format: <strong className="text-gray-700 dark:text-gray-200">MM-DD-YYYY</strong> (e.g., 12-10-2026) or click the calendar icon to select.
                    </span>
                  </div>

                  <div className="p-3 bg-gray-100 dark:bg-dark-700 rounded-xl text-sm">
                    <strong className="text-gray-900 dark:text-white">Due Date Rules:</strong>
                    <ul className="mt-2 space-y-1 text-gray-600 dark:text-gray-400 list-disc list-inside">
                      <li><strong>Monthly:</strong> Due Date is 1 month after the start date (e.g., 12-10-2026 starts, due 01-10-2027)</li>
                      <li><strong>Quarterly:</strong> Due Date is 4 months after the start date (e.g., 10-01-2026 starts, due 02-01-2027)</li>
                      <li><strong>Yearly:</strong> Due Date is 1 year after the start date (e.g., 01-01-2026 starts, due 01-01-2027)</li>
                    </ul>
                  </div>

                  <button 
                    onClick={async () => { 
                      const freq = bookkeepingFrequency || selectedMenuUser?.bookkeepingService?.frequency;
                      const start = bookkeepingStartDate !== "" ? bookkeepingStartDate : formatDateMMDDYYYY(selectedMenuUser?.bookkeepingService?.startDate);
                      if (freq && start && !isSavingBookkeepingDueDate) { 
                        setIsSavingBookkeepingDueDate(true);
                        try {
                          await handleBookkeepingServiceUpdate(selectedMenuUser._id, freq, start); 
                          setBookkeepingFrequency("");
                          setBookkeepingStartDate("");
                        } finally {
                          setIsSavingBookkeepingDueDate(false);
                        }
                      } 
                    }} 
                    disabled={isSavingBookkeepingDueDate || !(bookkeepingFrequency || selectedMenuUser?.bookkeepingService?.frequency) || !(bookkeepingStartDate !== "" ? bookkeepingStartDate : selectedMenuUser?.bookkeepingService?.startDate)} 
                    className="w-full px-4 py-2.5 bg-green-600 text-white font-medium rounded-xl hover:bg-green-700 disabled:opacity-50 flex items-center justify-center gap-2 cursor-pointer transition-all"
                  >
                    {isSavingBookkeepingDueDate ? (
                      <>
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                        <span>Saving & Calculating...</span>
                      </>
                    ) : (
                      <span>Save & Calculate Due Date</span>
                    )}
                  </button>

                  {selectedMenuUser?.bookkeepingService?.dueDate && (
                    <div className="p-5 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/10 dark:to-indigo-900/10 rounded-2xl border border-blue-100 dark:border-blue-800 mt-4 space-y-3">
                      <div className="flex items-center justify-between mb-1">
                        <h6 className="font-bold text-blue-900 dark:text-blue-300 flex items-center gap-2">
                          <FaInfoCircle className="text-blue-500" /> Current Bookkeeping Setup
                        </h6>
                        <button
                          onClick={() => handleRemoveBookkeepingService(selectedMenuUser._id)}
                          className="p-2 bg-red-100 dark:bg-red-900/20 text-red-600 dark:text-red-400 rounded-lg hover:bg-red-200 transition-colors"
                          title="Remove Service"
                        >
                          <FaTrash className="w-3.5 h-3.5" />
                        </button>
                      </div>

                      <div className="grid grid-cols-2 gap-3 text-xs bg-white dark:bg-dark-800 p-4 rounded-xl border border-gray-100 dark:border-dark-700 shadow-sm">
                        <div>
                          <div className="text-gray-400 uppercase font-semibold text-[10px] tracking-wider mb-0.5">Frequency</div>
                          <div className="text-sm font-bold text-gray-900 dark:text-white">{selectedMenuUser.bookkeepingService.frequency}</div>
                        </div>
                        <div>
                          <div className="text-gray-400 uppercase font-semibold text-[10px] tracking-wider mb-0.5">Start Date</div>
                          <div className="text-sm font-bold text-gray-900 dark:text-white">{formatDateMMDDYYYY(selectedMenuUser.bookkeepingService.startDate)}</div>
                        </div>
                        <div className="col-span-2 pt-2 border-t border-gray-100 dark:border-dark-700">
                          <div className="text-gray-400 uppercase font-semibold text-[10px] tracking-wider mb-0.5">Accounting Period</div>
                          <div className="text-xs font-bold text-blue-600 dark:text-blue-400">{selectedMenuUser.bookkeepingService.periodText || "—"}</div>
                        </div>
                        <div className="col-span-2 pt-2 border-t border-gray-100 dark:border-dark-700">
                          <div className="text-gray-400 uppercase font-semibold text-[10px] tracking-wider mb-0.5">Next Due Date</div>
                          <div className="text-sm font-bold text-red-600 dark:text-red-400">{formatDateMMDDYYYY(selectedMenuUser.bookkeepingService.dueDateText || selectedMenuUser.bookkeepingService.dueDate)}</div>
                        </div>
                      </div>

                      {/* Document Status */}
                      {(() => {
                        const isDocUploaded = selectedMenuUser?.bookkeepingService?.documentsUploaded || 
                          selectedMenuUser?.bookkeepingSteps?.find(s => s.step === 1)?.status === 'submitted' || 
                          selectedMenuUser?.bookkeepingSteps?.find(s => s.step === 1)?.status === 'completed';
                        return (
                          <div className="p-3 rounded-xl bg-white dark:bg-dark-800 border border-gray-100 dark:border-dark-700 shadow-sm flex items-center justify-between">
                            <div className="flex items-center gap-2.5">
                              <span className={`w-2.5 h-2.5 rounded-full ${isDocUploaded ? 'bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.6)]' : 'bg-amber-500 animate-pulse'}`} />
                              <div>
                                <div className="text-[10px] uppercase font-bold text-gray-400 tracking-wider">Document Upload Status</div>
                                <div className={`text-xs font-bold ${isDocUploaded ? 'text-green-600 dark:text-green-400' : 'text-amber-600 dark:text-amber-400'}`}>
                                  {isDocUploaded ? 'Documents Uploaded (Daily Reminders Stopped)' : 'Documents Pending (Daily Reminders Active)'}
                                </div>
                              </div>
                            </div>
                            {selectedMenuUser?.bookkeepingService?.documentsUploadedAt && (
                              <span className="text-[10px] text-gray-400 font-medium">
                                {new Date(selectedMenuUser.bookkeepingService.documentsUploadedAt).toLocaleDateString()}
                              </span>
                            )}
                          </div>
                        );
                      })()}

                      {/* Email Reminder Tracking & Manual Actions */}
                      <div className="p-4 bg-white dark:bg-dark-800 rounded-xl border border-gray-100 dark:border-dark-700 shadow-sm space-y-3">
                        <div className="flex items-center justify-between">
                          <span className="text-[10px] font-bold uppercase tracking-wider text-gray-400 flex items-center gap-1.5">
                            <FaBell className="text-amber-500" /> Reminder Email Status
                          </span>
                          <span className={`px-2 py-0.5 rounded-full text-[9px] font-bold uppercase tracking-wider ${
                            selectedMenuUser?.bookkeepingService?.dailyReminderActive !== false && !selectedMenuUser?.bookkeepingService?.documentsUploaded
                              ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300'
                              : 'bg-gray-100 text-gray-600 dark:bg-dark-700 dark:text-gray-400'
                          }`}>
                            {selectedMenuUser?.bookkeepingService?.dailyReminderActive !== false && !selectedMenuUser?.bookkeepingService?.documentsUploaded
                              ? 'Daily Reminders Active'
                              : 'Daily Reminders Stopped'}
                          </span>
                        </div>

                        <div className="grid grid-cols-2 gap-2 text-xs">
                          <div className="p-2.5 bg-gray-50 dark:bg-dark-700/60 rounded-lg border border-gray-100 dark:border-dark-700">
                            <span className="text-[10px] text-gray-400 block font-semibold">Last Reminder Sent</span>
                            <span className="font-bold text-gray-800 dark:text-gray-200 text-xs block truncate mt-0.5">
                              {selectedMenuUser?.bookkeepingService?.lastReminderSentAt 
                                ? new Date(selectedMenuUser.bookkeepingService.lastReminderSentAt).toLocaleString('en-US', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
                                : 'Never'}
                            </span>
                            {selectedMenuUser?.bookkeepingService?.lastReminderType && (
                              <span className="inline-block mt-1 text-[9px] font-semibold px-1.5 py-0.5 bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300 rounded">
                                {selectedMenuUser.bookkeepingService.lastReminderType === 'manual' ? 'Manual (Admin)' : (selectedMenuUser.bookkeepingService.lastReminderType === 'auto-setup' ? 'Due Date Setup' : 'Daily Cron')}
                              </span>
                            )}
                          </div>

                          <div className="p-2.5 bg-gray-50 dark:bg-dark-700/60 rounded-lg border border-gray-100 dark:border-dark-700">
                            <span className="text-[10px] text-gray-400 block font-semibold">Total Reminders</span>
                            <span className="font-bold text-gray-800 dark:text-gray-200 text-xs block mt-0.5">
                              {selectedMenuUser?.bookkeepingService?.reminderCount || 0} Sent
                            </span>
                            <span className="block mt-1 text-[9px] text-gray-500 truncate">
                              {selectedMenuUser?.bookkeepingService?.dailyReminderActive !== false && !selectedMenuUser?.bookkeepingService?.documentsUploaded
                                ? 'Scheduled Daily (9 AM UTC)'
                                : 'Reminders Inactive'}
                            </span>
                          </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="flex gap-2 pt-1">
                          <button
                            type="button"
                            onClick={() => handleSendBookkeepingReminder(selectedMenuUser._id)}
                            disabled={manualBookkeepingReminderLoading}
                            className="flex-1 flex items-center justify-center gap-1.5 py-2 px-3 bg-primary-600 hover:bg-primary-700 text-white text-xs font-bold rounded-lg transition-all disabled:opacity-50 shadow-sm"
                            title="Send an immediate document upload reminder email to this client"
                          >
                            {manualBookkeepingReminderLoading ? (
                              <div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                            ) : (
                              <FaPaperPlane className="w-3 h-3" />
                            )}
                            <span>Send Reminder Email Now</span>
                          </button>

                          <button
                            type="button"
                            onClick={() => handleToggleBookkeepingReminders(selectedMenuUser._id)}
                            disabled={toggleReminderLoading}
                            className={`px-3 py-2 text-xs font-bold rounded-lg border transition-all disabled:opacity-50 flex items-center gap-1.5 ${
                              selectedMenuUser?.bookkeepingService?.dailyReminderActive !== false
                                ? 'bg-amber-50 hover:bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950/20 dark:text-amber-400 dark:border-amber-900/30'
                                : 'bg-green-50 hover:bg-green-100 text-green-700 border-green-200 dark:bg-green-950/20 dark:text-green-400 dark:border-green-900/30'
                            }`}
                            title="Toggle daily automated reminder emails"
                          >
                            {toggleReminderLoading ? (
                              <div className="w-3 h-3 border-2 border-current border-t-transparent rounded-full animate-spin" />
                            ) : (
                              <FaSync className="w-3 h-3" />
                            )}
                            <span>{selectedMenuUser?.bookkeepingService?.dailyReminderActive !== false ? 'Pause Daily' : 'Resume Daily'}</span>
                          </button>
                        </div>

                        {/* Recent Reminder Logs */}
                        {selectedMenuUser?.bookkeepingService?.reminderLogs && selectedMenuUser.bookkeepingService.reminderLogs.length > 0 && (
                          <div className="pt-2 border-t border-gray-100 dark:border-dark-700">
                            <span className="text-[9px] font-bold uppercase tracking-wider text-gray-400 block mb-1.5">Recent Reminder History</span>
                            <div className="space-y-1 max-h-24 overflow-y-auto">
                              {selectedMenuUser.bookkeepingService.reminderLogs.slice(-3).reverse().map((log, idx) => (
                                <div key={idx} className="flex items-center justify-between text-[10px] p-1.5 rounded bg-gray-50 dark:bg-dark-700/60 text-gray-600 dark:text-gray-300">
                                  <span className="font-medium">
                                    {new Date(log.sentAt).toLocaleString('en-US', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
                                  </span>
                                  <span className={`px-1.5 py-0.5 rounded text-[8px] font-bold uppercase ${
                                    log.reminderType === 'manual' ? 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300' : (log.reminderType === 'auto-setup' ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300' : 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300')
                                  }`}>
                                    {log.reminderType === 'manual' ? 'Manual' : (log.reminderType === 'auto-setup' ? 'Setup' : 'Daily Cron')}
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Bookkeeping Steps Status Section */}
                <div className="pt-6 border-t border-gray-100 dark:border-dark-700">
                  <h5 className="font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                    <FaChartLine className="text-primary-500" /> Bookkeeping Steps Status
                  </h5>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {(() => {
                      const defaultBookkeepingSteps = [
                        { step: 1, title: 'Information requirement checklist', status: 'pending' },
                        { step: 2, title: 'Pending Queries', status: 'pending' },
                        { step: 3, title: 'Draft financials', status: 'pending' },
                        { step: 4, title: 'Final Books', status: 'pending' }
                      ];
                      const stepsList = selectedMenuUser?.bookkeepingSteps?.length > 0
                        ? selectedMenuUser.bookkeepingSteps
                        : defaultBookkeepingSteps;

                      // Make sure all 4 steps exist in stepsList
                      const finalSteps = defaultBookkeepingSteps.map(ds => {
                        const existing = stepsList.find(s => s.step === ds.step);
                        return existing ? existing : ds;
                      });

                      return finalSteps.map((step) => {
                        // Filter documents for this step
                        const stepDocs = selectedMenuUser?.documents?.filter(doc => doc.stepNumber === step.step) || [];

                        return (
                          <div 
                            key={step.step} 
                            onClick={(e) => {
                              if (step.step === 3) {
                                setShowStep3Modal(true);
                              }
                            }}
                            className={`p-4 rounded-xl border-2 transition-all relative group ${
                              step.step === 3 
                                ? 'cursor-pointer hover:border-primary-500 dark:hover:border-primary-500 hover:shadow-lg hover:-translate-y-0.5 transform duration-200' 
                                : ''
                            } ${
                              step.status === 'completed'
                                ? 'bg-green-50/50 dark:bg-green-900/10 border-green-200 dark:border-green-800'
                                : step.status === 'submitted'
                                ? 'bg-blue-50/50 dark:bg-blue-900/10 border-blue-200 dark:border-blue-800'
                                : step.status === 'in-progress'
                                ? 'bg-amber-50/50 dark:bg-amber-900/10 border-amber-200 dark:border-amber-800'
                                : step.status === 'client-pending'
                                ? 'bg-purple-50/50 dark:bg-purple-900/10 border-purple-200 dark:border-purple-800'
                                : 'bg-gray-50/50 dark:bg-dark-900/50 border-gray-200 dark:border-dark-700'
                            }`}
                          >
                            <div className="flex items-center justify-between mb-2">
                              <span className="text-[10px] font-bold text-gray-400 uppercase">Step {step.step}</span>
                              <div className="flex items-center gap-1.5">
                                {step.step === 3 && (
                                  <span className="hidden group-hover:inline-block px-1.5 py-0.5 text-[8px] font-bold bg-primary-100 text-primary-700 dark:bg-primary-950/30 dark:text-primary-400 rounded-full transition-all">
                                    Click to Manage
                                  </span>
                                )}
                                <span className={`px-2 py-0.5 text-[9px] font-black rounded-full uppercase tracking-wider ${
                                  step.status === 'completed'
                                    ? 'bg-green-500 text-white'
                                    : step.status === 'submitted'
                                    ? 'bg-blue-500 text-white'
                                    : step.status === 'in-progress'
                                    ? 'bg-amber-500 text-white'
                                    : step.status === 'client-pending'
                                    ? 'bg-purple-500 text-white'
                                    : 'bg-gray-500 text-white'
                                }`}>
                                  {step.status || 'pending'}
                                </span>
                              </div>
                            </div>

                            <h6 className="font-bold text-gray-900 dark:text-white text-xs mb-1.5">
                              {step.title}
                            </h6>

                            <div className="relative mt-3" onClick={(e) => e.stopPropagation()}>
                              <label className="block text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase mb-1">
                                Update Status
                              </label>
                              <div className="relative">
                                <select
                                  value={step.status || 'pending'}
                                  onChange={(e) => handleUpdateBookkeepingStepStatus(step.step, e.target.value)}
                                  disabled={updatingBookkeepingStep[step.step]}
                                  className="w-full pl-3 pr-8 py-2 bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-600 rounded-xl text-xs font-semibold text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 outline-none transition-all appearance-none cursor-pointer"
                                >
                                  <option value="pending">Pending</option>
                                  <option value="in-progress">In Progress</option>
                                  <option value="client-pending">Client Action Pending</option>
                                  <option value="submitted">Submitted</option>
                                  <option value="completed">Completed</option>
                                </select>
                                <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
                                  {updatingBookkeepingStep[step.step] ? (
                                    <div className="w-3.5 h-3.5 border-2 border-primary-600 border-t-transparent rounded-full animate-spin"></div>
                                  ) : (
                                    <FaChevronDown className="w-2.5 h-2.5" />
                                  )}
                                </div>
                              </div>
                            </div>

                            {step.step === 1 && (step.status === 'submitted' || step.status === 'completed') && (
                              <button
                                onClick={() => handleUpdateBookkeepingStepStatus(1, 'in-progress')}
                                className="w-full mt-3 py-1.5 bg-amber-100 hover:bg-amber-200 text-amber-700 text-[10px] font-bold rounded-lg transition-all flex items-center justify-center gap-1.5"
                              >
                                <FaUnlock className="w-3 h-3" /> Re-open for User
                              </button>
                            )}

                            {step.step === 2 && (
                              <button
                                onClick={() => {
                                  setBookkeepingQueries(selectedMenuUser.bookkeepingQueries || []);
                                  if (selectedMenuUser?.bookkeepingEmailSchedule) {
                                    setEmailSchedule({
                                      scheduleType: selectedMenuUser.bookkeepingEmailSchedule.scheduleType || 'immediate',
                                      scheduledDate: selectedMenuUser.bookkeepingEmailSchedule.scheduledDate || '',
                                      scheduledTime: selectedMenuUser.bookkeepingEmailSchedule.scheduledTime || '09:00',
                                      dayOfWeek: selectedMenuUser.bookkeepingEmailSchedule.dayOfWeek || 'Monday'
                                    });
                                  } else {
                                    setEmailSchedule({
                                      scheduleType: 'immediate',
                                      scheduledDate: '',
                                      scheduledTime: '09:00',
                                      dayOfWeek: 'Monday'
                                    });
                                  }
                                  setShowBookkeepingQueriesModal(true);
                                }}
                                className="w-full mt-3 py-1.5 bg-indigo-600 hover:bg-indigo-700 text-white text-[10px] font-bold rounded-lg transition-all flex items-center justify-center gap-1.5"
                              >
                                <FaEye className="w-3 h-3" /> View / Edit Pending Queries
                              </button>
                            )}

                            {step.step === 3 && (
                              <div className="mt-3 space-y-3 pt-3 border-t border-gray-200/50 dark:border-dark-700/50">
                                {step.status === 'client-pending' ? (
                                  <div className="p-3 bg-purple-50/50 dark:bg-purple-950/10 rounded-xl border border-purple-100 dark:border-purple-900/50 text-[11px] leading-relaxed">
                                    <div className="font-bold text-purple-700 dark:text-purple-300 uppercase text-[9px] mb-1">Awaiting Client Approval</div>
                                    {(() => {
                                      const pendingEntry = [...(selectedMenuUser?.bookkeepingStep3History || [])]
                                        .reverse()
                                        .find(h => h.status === 'pending');
                                      return pendingEntry ? (
                                        <p className="text-gray-600 dark:text-gray-400 italic">"{pendingEntry.question}"</p>
                                      ) : null;
                                    })()}
                                  </div>
                                ) : step.status === 'completed' ? (
                                  <div className="p-3 bg-green-50/50 dark:bg-green-950/10 rounded-xl border border-green-100 dark:border-green-900/50 text-[11px] text-green-700 dark:text-green-400 font-medium">
                                    <span className="font-bold uppercase text-[9px] block mb-0.5">Approved</span>
                                    Draft financial statements approved by client.
                                  </div>
                                ) : (() => {
                                  const rejectedEntry = [...(selectedMenuUser?.bookkeepingStep3History || [])]
                                    .reverse()
                                    .find(h => h.status === 'rejected');
                                  return rejectedEntry ? (
                                    <div className="p-3 bg-red-50/50 dark:bg-red-950/10 rounded-xl border border-red-100 dark:border-red-900/50 text-[11px] text-red-700 dark:text-red-400">
                                      <span className="font-bold uppercase text-[9px] block mb-0.5">Feedback Received</span>
                                      <p className="italic">"{rejectedEntry.clientComment}"</p>
                                    </div>
                                  ) : (
                                    <div className="text-[10px] text-gray-400 dark:text-gray-500 italic pb-1">
                                      No draft published yet. Click below to manage draft.
                                    </div>
                                  );
                                })()}

                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setShowStep3Modal(true);
                                  }}
                                  className="w-full py-2 bg-primary-600 hover:bg-primary-700 text-white text-[10px] font-bold rounded-lg transition-all flex items-center justify-center gap-1.5 shadow-sm"
                                >
                                  <FaEye className="w-3.5 h-3.5" /> Manage Draft & Revisions
                                </button>

                                {step.status === 'completed' && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (window.confirm("Are you sure you want to reopen Step 3 (Draft Financials) for this client?\n\nThis will reset the step status back to 'In Progress' and allow you to upload new draft financials or send revised questions to the client.")) {
                                        handleUpdateBookkeepingStepStatus(3, 'in-progress');
                                      }
                                    }}
                                    className="w-full py-2 bg-amber-50 hover:bg-amber-100 dark:bg-amber-950/20 dark:hover:bg-amber-950/30 text-amber-700 dark:text-amber-400 text-[10px] font-bold rounded-lg transition-all flex items-center justify-center gap-1.5 border border-amber-200 dark:border-amber-900/30 shadow-sm"
                                    disabled={updatingBookkeepingStep[3]}
                                  >
                                    {updatingBookkeepingStep[3] ? (
                                      <div className="w-3.5 h-3.5 border-2 border-amber-600 border-t-transparent rounded-full animate-spin"></div>
                                    ) : (
                                      <>
                                        <FaUnlock className="w-3 h-3" /> Reopen Step 3
                                      </>
                                    )}
                                  </button>
                                )}
                              </div>
                            )}

                            {/* Uploaded Documents List */}
                            {stepDocs.length > 0 && (
                              <div className="mt-4 pt-3 border-t border-gray-200/50 dark:border-dark-700/50" onClick={(e) => e.stopPropagation()}>
                                <span className="block text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase mb-2">
                                  Uploaded Files ({stepDocs.length})
                                </span>
                                <div className="space-y-1.5 max-h-36 overflow-y-auto custom-scrollbar">
                                  {stepDocs.map((doc) => (
                                    <div 
                                      key={doc._id} 
                                      className="flex items-center justify-between p-2 bg-white/80 dark:bg-dark-800/80 rounded-lg border border-gray-100 dark:border-dark-700/50 text-[11px]"
                                    >
                                      <div className="flex items-center gap-2 min-w-0 flex-1 mr-2">
                                        <FaFileAlt className="text-primary-500 shrink-0 w-3 h-3" />
                                        <span className="font-medium text-gray-700 dark:text-gray-300 truncate" title={doc.originalName}>
                                          {doc.originalName}
                                        </span>
                                      </div>
                                      <div className="flex items-center gap-1.5 shrink-0">
                                        <a
                                          href={`${process.env.REACT_APP_API_BASE_URL || (typeof API_BASE !== 'undefined' ? API_BASE : '')}${doc.fileUrl}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="p-1 hover:bg-gray-100 dark:hover:bg-dark-700 text-primary-600 rounded-md transition-colors"
                                          title="View Document"
                                        >
                                          <FaEye className="w-3.5 h-3.5" />
                                        </a>
                                        <button
                                          onClick={async () => {
                                            if (window.confirm(`Are you sure you want to delete this bookkeeping document?\n\n"${doc.originalName}"`)) {
                                              try {
                                                const token = localStorage.getItem('adminToken');
                                                await axios.delete(
                                                  `${process.env.REACT_APP_API_BASE_URL || (typeof API_BASE !== 'undefined' ? API_BASE : '')}/api/bookkeeping/${selectedMenuUser._id}/file/${doc._id}`,
                                                  { headers: { Authorization: `Bearer ${token}` } }
                                                );
                                                // Remove locally
                                                const updatedDocs = selectedMenuUser.documents.filter(d => d._id !== doc._id);
                                                setSelectedMenuUser({ ...selectedMenuUser, documents: updatedDocs });
                                                alert("Document deleted successfully!");
                                              } catch (err) {
                                                console.error("Error deleting bookkeeping file:", err);
                                                alert("Failed to delete document.");
                                              }
                                            }
                                          }}
                                          className="p-1 hover:bg-red-50 dark:hover:bg-red-950/20 text-red-600 rounded-md transition-colors"
                                          title="Delete Document"
                                        >
                                          <FaTrash className="w-3 h-3" />
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      });
                    })()}
                  </div>
                </div>

                {/* Bookkeeping Feedback Section */}
                <div className="pt-6 border-t border-gray-100 dark:border-dark-700">
                  <h5 className="font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                    <FaStar className="text-yellow-400" /> Bookkeeping Feedback
                  </h5>
                  {selectedMenuUser?.bookkeepingFeedback?.rating ? (
                    <div className="p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-100 dark:border-yellow-800 rounded-xl">
                      <div className="flex items-center gap-3 mb-2">
                        <div className="flex items-center gap-0.5">
                          {[1, 2, 3, 4, 5].map(star => (
                            <FaStar key={star} size={12} className={`${star <= selectedMenuUser.bookkeepingFeedback.rating ? 'text-yellow-400' : 'text-gray-200'}`} />
                          ))}
                        </div>
                        <span className="text-sm font-bold text-gray-900 dark:text-white">
                          {selectedMenuUser.bookkeepingFeedback.rating}/5
                        </span>
                      </div>
                      {selectedMenuUser.bookkeepingFeedback.comment && (
                        <p className="text-xs text-gray-700 dark:text-gray-300 italic bg-white/50 dark:bg-dark-800/50 p-3 rounded-lg border border-yellow-200 dark:border-yellow-900/50">
                          &ldquo;{selectedMenuUser.bookkeepingFeedback.comment}&rdquo;
                        </p>
                      )}
                      {selectedMenuUser.bookkeepingFeedback.submittedAt && (
                        <p className="text-[10px] text-gray-400 mt-3 flex items-center gap-1">
                          <FaHistory size={8} /> {formatDateForDisplay(selectedMenuUser.bookkeepingFeedback.submittedAt)}
                        </p>
                      )}
                    </div>
                  ) : (
                    <div className="p-4 bg-gray-50 dark:bg-dark-900/30 border border-gray-100 dark:border-dark-700 rounded-xl text-center">
                      <p className="text-xs text-gray-400">No feedback provided yet.</p>
                    </div>
                  )}
                </div>

                {/* Bookkeeping Collaborators Table */}
                <div className="pt-6 border-t border-gray-100 dark:border-dark-700">
                  <h5 className="font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                    <FaUsers className="text-amber-500" /> Bookkeeping Collaborators
                  </h5>
                  
                  {bookkeepingCollaborators.length === 0 ? (
                    <div className="p-6 bg-gray-50 dark:bg-dark-900/30 border border-gray-100 dark:border-dark-700 rounded-2xl text-center text-gray-400 dark:text-gray-500">
                      <div className="flex flex-col items-center justify-center gap-1.5">
                        <FaUsers size={20} className="opacity-40" />
                        <p className="font-medium text-xs">No Collaborators Associated</p>
                        <p className="text-[11px]">Collaborators will appear here once they accept their bookkeeping invitations.</p>
                      </div>
                    </div>
                  ) : (
                    <div className="overflow-x-auto rounded-xl border border-gray-200 dark:border-dark-700 shadow-sm bg-white dark:bg-dark-900/10">
                      <table className="w-full text-left border-collapse text-xs">
                        <thead>
                          <tr className="bg-gray-50 dark:bg-dark-900/50 text-gray-500 dark:text-gray-400 uppercase tracking-wider font-bold">
                            <th className="p-3 border-b border-gray-200 dark:border-dark-700">Name</th>
                            <th className="p-3 border-b border-gray-200 dark:border-dark-700">Email</th>
                            <th className="p-3 border-b border-gray-200 dark:border-dark-700 text-center w-24">Action</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100 dark:divide-dark-700">
                          {bookkeepingCollaborators.map((collab) => (
                            <tr key={collab._id} className="hover:bg-gray-50/50 dark:hover:bg-dark-800/30">
                              <td className="p-3 font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                                <div className="w-6 h-6 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center font-bold text-[10px] text-amber-600 dark:text-amber-400 shrink-0">
                                  {collab.name.charAt(0).toUpperCase()}
                                </div>
                                <span className="truncate max-w-[150px]" title={collab.name}>{collab.name}</span>
                              </td>
                              <td className="p-3 text-gray-600 dark:text-gray-400">
                                <span className="truncate max-w-[200px] block font-mono" title={collab.email}>{collab.email}</span>
                              </td>
                              <td className="p-3 text-center">
                                <button
                                  onClick={() => handleRemoveCollaborator(collab._id, collab.name)}
                                  className="p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-950/20 rounded-lg transition-all cursor-pointer inline-flex items-center gap-1 font-semibold"
                                  title="Remove Collaborator"
                                >
                                  <FaTrash className="w-3 h-3" />
                                  <span>Remove</span>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Quick Payment Tab */}
            {activeTab === 'quick-payment' && (
              <div className="space-y-6">
                <div>
                  <h5 className="font-bold text-gray-900 dark:text-white mb-3 flex items-center gap-2">
                    <FaDollarSign className="text-green-500" /> Quick Payment
                  </h5>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
                    Generate a quick payment link or record a manual payment for this client. This will open the payment management interface.
                  </p>
                  <button
                    onClick={() => {
                      onQuickPayment(selectedMenuUser);
                      setShowMenu(false);
                    }}
                    className="w-full px-4 py-4 bg-green-600 text-white font-bold rounded-2xl hover:bg-green-700 flex items-center justify-center gap-3 transition-all shadow-lg shadow-green-600/20"
                  >
                    <FaDollarSign /> Open Quick Payment Form
                  </button>
                </div>
              </div>
            )}

            {/* Export Data Tab */}
            {activeTab === 'export-data' && (
              <div className="space-y-6">
                <div>
                  <h5 className="font-bold text-gray-900 dark:text-white mb-3 flex items-center gap-2">
                    <FaDownload className="text-indigo-500" /> Export Client Data
                  </h5>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
                    Download a comprehensive export of all data associated with this client, including services, tax filings, and formation details.
                  </p>
                  <button
                    onClick={() => {
                      onExportData(selectedMenuUser);
                      setShowMenu(false);
                    }}
                    className="w-full px-4 py-4 bg-indigo-600 text-white font-bold rounded-2xl hover:bg-indigo-700 flex items-center justify-center gap-3 transition-all shadow-lg shadow-indigo-600/20"
                  >
                    <FaDownload /> Export All Client Data
                  </button>
                </div>
              </div>
            )}

            {/* Documents Tab */}
            {activeTab === 'documents' && (
              <DocumentsManager 
                userId={selectedMenuUser?._id} 
                userName={selectedMenuUser?.name}
                hideBackButton={true} 
              />
            )}

          </div>

          {/* Bookkeeping Queries Modal */}
          {showBookkeepingQueriesModal && createPortal(
            <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-0 z-[9999] animate-fade-in">
              <div className="bg-white dark:bg-dark-800 w-full h-full overflow-hidden shadow-2xl flex flex-col border-none animate-scale-up">
                
                {/* Header */}
                <div className="p-5 border-b border-gray-100 dark:border-dark-700 flex items-center justify-between bg-gray-50/50 dark:bg-dark-900/30">
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 dark:text-white flex items-center gap-2">
                      <FaChartLine className="text-primary-500" /> Bookkeeping Queries Table - {selectedMenuUser?.name}
                    </h3>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                      Configure bookkeeping queries for the client to answer. Add row-level query details and submit.
                    </p>
                  </div>
                  <button 
                    onClick={() => setShowBookkeepingQueriesModal(false)}
                    className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-xl hover:bg-gray-100 dark:hover:bg-dark-700 transition-colors"
                  >
                    <FaTimes size={16} />
                  </button>
                </div>

                {/* Table Body */}
                <div className="p-6 overflow-y-auto flex-1 custom-scrollbar">
                  <div className="overflow-x-auto rounded-xl border border-gray-200 dark:border-dark-700">
                    <table className="w-full text-left border-collapse text-xs">
                      <thead>
                        <tr className="bg-gray-50 dark:bg-dark-900/50 text-gray-500 dark:text-gray-400 uppercase tracking-wider font-bold">
                          <th className="p-3 border-b border-gray-200 dark:border-dark-700 w-16 text-center">SR No</th>
                          <th className="p-3 border-b border-gray-200 dark:border-dark-700 w-36 text-center">Date</th>
                          <th className="p-3 border-b border-gray-200 dark:border-dark-700 w-44">Account Name</th>
                          <th className="p-3 border-b border-gray-200 dark:border-dark-700">Description</th>
                          <th className="p-3 border-b border-gray-200 dark:border-dark-700 w-32">Amount</th>
                          <th className="p-3 border-b border-gray-200 dark:border-dark-700">Bookscomply Comment</th>
                          <th className="p-3 border-b border-gray-200 dark:border-dark-700">Client Comment</th>
                          <th className="p-3 border-b border-gray-200 dark:border-dark-700 w-48">Assigned Email</th>
                          <th className="p-3 border-b border-gray-200 dark:border-dark-700 w-36 text-center">Status / Actions</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100 dark:divide-dark-700">
                        {bookkeepingQueries.length === 0 ? (
                          <tr>
                            <td colSpan="9" className="p-12 text-center text-gray-400 dark:text-gray-500">
                              <div className="flex flex-col items-center justify-center gap-2">
                                <FaChartLine size={24} className="opacity-40" />
                                <p className="font-medium text-sm">No Queries Added Yet</p>
                                <p className="text-xs">Click "+ Add Query Row" below to configure query details.</p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          bookkeepingQueries.map((q, index) => (
                            <React.Fragment key={index}>
                              <tr className="hover:bg-gray-50/50 dark:hover:bg-dark-800/30">
                                <td className="p-3 text-center font-bold text-gray-900 dark:text-white">
                                  {q.srNo}
                                </td>
                                <td className="p-3">
                                  <input
                                    type="date"
                                    value={convertToISODate(q.date || "")}
                                    onChange={(e) => handleQueryCellChange(index, "date", convertToUSDate(e.target.value))}
                                    className="w-full px-2 py-1.5 rounded-lg border border-gray-200 dark:border-dark-600 bg-white dark:bg-dark-900 text-gray-900 dark:text-white text-xs focus:ring-1 focus:ring-primary-500 focus:border-primary-500 outline-none font-semibold text-center cursor-pointer"
                                  />
                                </td>
                                <td className="p-3">
                                  <input
                                    type="text"
                                    value={q.accountName || ""}
                                    onChange={(e) => handleQueryCellChange(index, "accountName", e.target.value)}
                                    className="w-full px-2.5 py-1.5 rounded-lg border border-gray-200 dark:border-dark-600 bg-white dark:bg-dark-900 text-gray-900 dark:text-white text-xs focus:ring-1 focus:ring-primary-500 focus:border-primary-500 outline-none"
                                    placeholder="e.g. Paypal"
                                  />
                                </td>
                                <td className="p-3">
                                  <textarea
                                    value={q.description || ""}
                                    onChange={(e) => handleQueryCellChange(index, "description", e.target.value)}
                                    rows="1"
                                    className="w-full px-2.5 py-1.5 rounded-lg border border-gray-200 dark:border-dark-600 bg-white dark:bg-dark-900 text-gray-900 dark:text-white text-xs focus:ring-1 focus:ring-primary-500 focus:border-primary-500 outline-none resize-y"
                                    placeholder="Describe the transaction query..."
                                  />
                                </td>
                                <td className="p-3">
                                  <input
                                    type="text"
                                    value={q.amount || ""}
                                    onChange={(e) => handleQueryCellChange(index, "amount", e.target.value)}
                                    className="w-full px-2.5 py-1.5 rounded-lg border border-gray-200 dark:border-dark-600 bg-white dark:bg-dark-900 text-gray-900 dark:text-white text-xs focus:ring-1 focus:ring-primary-500 focus:border-primary-500 outline-none"
                                    placeholder="e.g. $1,250.00"
                                  />
                                </td>
                                <td className="p-3">
                                  <textarea
                                    value={q.bookscomplyComment || ""}
                                    onChange={(e) => handleQueryCellChange(index, "bookscomplyComment", e.target.value)}
                                    rows="1"
                                    className="w-full px-2.5 py-1.5 rounded-lg border border-gray-200 dark:border-dark-600 bg-white dark:bg-dark-900 text-gray-900 dark:text-white text-xs focus:ring-1 focus:ring-primary-500 focus:border-primary-500 outline-none resize-y"
                                    placeholder="Add comments or instructions..."
                                  />
                                </td>
                                <td className="p-3">
                                  <textarea
                                    value={q.clientComment || ""}
                                    disabled
                                    rows="1"
                                    className="w-full px-2.5 py-1.5 rounded-lg border border-gray-150 dark:border-dark-650 bg-gray-50 dark:bg-dark-900/50 text-gray-500 dark:text-gray-400 text-xs outline-none cursor-not-allowed"
                                    placeholder="Client comment goes here..."
                                  />
                                </td>
                                <td className="p-3">
                                  <div className="relative w-full">
                                    <input
                                      type="email"
                                      value={q.assignedEmail || ""}
                                      onChange={(e) => handleQueryCellChange(index, "assignedEmail", e.target.value)}
                                      className="w-full px-2.5 py-1.5 pr-8 rounded-lg border border-gray-200 dark:border-dark-600 bg-white dark:bg-dark-900 text-gray-900 dark:text-white text-xs focus:ring-1 focus:ring-primary-500 focus:border-primary-500 outline-none"
                                      placeholder={selectedMenuUser?.email || "user@email.com"}
                                    />
                                    {q.assignedEmail && (
                                      <button
                                        onClick={() => handleQueryCellChange(index, "assignedEmail", "")}
                                        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-400 hover:text-red-500 transition-colors"
                                        title="Remove assigned email"
                                      >
                                        <FaTimes className="w-3 h-3" />
                                      </button>
                                    )}
                                  </div>
                                </td>
                                <td className="p-3 text-center">
                                  <div className="flex items-center justify-center gap-3">
                                    {q.adminSatisfaction === 'yes' || q.adminSecondSatisfaction === 'yes' ? (
                                      <span className="px-2 py-0.5 rounded-full text-[10px] font-black tracking-wide uppercase bg-green-100 text-green-800 dark:bg-green-950/30 dark:text-green-400">
                                        Completed
                                      </span>
                                    ) : !q.isClientSubmitted ? (
                                      <span className="px-2 py-0.5 rounded-full text-[10px] font-black tracking-wide uppercase bg-amber-100 text-amber-800 dark:bg-amber-950/30 dark:text-amber-400">
                                        Client Pending
                                      </span>
                                    ) : !q.isAdminReplied ? (
                                      <span className="px-2 py-0.5 rounded-full text-[10px] font-black tracking-wide uppercase bg-blue-100 text-blue-800 dark:bg-blue-950/30 dark:text-blue-400">
                                        Client Answered
                                      </span>
                                    ) : !q.isClientReplySubmitted ? (
                                      <span className="px-2 py-0.5 rounded-full text-[10px] font-black tracking-wide uppercase bg-purple-100 text-purple-800 dark:bg-purple-950/30 dark:text-purple-400">
                                        Waiting for Client
                                      </span>
                                    ) : !q.isAdminSecondReplied ? (
                                      <span className="px-2 py-0.5 rounded-full text-[10px] font-black tracking-wide uppercase bg-blue-100 text-blue-800 dark:bg-blue-950/30 dark:text-blue-400">
                                        Client Answered
                                      </span>
                                    ) : (
                                      <span className="px-2 py-0.5 rounded-full text-[10px] font-black tracking-wide uppercase bg-green-100 text-green-800 dark:bg-green-950/30 dark:text-green-400">
                                        Completed
                                      </span>
                                    )}
                                    <button
                                      onClick={() => handleRemoveQueryRow(index)}
                                      className="p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-950/20 rounded-lg transition-all"
                                      title="Delete Query"
                                    >
                                      <FaTrash className="w-3.5 h-3.5" />
                                    </button>
                                  </div>
                                </td>
                              </tr>

                              {/* Thread Conversation Sub-row */}
                              {(q.isClientSubmitted || (q.clientComment && q.clientComment.trim())) && (
                                <tr className="bg-gray-50/30 dark:bg-dark-900/10">
                                  <td colSpan="9" className="p-4 border-b border-gray-200 dark:border-dark-700">
                                    <div className="pl-6 border-l-2 border-primary-500 space-y-3 text-left">
                                      {/* Client First Comment (Read-only) */}
                                      <div className="bg-white dark:bg-dark-800 p-3 rounded-xl border border-gray-150 dark:border-dark-700 shadow-sm max-w-4xl">
                                        <div className="flex items-center mb-1">
                                          <span className="text-[10px] font-bold text-primary-600 dark:text-primary-400 uppercase tracking-wider">Client's First Comment</span>
                                        </div>
                                        <p className="text-xs text-gray-700 dark:text-gray-300 whitespace-pre-wrap">{q.clientComment || "N/A"}</p>
                                        
                                        {!q.isAdminReplied && (
                                          <div className="mt-3 pt-3 border-t border-gray-100 dark:border-dark-700 flex flex-wrap items-center gap-4">
                                            <span className="text-xs font-semibold text-gray-700 dark:text-gray-300">Are you satisfied with this comment?</span>
                                            <label className="flex items-center gap-1.5 text-xs text-gray-700 dark:text-gray-300 cursor-pointer">
                                              <input type="radio" name={`satisfaction-1-${index}`} className="w-3.5 h-3.5 text-primary-600" checked={q.adminSatisfaction === 'yes'} onChange={() => handleQueryCellChange(index, "adminSatisfaction", "yes")} disabled={q.isAdminReplied} /> Yes
                                            </label>
                                            <label className="flex items-center gap-1.5 text-xs text-gray-700 dark:text-gray-300 cursor-pointer">
                                              <input type="radio" name={`satisfaction-1-${index}`} className="w-3.5 h-3.5 text-primary-600" checked={q.adminSatisfaction === 'no'} onChange={() => handleQueryCellChange(index, "adminSatisfaction", "no")} disabled={q.isAdminReplied} /> No
                                            </label>
                                          </div>
                                        )}
                                      </div>

                                      {/* Bookscomply Team Reply (Textarea input) */}
                                      {(q.adminSatisfaction === 'no' || q.isAdminReplied) && (
                                        <div className="bg-gradient-to-r from-indigo-50/50 to-purple-50/50 dark:from-indigo-950/10 dark:to-purple-950/10 p-3 rounded-xl border border-indigo-100 dark:border-indigo-900/50 shadow-sm max-w-4xl">
                                          <div className="flex items-center justify-between mb-1.5">
                                            <span className="text-[10px] font-bold text-indigo-600 dark:text-indigo-400 uppercase tracking-wider">Bookscomply Team Reply</span>
                                            {q.isAdminReplied && (
                                              <span className="text-[9px] text-green-600 dark:text-green-400 font-bold uppercase tracking-wider flex items-center gap-1">
                                                <FaCheck className="w-2.5 h-2.5" /> Submitted
                                              </span>
                                            )}
                                          </div>
                                          <textarea
                                            value={q.bookscomplyReply || ""}
                                            onChange={(e) => handleQueryCellChange(index, "bookscomplyReply", e.target.value)}
                                            disabled={q.isAdminReplied}
                                            rows="2"
                                            className="w-full px-2.5 py-1.5 rounded-lg border border-indigo-300 dark:border-dark-600 bg-white dark:bg-dark-900 text-gray-900 dark:text-white text-xs focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 outline-none resize-y disabled:opacity-60 disabled:cursor-not-allowed disabled:bg-gray-50 dark:disabled:bg-dark-900/50 font-medium"
                                            placeholder={q.isAdminReplied ? "Your reply is submitted and locked." : "Type your reply to the client's comment here..."}
                                          />
                                        </div>
                                      )}

                                      {/* Client Follow-up Reply (Read-only) */}
                                      {(q.isClientReplySubmitted || (q.clientReply && q.clientReply.trim())) && (
                                        <>
                                          <div className="bg-white dark:bg-dark-800 p-3 rounded-xl border border-gray-150 dark:border-dark-700 shadow-sm max-w-4xl">
                                            <div className="flex items-center mb-1">
                                              <span className="text-[10px] font-bold text-primary-600 dark:text-primary-400 uppercase tracking-wider">Client's Follow-up Reply</span>
                                            </div>
                                            <p className="text-xs text-gray-700 dark:text-gray-300 whitespace-pre-wrap">{q.clientReply}</p>
                                            
                                            {!q.isAdminSecondReplied && (
                                              <div className="mt-3 pt-3 border-t border-gray-100 dark:border-dark-700 flex flex-wrap items-center gap-4">
                                                <span className="text-xs font-semibold text-gray-700 dark:text-gray-300">Are you satisfied with this comment?</span>
                                                <label className="flex items-center gap-1.5 text-xs text-gray-700 dark:text-gray-300 cursor-pointer">
                                                  <input type="radio" name={`satisfaction-2-${index}`} className="w-3.5 h-3.5 text-primary-600" checked={q.adminSecondSatisfaction === 'yes'} onChange={() => handleQueryCellChange(index, "adminSecondSatisfaction", "yes")} disabled={q.isAdminSecondReplied} /> Yes
                                                </label>
                                                <label className="flex items-center gap-1.5 text-xs text-gray-700 dark:text-gray-300 cursor-pointer">
                                                  <input type="radio" name={`satisfaction-2-${index}`} className="w-3.5 h-3.5 text-primary-600" checked={q.adminSecondSatisfaction === 'no'} onChange={() => handleQueryCellChange(index, "adminSecondSatisfaction", "no")} disabled={q.isAdminSecondReplied} /> No
                                                </label>
                                              </div>
                                            )}
                                          </div>

                                          {/* Bookscomply Team Follow-up Reply (Textarea input) */}
                                          {(q.adminSecondSatisfaction === 'no' || q.isAdminSecondReplied) && (
                                            <div className="bg-gradient-to-r from-indigo-50/50 to-purple-50/50 dark:from-indigo-950/10 dark:to-purple-950/10 p-3 rounded-xl border border-indigo-100 dark:border-indigo-900/50 shadow-sm max-w-4xl">
                                              <div className="flex items-center justify-between mb-1.5">
                                                <span className="text-[10px] font-bold text-indigo-600 dark:text-indigo-400 uppercase tracking-wider">Bookscomply Team Follow-up Reply</span>
                                                {q.isAdminSecondReplied && (
                                                  <span className="text-[9px] text-green-600 dark:text-green-400 font-bold uppercase tracking-wider flex items-center gap-1">
                                                    <FaCheck className="w-2.5 h-2.5" /> Submitted
                                                  </span>
                                                )}
                                              </div>
                                              <textarea
                                                value={q.bookscomplySecondReply || ""}
                                                onChange={(e) => handleQueryCellChange(index, "bookscomplySecondReply", e.target.value)}
                                                disabled={q.isAdminSecondReplied}
                                                rows="2"
                                                className="w-full px-2.5 py-1.5 rounded-lg border border-indigo-300 dark:border-dark-600 bg-white dark:bg-dark-900 text-gray-900 dark:text-white text-xs focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 outline-none resize-y disabled:opacity-60 disabled:cursor-not-allowed disabled:bg-gray-50 dark:disabled:bg-dark-900/50 font-medium"
                                                placeholder={q.isAdminSecondReplied ? "Your second reply is submitted and locked." : "Type your follow-up reply here..."}
                                              />
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="mt-4 flex flex-wrap items-center justify-between gap-4">
                    <button
                      onClick={handleAddQueryRow}
                      className="px-4 py-2 bg-primary-600 hover:bg-primary-700 text-white font-bold rounded-xl transition-all shadow-sm shadow-primary-500/20 flex items-center gap-2 text-xs"
                    >
                      <FaPlus className="w-3 h-3" /> Add Query Row
                    </button>

                    {/* Email Schedule Config Trigger Button */}
                    <button
                      type="button"
                      onClick={() => setShowScheduleModal(true)}
                      className="px-4 py-2 bg-purple-50 dark:bg-purple-950/40 text-purple-700 dark:text-purple-300 hover:bg-purple-100 dark:hover:bg-purple-900/50 border border-purple-200 dark:border-purple-800 rounded-xl text-xs font-bold transition-all flex items-center gap-2 shadow-sm"
                    >
                      <FaCalendarAlt className="w-3.5 h-3.5 text-purple-600 dark:text-purple-400" />
                      <span>Email Schedule:</span>
                      <span className="bg-purple-600 text-white px-2.5 py-0.5 rounded-full text-[10px] font-extrabold uppercase">
                        {emailSchedule.scheduleType === 'immediate' && "⚡ Immediate (Turant)"}
                        {emailSchedule.scheduleType === 'daily' && `⏰ Daily (${emailSchedule.scheduledTime || '09:00'})`}
                        {emailSchedule.scheduleType === 'weekly' && `📅 Every ${emailSchedule.dayOfWeek} (${emailSchedule.scheduledTime || '09:00'})`}
                        {emailSchedule.scheduleType === 'custom_date' && `📆 Date: ${emailSchedule.scheduledDate || 'Not set'} (${emailSchedule.scheduledTime || '09:00'})`}
                      </span>
                    </button>
                  </div>
                </div>

                {/* Footer Actions */}
                <div className="p-5 border-t border-gray-100 dark:border-dark-700 flex items-center justify-end gap-3 bg-gray-50/50 dark:bg-dark-900/30">
                  <button 
                    onClick={() => setShowBookkeepingQueriesModal(false)}
                    className="px-4 py-2.5 bg-gray-100 hover:bg-gray-200 dark:bg-dark-700 dark:hover:bg-dark-600 text-gray-700 dark:text-gray-300 font-bold rounded-xl transition-all"
                  >
                    Cancel
                  </button>
                  <button 
                    onClick={() => handleSaveBookkeepingQueries('draft')}
                    disabled={savingBookkeepingQueries !== false}
                    className="px-4 py-2.5 bg-amber-500 hover:bg-amber-600 text-white font-bold rounded-xl transition-all shadow-sm"
                  >
                    {savingBookkeepingQueries === 'draft' ? "Saving..." : "Save Draft"}
                  </button>
                  <button 
                    onClick={() => handleSaveBookkeepingQueries('client-pending')}
                    disabled={savingBookkeepingQueries !== false || bookkeepingQueries.length === 0}
                    className="px-5 py-2.5 bg-green-600 hover:bg-green-700 text-white font-bold rounded-xl transition-all shadow-sm flex items-center gap-1.5"
                  >
                    {savingBookkeepingQueries === 'client-pending' ? "Submitting..." : emailSchedule.scheduleType === 'immediate' ? "Submit to Client" : "Submit & Activate Schedule"}
                  </button>
                  <button 
                    onClick={() => handleSaveBookkeepingQueries('completed')}
                    disabled={savingBookkeepingQueries !== false || bookkeepingQueries.length === 0}
                    className="px-5 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-xl transition-all shadow-sm"
                  >
                    {savingBookkeepingQueries === 'completed' ? "Finishing..." : "Submit StepCard 2"}
                  </button>
                </div>

              </div>
            </div>,
            document.body
          )}

          {/* Email Schedule Configuration Modal Dialog */}
          {showScheduleModal && createPortal(
            <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-[10000] animate-fade-in">
              <div className="bg-white dark:bg-dark-800 w-full max-w-md rounded-2xl shadow-2xl p-6 border border-gray-100 dark:border-dark-700 animate-scale-up space-y-5">
                <div className="flex items-center justify-between border-b border-gray-100 dark:border-dark-700 pb-3">
                  <h3 className="text-base font-bold text-gray-900 dark:text-white flex items-center gap-2">
                    <FaCalendarAlt className="text-purple-600" /> Email Schedule Configuration
                  </h3>
                  <button onClick={() => setShowScheduleModal(false)} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 p-1">
                    <FaTimes />
                  </button>
                </div>

                <div className="space-y-4 text-xs">
                  <div>
                    <label className="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-2">
                      Select Schedule Type:
                    </label>
                    <div className="grid grid-cols-2 gap-2.5">
                      <button
                        type="button"
                        onClick={() => setEmailSchedule(prev => ({ ...prev, scheduleType: 'immediate' }))}
                        className={`p-3 rounded-xl border text-left font-bold transition-all flex flex-col gap-1 ${
                          emailSchedule.scheduleType === 'immediate'
                            ? 'border-purple-500 bg-purple-50 dark:bg-purple-950/40 text-purple-800 dark:text-purple-200 ring-2 ring-purple-500/20'
                            : 'border-gray-200 dark:border-dark-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-dark-700'
                        }`}
                      >
                        <div className="flex items-center gap-1.5">
                          <span className="text-amber-500">⚡</span>
                          <span>Immediate</span>
                        </div>
                        <span className="text-[10px] font-normal text-gray-500 dark:text-gray-400">Send mail turant upon submission</span>
                      </button>

                      <button
                        type="button"
                        onClick={() => setEmailSchedule(prev => ({ ...prev, scheduleType: 'daily' }))}
                        className={`p-3 rounded-xl border text-left font-bold transition-all flex flex-col gap-1 ${
                          emailSchedule.scheduleType === 'daily'
                            ? 'border-purple-500 bg-purple-50 dark:bg-purple-950/40 text-purple-800 dark:text-purple-200 ring-2 ring-purple-500/20'
                            : 'border-gray-200 dark:border-dark-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-dark-700'
                        }`}
                      >
                        <div className="flex items-center gap-1.5">
                          <span className="text-blue-500">⏰</span>
                          <span>Daily</span>
                        </div>
                        <span className="text-[10px] font-normal text-gray-500 dark:text-gray-400">Send reminder email every day</span>
                      </button>

                      <button
                        type="button"
                        onClick={() => setEmailSchedule(prev => ({ ...prev, scheduleType: 'weekly' }))}
                        className={`p-3 rounded-xl border text-left font-bold transition-all flex flex-col gap-1 ${
                          emailSchedule.scheduleType === 'weekly'
                            ? 'border-purple-500 bg-purple-50 dark:bg-purple-950/40 text-purple-800 dark:text-purple-200 ring-2 ring-purple-500/20'
                            : 'border-gray-200 dark:border-dark-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-dark-700'
                        }`}
                      >
                        <div className="flex items-center gap-1.5">
                          <span className="text-green-500">📅</span>
                          <span>Weekly</span>
                        </div>
                        <span className="text-[10px] font-normal text-gray-500 dark:text-gray-400">Send email once every week</span>
                      </button>

                      <button
                        type="button"
                        onClick={() => setEmailSchedule(prev => ({ ...prev, scheduleType: 'custom_date' }))}
                        className={`p-3 rounded-xl border text-left font-bold transition-all flex flex-col gap-1 ${
                          emailSchedule.scheduleType === 'custom_date'
                            ? 'border-purple-500 bg-purple-50 dark:bg-purple-950/40 text-purple-800 dark:text-purple-200 ring-2 ring-purple-500/20'
                            : 'border-gray-200 dark:border-dark-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-dark-700'
                        }`}
                      >
                        <div className="flex items-center gap-1.5">
                          <span className="text-purple-500">📆</span>
                          <span>Specific Date</span>
                        </div>
                        <span className="text-[10px] font-normal text-gray-500 dark:text-gray-400">One-time date wise schedule</span>
                      </button>
                    </div>
                  </div>

                  {emailSchedule.scheduleType !== 'immediate' && (
                    <div className="p-4 bg-gray-50 dark:bg-dark-900/50 rounded-xl border border-gray-200 dark:border-dark-700 space-y-3">
                      {emailSchedule.scheduleType === 'custom_date' && (
                        <div>
                          <label className="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">
                            Scheduled Date:
                          </label>
                          <input
                            type="date"
                            value={emailSchedule.scheduledDate}
                            onChange={(e) => setEmailSchedule(prev => ({ ...prev, scheduledDate: e.target.value }))}
                            className="w-full px-3 py-2 rounded-xl border border-gray-300 dark:border-dark-600 bg-white dark:bg-dark-800 text-gray-900 dark:text-white font-semibold outline-none focus:ring-2 focus:ring-purple-500/20"
                          />
                        </div>
                      )}

                      {emailSchedule.scheduleType === 'weekly' && (
                        <div>
                          <label className="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1">
                            Select Day of Week:
                          </label>
                          <select
                            value={emailSchedule.dayOfWeek}
                            onChange={(e) => setEmailSchedule(prev => ({ ...prev, dayOfWeek: e.target.value }))}
                            className="w-full px-3 py-2 rounded-xl border border-gray-300 dark:border-dark-600 bg-white dark:bg-dark-800 text-gray-900 dark:text-white font-semibold outline-none focus:ring-2 focus:ring-purple-500/20"
                          >
                            {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(day => (
                              <option key={day} value={day}>{day}</option>
                            ))}
                          </select>
                        </div>
                      )}

                      <div>
                        <label className="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-1 flex items-center gap-1">
                          <FaClock className="text-purple-500" /> Dispatch Time:
                        </label>
                        <input
                          type="time"
                          value={emailSchedule.scheduledTime}
                          onChange={(e) => setEmailSchedule(prev => ({ ...prev, scheduledTime: e.target.value }))}
                          className="w-full px-3 py-2 rounded-xl border border-gray-300 dark:border-dark-600 bg-white dark:bg-dark-800 text-gray-900 dark:text-white font-semibold outline-none focus:ring-2 focus:ring-purple-500/20"
                        />
                      </div>
                    </div>
                  )}

                  <p className="text-[11px] font-medium text-purple-600 dark:text-purple-400 bg-purple-50 dark:bg-purple-950/40 p-2.5 rounded-xl border border-purple-200 dark:border-purple-800">
                    💡 <b>Tip:</b> Schedule settings select karne ke baad neeche <b>"Submit & Activate Schedule"</b> green button par click karna zaroori hai!
                  </p>
                </div>

                <div className="flex justify-end gap-2 pt-2 border-t border-gray-100 dark:border-dark-700">
                  <button
                    type="button"
                    onClick={() => setShowScheduleModal(false)}
                    className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white font-bold rounded-xl transition-all shadow-sm text-xs"
                  >
                    Save Schedule Settings
                  </button>
                </div>
              </div>
            </div>,
            document.body
          )}

          {/* Bookkeeping Step 3 Modal */}
          {showStep3Modal && createPortal(
            <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-0 z-[9999] animate-fade-in" onClick={() => setShowStep3Modal(false)}>
              <div 
                className="bg-white dark:bg-dark-800 w-full h-full shadow-2xl flex flex-col overflow-hidden border-none animate-scale-up"
                onClick={e => e.stopPropagation()}
              >
                {/* Header */}
                <div className="p-6 border-b border-gray-100 dark:border-dark-700 flex items-center justify-between bg-gray-50/50 dark:bg-dark-900/30">
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 dark:text-white flex items-center gap-2">
                      <FaFileAlt className="text-primary-500" /> Bookkeeping Step 3: Draft Financials & Client Decision
                    </h3>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                      Upload draft financials for <strong>{selectedMenuUser?.name}</strong>, ask a custom decision question, and manage previous revision cycles.
                    </p>
                  </div>
                  <button 
                    onClick={() => setShowStep3Modal(false)}
                    className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-xl hover:bg-gray-100 dark:hover:bg-dark-700 transition-colors"
                  >
                    <FaTimes size={16} />
                  </button>
                </div>

                {/* Body split in 2 columns */}
                <div className="flex-1 overflow-hidden flex flex-col md:flex-row bg-white dark:bg-dark-800">
                  
                  {/* Left Column: Upload New Revision */}
                  <div id="publish-new-revision-form" className="w-full md:w-1/2 p-6 border-b md:border-b-0 md:border-r border-gray-100 dark:border-dark-700 overflow-y-auto custom-scrollbar flex flex-col justify-between">
                    <div className="space-y-5">
                      <h4 className="text-xs font-bold text-gray-400 dark:text-gray-500 uppercase tracking-widest flex items-center gap-1.5">
                        <FaFileUpload className="text-primary-500" /> {editStep3HistoryIndex !== null ? 'Update Existing Revision' : 'Publish New Revision'}
                      </h4>

                      {editStep3HistoryIndex !== null && (
                        <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 text-amber-800 dark:text-amber-400 p-3 rounded-lg text-xs font-semibold flex items-center justify-between">
                          <span>Editing Draft History Entry #{editStep3HistoryIndex + 1}</span>
                          <button onClick={() => setEditStep3HistoryIndex(null)} className="text-amber-600 hover:text-amber-800 dark:text-amber-500 dark:hover:text-amber-300 underline">Cancel Edit</button>
                        </div>
                      )}
                      
                      <div className="p-5 bg-gray-50/50 dark:bg-dark-900/30 rounded-2xl border border-dashed border-gray-200 dark:border-dark-700 space-y-4">
                        {/* File Upload Input */}
                        <div className="space-y-2">
                          <label className="block text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                            Select Draft Financial Documents
                          </label>
                          {(!step3Files || step3Files.length === 0) ? (
                            <div className="relative group">
                              <input
                                type="file"
                                multiple
                                id="step3-modal-file-input"
                                onChange={(e) => {
                                  if (e.target.files) {
                                    const newFiles = Array.from(e.target.files);
                                    setStep3Files(prev => [...prev, ...newFiles]);
                                    e.target.value = '';
                                  }
                                }}
                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                              />
                              <div className="flex flex-col items-center justify-center p-6 bg-white dark:bg-dark-800 rounded-xl border border-dashed border-gray-200 dark:border-dark-700 hover:border-primary-500 dark:hover:border-primary-400 hover:bg-primary-50/5 dark:hover:bg-primary-950/5 transition-all text-center">
                                <FaFileUpload className="w-8 h-8 text-gray-400 group-hover:text-primary-500 transition-colors mb-2" />
                                <span className="text-xs font-bold text-gray-700 dark:text-gray-300">Click or drag files here</span>
                                <span className="text-[10px] text-gray-400 mt-1">PDF, Excel, Word formats supported</span>
                              </div>
                            </div>
                          ) : (
                            <div className="space-y-3">
                              {/* Selected Files list */}
                              <div className="p-3 bg-primary-50/30 dark:bg-primary-950/5 rounded-2xl border border-primary-100/50 dark:border-primary-900/20 space-y-2">
                                <span className="text-[10px] font-bold text-primary-700 dark:text-primary-400 uppercase tracking-wider block">Selected Files ({step3Files.length}):</span>
                                <div className="space-y-1.5 max-h-[160px] overflow-y-auto custom-scrollbar pr-0.5">
                                  {Array.from(step3Files).map((file, idx) => (
                                    <div key={idx} className="group/item flex items-center gap-2 text-xs text-gray-600 dark:text-gray-300 bg-white dark:bg-dark-800 px-3 py-2 rounded-xl border border-gray-150 dark:border-dark-700 hover:border-primary-300 dark:hover:border-primary-800 transition-all shadow-sm">
                                      <FaFileAlt className="text-primary-500 w-3.5 h-3.5 shrink-0" />
                                      <span className="truncate flex-1 font-medium">{file.name}</span>
                                      <span className="text-[10px] text-gray-400 shrink-0 bg-gray-50 dark:bg-dark-900 px-1.5 py-0.5 rounded-md">{(file.size / 1024).toFixed(0)} KB</span>
                                      <button
                                        type="button"
                                        onClick={() => handleRemoveFile(idx)}
                                        className="p-1 rounded-lg hover:bg-red-50 dark:hover:bg-red-950/30 text-gray-400 hover:text-red-500 transition-colors shrink-0"
                                        title="Remove file"
                                      >
                                        <FaTrash size={11} />
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              </div>

                              {/* Small drag area to add more files */}
                              <div className="relative group">
                                <input
                                  type="file"
                                  multiple
                                  id="step3-modal-file-input"
                                  onChange={(e) => {
                                    if (e.target.files) {
                                      const newFiles = Array.from(e.target.files);
                                      setStep3Files(prev => [...prev, ...newFiles]);
                                      e.target.value = '';
                                    }
                                  }}
                                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                                />
                                <div className="flex items-center justify-center gap-2.5 p-3 bg-white dark:bg-dark-800 rounded-xl border border-dashed border-gray-250 dark:border-dark-600 hover:border-primary-500 dark:hover:border-primary-400 hover:bg-primary-50/5 dark:hover:bg-primary-950/5 transition-all text-center">
                                  <FaFileUpload className="w-5 h-5 text-gray-400 group-hover:text-primary-500 transition-colors shrink-0" />
                                  <div className="text-left">
                                    <span className="text-xs font-bold text-gray-700 dark:text-gray-300">Click or drag more files here</span>
                                    <span className="text-[9px] text-gray-400 block -mt-0.5">PDF, Excel, Word formats supported</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Question Builder */}
                        <div className="space-y-4 pt-2">
                          <div className="flex justify-between items-center">
                            <label className="block text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                              Client Decision Questions ({step3Questions.length})
                            </label>
                            <button
                              type="button"
                              onClick={handleAddQuestion}
                              className="px-2.5 py-1 bg-primary-50 hover:bg-primary-100 dark:bg-primary-950/20 dark:hover:bg-primary-950/40 text-primary-600 dark:text-primary-400 text-[10px] font-bold rounded-lg border border-primary-200 dark:border-primary-800/30 transition-all flex items-center gap-1 shadow-sm"
                            >
                              + Add Question
                            </button>
                          </div>

                          <div className="space-y-4 max-h-[300px] overflow-y-auto custom-scrollbar pr-1">
                            {step3Questions.map((q, qIdx) => (
                              <div 
                                key={qIdx} 
                                className="p-4 bg-white dark:bg-dark-800 border border-gray-150 dark:border-dark-700 rounded-xl space-y-3 relative group"
                              >
                                {step3Questions.length > 1 && (
                                  <button
                                    type="button"
                                    onClick={() => handleRemoveQuestion(qIdx)}
                                    className="absolute top-3 right-3 text-gray-450 hover:text-red-500 transition-colors p-1"
                                    title="Delete Question"
                                  >
                                    <FaTimes className="w-3.5 h-3.5" />
                                  </button>
                                )}

                                <div className="space-y-1 pr-6">
                                  <span className="text-[9px] font-extrabold text-primary-500 uppercase tracking-wider block">Question {qIdx + 1}</span>
                                  <textarea
                                    rows={2}
                                    value={q.questionText}
                                    onChange={(e) => handleQuestionTextChange(qIdx, e.target.value)}
                                    placeholder="Enter your custom question here..."
                                    className="w-full p-2 text-xs bg-gray-50 dark:bg-dark-900 border border-gray-250 dark:border-dark-700 rounded-lg text-gray-900 dark:text-white outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500 transition-all"
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="mt-6 pt-4 border-t border-gray-100 dark:border-dark-700 flex gap-3">
                      <button 
                        type="button"
                        onClick={() => {
                          setStep3Files([]);
                          setStep3Question("");
                          setStep3Questions([
                            { questionText: "Do you approve of these draft financial statements to proceed to filing?", options: [] }
                          ]);
                          setNewOptionTexts({});
                          setEditStep3HistoryIndex(null);
                          const fileInput = document.getElementById("step3-modal-file-input");
                          if (fileInput) fileInput.value = "";
                        }}
                        className="flex-1 py-3 bg-gray-100 hover:bg-gray-200 dark:bg-dark-700 dark:hover:bg-dark-600 text-gray-700 dark:text-gray-300 text-xs font-bold rounded-2xl transition-all"
                      >
                        Reset Form
                      </button>
                      <button
                        type="button"
                        onClick={() => handleUploadStep3Documents(editStep3HistoryIndex)}
                        disabled={step3Uploading || ((!step3Files || step3Files.length === 0) && editStep3HistoryIndex === null)}
                        className="flex-[2] py-3 bg-primary-600 hover:bg-primary-700 text-white text-xs font-bold rounded-2xl transition-all shadow-lg shadow-primary-500/20 flex items-center justify-center gap-2 disabled:opacity-50"
                      >
                        {step3Uploading ? (
                          <>
                            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                            {editStep3HistoryIndex !== null ? 'Updating...' : 'Publishing Draft...'}
                          </>
                        ) : (
                          <>
                            <FaFileUpload className="w-4 h-4" /> {editStep3HistoryIndex !== null ? 'Update Draft & Send' : 'Publish Draft & Send Questions'}
                          </>
                        )}
                      </button>
                      <button
                        type="button"
                        onClick={() => handleUpdateBookkeepingStepStatus(3, 'completed')}
                        disabled={updatingBookkeepingStep[3]}
                        className="flex-[2] py-3 bg-green-600 hover:bg-green-700 text-white text-xs font-bold rounded-2xl transition-all shadow-lg shadow-green-500/20 flex items-center justify-center gap-2 disabled:opacity-50"
                      >
                        {updatingBookkeepingStep[3] ? (
                          <>
                            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                            Submitting...
                          </>
                        ) : (
                          <>
                            <FaCheck className="w-4 h-4" /> StepCard 3 Submitted
                          </>
                        )}
                      </button>
                    </div>
                  </div>

                  {/* Right Column: Iteration Timeline History */}
                  <div className="w-full md:w-1/2 p-6 bg-gray-50/30 dark:bg-dark-900/10 overflow-y-auto custom-scrollbar flex flex-col justify-between">
                    <div className="space-y-5">
                      <h4 className="text-xs font-bold text-gray-400 dark:text-gray-500 uppercase tracking-widest flex items-center gap-1.5">
                        <FaHistory className="text-purple-500" /> Draft Iteration History
                      </h4>

                      {/* Active Pending Draft inside History Panel for instant highlight */}
                      {selectedMenuUser?.bookkeepingSteps?.find(s => s.step === 3)?.status === 'client-pending' && (() => {
                        const pendingEntry = [...(selectedMenuUser?.bookkeepingStep3History || [])]
                          .reverse()
                          .find(h => h.status === 'pending');
                        if (!pendingEntry) return null;
                        return (
                          <div className="p-4 bg-purple-50/50 dark:bg-purple-950/15 rounded-2xl border border-purple-200 dark:border-purple-900/60 shadow-sm space-y-3">
                            <div className="flex justify-between items-center">
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-[9px] font-black bg-purple-100 dark:bg-purple-900/40 text-purple-700 dark:text-purple-300 uppercase tracking-wider">
                                Awaiting Client Response
                              </span>
                              <span className="text-[9px] text-gray-400 font-bold">
                                {new Date(pendingEntry.uploadedAt).toLocaleDateString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                              </span>
                            </div>
                            {pendingEntry.questions && pendingEntry.questions.length > 0 ? (
                              <div className="space-y-1.5">
                                <span className="block text-[9px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider">
                                  Questions Asked:
                                </span>
                                <div className="space-y-2 pl-2 border-l border-purple-205 dark:border-purple-900/50">
                                  {pendingEntry.questions.map((q, qIdx) => (
                                    <div key={qIdx} className="text-xs text-gray-700 dark:text-gray-300">
                                      <span className="font-semibold">Q{qIdx + 1}:</span> {q.questionText}
                                      <div className="flex flex-wrap gap-1 mt-1">
                                        {q.options?.map((opt, optIdx) => (
                                          <span 
                                            key={optIdx} 
                                            className="px-1.5 py-0.5 rounded bg-gray-100 dark:bg-dark-800 text-[9px] text-gray-500 border border-gray-200 dark:border-dark-700"
                                          >
                                            {opt}
                                          </span>
                                        ))}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ) : (
                              <div className="text-xs font-semibold text-gray-700 dark:text-gray-300">
                                Question: <span className="italic font-normal">"{pendingEntry.question}"</span>
                              </div>
                            )}
                            <div className="space-y-1.5">
                              <span className="block text-[9px] font-bold text-gray-400 uppercase tracking-wider">
                                Draft Documents:
                              </span>
                              {pendingEntry.documents?.map((doc, idx) => (
                                <div key={idx} className="flex items-center justify-between p-2 bg-white dark:bg-dark-800 rounded-xl border border-gray-150 dark:border-dark-700 text-xs">
                                  <span className="truncate font-medium text-gray-600 dark:text-gray-300 flex-1 mr-2">{doc.originalName}</span>
                                  <a
                                    href={`${API_BASE}${doc.fileUrl}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="p-1 hover:bg-gray-50 dark:hover:bg-dark-700 text-primary-600 rounded-lg transition-colors"
                                  >
                                    <FaEye className="w-4 h-4" />
                                  </a>
                                </div>
                              ))}
                            </div>
                          </div>
                        );
                      })()}

                      {/* Timeline */}
                      {!selectedMenuUser?.bookkeepingStep3History || selectedMenuUser.bookkeepingStep3History.length === 0 ? (
                        <div className="flex flex-col items-center justify-center p-12 text-center text-gray-400 dark:text-gray-500 gap-2">
                          <FaHistory size={24} className="opacity-40" />
                          <p className="font-semibold text-xs">No History Found</p>
                          <p className="text-[10px]">Revisions and client interaction logs will populate here.</p>
                        </div>
                      ) : (
                        <div className="space-y-4">
                          {[...(selectedMenuUser.bookkeepingStep3History)].reverse().map((hist, idx) => (
                            <div 
                              key={idx} 
                              className={`p-4 rounded-2xl border transition-all space-y-3 ${
                                hist.status === 'approved'
                                  ? 'bg-green-50/30 dark:bg-green-950/5 border-green-200 dark:border-green-900/60 shadow-sm shadow-green-500/5'
                                  : hist.status === 'rejected'
                                  ? 'bg-red-50/30 dark:bg-red-950/5 border-red-200 dark:border-red-900/60 shadow-sm shadow-red-500/5'
                                  : 'bg-white dark:bg-dark-800 border-gray-200 dark:border-dark-700 shadow-sm'
                              }`}
                            >
                              <div className="flex items-center justify-between">
                                <span className="text-[10px] text-gray-400 dark:text-gray-500 font-bold">
                                  {new Date(hist.uploadedAt).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                                </span>
                                <div className="flex items-center">
                                  <span className={`px-2 py-0.5 rounded-full text-[9px] font-black uppercase tracking-wider ${
                                    hist.status === 'approved'
                                      ? 'bg-green-100 text-green-700 dark:bg-green-950/30 dark:text-green-400 border border-green-200/30'
                                      : hist.status === 'rejected'
                                      ? 'bg-red-100 text-red-700 dark:bg-red-950/30 dark:text-red-400 border border-red-200/30'
                                      : 'bg-purple-100 text-purple-700 dark:bg-purple-950/30 dark:text-purple-400 border border-purple-200/30'
                                  }`}>
                                    {hist.status}
                                  </span>
                                  <button
                                    onClick={() => handleEditDraftHistory(selectedMenuUser.bookkeepingStep3History.length - 1 - idx)}
                                    className="p-1 text-blue-500 hover:text-blue-700 hover:bg-blue-50 dark:hover:bg-blue-950/20 rounded-lg transition-all ml-2"
                                    title="Edit History Entry"
                                  >
                                    <FaEdit className="w-3.5 h-3.5" />
                                  </button>
                                  <button
                                    onClick={() => handleDeleteDraftHistory(selectedMenuUser.bookkeepingStep3History.length - 1 - idx)}
                                    className="p-1 text-red-500 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-950/20 rounded-lg transition-all ml-2"
                                    title="Delete History Entry"
                                  >
                                    <FaTrash className="w-3.5 h-3.5" />
                                  </button>
                                </div>
                              </div>
                              
                              {hist.questions && hist.questions.length > 0 ? (
                                <div className="space-y-2">
                                  <span className="font-bold text-gray-400 dark:text-gray-500 uppercase text-[9px] block mb-0.5">Questions Asked & Answers:</span>
                                  <div className="space-y-2 pl-2 border-l border-purple-200 dark:border-purple-900/50">
                                    {hist.questions.map((q, qIdx) => (
                                      <div key={qIdx} className="text-xs text-gray-700 dark:text-gray-300">
                                        <div className="font-semibold">
                                          Q{qIdx + 1}: {q.questionText}
                                        </div>
                                        <div className="flex flex-wrap gap-1 mt-1">
                                          {q.options?.map((opt, optIdx) => (
                                            <span 
                                              key={optIdx} 
                                              className={`px-1.5 py-0.5 rounded text-[9px] font-bold border transition-all ${
                                                q.selectedAnswer === opt
                                                  ? 'bg-purple-100 text-purple-700 dark:bg-purple-950/40 dark:text-purple-300 border-purple-300 dark:border-purple-800 font-extrabold'
                                                  : 'bg-gray-50 text-gray-455 dark:bg-dark-800 dark:text-gray-500 border-gray-250 dark:border-dark-700'
                                              }`}
                                            >
                                              {opt}
                                            </span>
                                          ))}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              ) : (
                                <div className="text-xs text-gray-700 dark:text-gray-300">
                                  <span className="font-bold text-gray-400 dark:text-gray-500 uppercase text-[9px] block mb-0.5">Question Asked:</span>
                                  <span className="italic">"{hist.question || 'No question added.'}"</span>
                                </div>
                              )}

                              <div className="space-y-1">
                                <span className="font-bold text-gray-400 dark:text-gray-500 uppercase text-[9px] block mb-0.5">Uploaded Documents:</span>
                                {hist.documents?.map((doc, docIdx) => (
                                  <div key={docIdx} className="flex items-center justify-between p-2 bg-white dark:bg-dark-800 rounded-xl border border-gray-150 dark:border-dark-700/50 text-xs">
                                    <span className="truncate text-gray-600 dark:text-gray-300 flex-1 mr-2">{doc.originalName}</span>
                                    <a
                                      href={`${API_BASE}${doc.fileUrl}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="p-1 hover:bg-gray-50 dark:hover:bg-dark-700 text-primary-600 rounded-lg"
                                    >
                                      <FaEye className="w-3.5 h-3.5" />
                                    </a>
                                  </div>
                                ))}
                              </div>

                              {hist.status === 'rejected' && hist.clientComment && (
                                <div className="p-2.5 bg-red-50/50 dark:bg-red-950/15 border-l-4 border-red-500 rounded-r-xl text-xs text-red-700 dark:text-red-400">
                                  <span className="font-bold text-[9px] uppercase tracking-wide block mb-0.5">Client Feedback / Comment:</span>
                                  <span className="italic font-medium">"{hist.clientComment}"</span>
                                </div>
                              )}

                              {hist.clientActionAt && (
                                <div className="text-[9px] text-gray-400 dark:text-gray-500 text-right pt-1 font-semibold">
                                  Client responded on {new Date(hist.clientActionAt).toLocaleDateString()} at {new Date(hist.clientActionAt).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                </div>
              </div>
            </div>,
            document.body
          )}

          {/* Signature Box Editor Modal */}
          <SignatureBoxEditor
            isOpen={step4EditorOpen}
            onClose={() => setStep4EditorOpen(false)}
            documentUrl={step4EditorDocUrl}
            existingBoxes={step4EditorBoxes}
            onSave={handleStep4SaveBoxes}
            isSaving={step4SavingBoxes}
          />

          {/* Move to History Confirmation Modal */}
          {showMoveToHistoryConfirm && (
            <div className="absolute inset-0 bg-black/50 flex items-center justify-center p-4 z-10">
              <div className="bg-white dark:bg-dark-800 rounded-xl p-6 max-w-md w-full shadow-2xl">
                <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                  <FaHistory className="text-purple-500" /> Confirm Move to History
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                  This action will:
                </p>
                <ul className="text-sm text-gray-600 dark:text-gray-400 mb-4 list-disc list-inside space-y-1">
                  <li>Save current tax filing cycle to history</li>
                  <li>Reset all steps for a new cycle</li>
                  <li>Lock the new cycle (user must pay to unlock)</li>
                  {newCycleTaxYearEndDate && <li>Set new Tax Year End: {formatDateForDisplay(newCycleTaxYearEndDate)}</li>}
                  {newCycleDueDate && <li>Set new Due Date: {formatDateForDisplay(newCycleDueDate)}</li>}
                </ul>
                <div className="flex gap-3">
                  <button onClick={() => { setShowMoveToHistoryConfirm(false); setMoveToHistoryMemberIndex(null); }} className="flex-1 px-4 py-2.5 bg-gray-200 dark:bg-dark-600 text-gray-700 dark:text-gray-300 font-medium rounded-xl hover:bg-gray-300 dark:hover:bg-dark-500">
                    Cancel
                  </button>
                  <button onClick={confirmMoveToHistory} className="flex-1 px-4 py-2.5 bg-purple-600 text-white font-medium rounded-xl hover:bg-purple-700 flex items-center justify-center gap-2">
                    <FaCheck /> Confirm
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Member Delete Confirmation Modal */}
          {memberToDeleteModal && (
            <div className="fixed inset-0 z-[9999999] bg-black/60 backdrop-blur-xs flex items-center justify-center p-4">
              <div className="bg-white dark:bg-dark-800 rounded-2xl p-6 max-w-md w-full shadow-2xl border border-gray-100 dark:border-dark-700 animate-in zoom-in-95 duration-200">
                <div className="w-12 h-12 rounded-2xl bg-red-100 dark:bg-red-950/40 text-red-600 dark:text-red-400 flex items-center justify-center mb-4">
                  <FaTrash size={20} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-1">
                  Delete Member
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
                  Are you sure you want to delete <span className="font-bold text-gray-900 dark:text-white">"{memberToDeleteModal.name}"</span>? This member and their associated form data will be safely backed up to the Recycle Bin.
                </p>
                <div className="flex items-center gap-3">
                  <button
                    type="button"
                    disabled={isDeletingMember}
                    onClick={() => setMemberToDeleteModal(null)}
                    className="flex-1 px-4 py-2.5 bg-gray-100 hover:bg-gray-200 dark:bg-dark-700 dark:hover:bg-dark-600 text-gray-700 dark:text-gray-300 text-sm font-semibold rounded-xl transition-all cursor-pointer"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    disabled={isDeletingMember}
                    onClick={async () => {
                      setIsDeletingMember(true);
                      try {
                        const data = await removeMember(selectedMenuUser._id, memberToDeleteModal.index);
                        if (data && data.user) {
                          setSelectedMenuUser(data.user);
                          if (!data.user.members || data.user.members.length === 0) {
                            setTaxFilingSubTab('primary-member');
                          } else if (memberToDeleteModal.index >= data.user.members.length) {
                            setActiveMemberIndex(Math.max(0, data.user.members.length - 1));
                          }
                        }
                        setMemberToDeleteModal(null);
                      } catch (err) {
                        console.error("Error deleting member:", err);
                      } finally {
                        setIsDeletingMember(false);
                      }
                    }}
                    className="flex-1 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-xl transition-all shadow-md shadow-red-600/20 cursor-pointer flex items-center justify-center gap-2"
                  >
                    {isDeletingMember ? (
                      <>
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                        <span>Deleting...</span>
                      </>
                    ) : (
                      <span>Delete Member</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Clear Tax Dates Confirmation Modal */}
          {clearDatesModal && (
            <div className="fixed inset-0 z-[9999999] bg-black/60 backdrop-blur-xs flex items-center justify-center p-4">
              <div className="bg-white dark:bg-dark-800 rounded-2xl p-6 max-w-md w-full shadow-2xl border border-gray-100 dark:border-dark-700 animate-in zoom-in-95 duration-200">
                <div className="w-12 h-12 rounded-2xl bg-amber-100 dark:bg-amber-950/40 text-amber-600 dark:text-amber-400 flex items-center justify-center mb-4">
                  <FaCalendarTimes size={22} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-1">
                  Remove Tax Dates?
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
                  Are you sure you want to remove the Tax Year End Date and Due Date for <span className="font-bold text-gray-900 dark:text-white">{clearDatesModal.type === 'primary' ? 'the Primary Member' : `"${selectedMenuUser.members?.[clearDatesModal.memberIndex]?.name || 'Member'}"`}</span>?
                </p>
                <div className="flex items-center gap-3">
                  <button
                    type="button"
                    disabled={isClearingDates}
                    onClick={() => setClearDatesModal(null)}
                    className="flex-1 px-4 py-2.5 bg-gray-100 hover:bg-gray-200 dark:bg-dark-700 dark:hover:bg-dark-600 text-gray-700 dark:text-gray-300 text-sm font-semibold rounded-xl transition-all cursor-pointer"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    disabled={isClearingDates}
                    onClick={async () => {
                      setIsClearingDates(true);
                      try {
                        if (clearDatesModal.type === 'primary') {
                          await handleTaxDateUpdate(selectedMenuUser._id, null, null, true);
                          setPrimaryTaxYearEndDate("");
                          setPrimaryDueDate("");
                        } else {
                          const mIdx = clearDatesModal.memberIndex;
                          await handleMemberTaxDateUpdate(selectedMenuUser._id, mIdx, null, null, true);
                          setMemberTaxYearEndDates(prev => ({ ...prev, [mIdx]: "" }));
                          setMemberDueDates(prev => ({ ...prev, [mIdx]: "" }));
                        }
                        setClearDatesModal(null);
                      } catch (err) {
                        console.error("Error clearing tax dates:", err);
                      } finally {
                        setIsClearingDates(false);
                      }
                    }}
                    className="flex-1 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-xl transition-all shadow-md shadow-red-600/20 cursor-pointer flex items-center justify-center gap-2"
                  >
                    {isClearingDates ? (
                      <>
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                        <span>Clearing...</span>
                      </>
                    ) : (
                      <span>Remove Dates</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>,
    document.body
  );
};

export default ClientMenuModal;
